// const fontDimensions = {
//   'MoonTime.ttf': {
//     '0': { height: 100, width: 50, ratio: 0.5 },
//     '1': { height: 100, width: 50, ratio: 0.5 },
//     '2': { height: 100, width: 50, ratio: 0.5 },
//     '3': { height: 100, width: 50, ratio: 0.5 },
//     '4': { height: 100, width: 50, ratio: 0.5 },
//     '5': { height: 100, width: 50, ratio: 0.5 },
//     '6': { height: 100, width: 50, ratio: 0.5 },
//     '7': { height: 100, width: 50, ratio: 0.5 },
//     '8': { height: 100, width: 50, ratio: 0.5 },
//     '9': { height: 100, width: 50, ratio: 0.5 },
//     '§': { height: 100, width: 50, ratio: 0.5 },
//     "'": { height: 100, width: 18.0234375, ratio: 0.180234375 },
//     '"': { height: 100, width: 40.8203125, ratio: 0.408203125 },
//     '+': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '!': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '%': { height: 100, width: 83.3046875, ratio: 0.833046875 },
//     '/': { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '=': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '(': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ')': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ö: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ü: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ó: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ú: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ő: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     P: { height: 100, width: 55.6171875, ratio: 0.556171875 },
//     O: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     I: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     U: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Z: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     T: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     R: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     E: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     W: { height: 100, width: 94.390625, ratio: 0.94390625 },
//     Q: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     A: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     S: { height: 100, width: 55.6171875, ratio: 0.556171875 },
//     D: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     F: { height: 100, width: 55.6171875, ratio: 0.556171875 },
//     G: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     H: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     J: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     K: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     L: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     É: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Á: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ű: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     _: { height: 100, width: 50, ratio: 0.5 },
//     ':': { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '?': { height: 100, width: 44.390625, ratio: 0.44390625 },
//     M: { height: 100, width: 88.921875, ratio: 0.88921875 },
//     N: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     B: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     V: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     C: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     X: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Y: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Í: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ö: { height: 100, width: 50, ratio: 0.5 },
//     ü: { height: 100, width: 50, ratio: 0.5 },
//     ó: { height: 100, width: 50, ratio: 0.5 },
//     ú: { height: 100, width: 50, ratio: 0.5 },
//     ő: { height: 100, width: 50, ratio: 0.5 },
//     p: { height: 100, width: 50, ratio: 0.5 },
//     o: { height: 100, width: 50, ratio: 0.5 },
//     i: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     u: { height: 100, width: 50, ratio: 0.5 },
//     z: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     t: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     r: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     e: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     w: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     q: { height: 100, width: 50, ratio: 0.5 },
//     a: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     s: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     d: { height: 100, width: 50, ratio: 0.5 },
//     f: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     g: { height: 100, width: 50, ratio: 0.5 },
//     h: { height: 100, width: 50, ratio: 0.5 },
//     j: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     k: { height: 100, width: 50, ratio: 0.5 },
//     l: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     é: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     á: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ű: { height: 100, width: 50, ratio: 0.5 },
//     '-': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '.': { height: 100, width: 25, ratio: 0.25 },
//     ',': { height: 100, width: 25, ratio: 0.25 },
//     m: { height: 100, width: 77.7890625, ratio: 0.777890625 },
//     n: { height: 100, width: 50, ratio: 0.5 },
//     b: { height: 100, width: 50, ratio: 0.5 },
//     v: { height: 100, width: 50, ratio: 0.5 },
//     c: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     x: { height: 100, width: 50, ratio: 0.5 },
//     y: { height: 100, width: 50, ratio: 0.5 },
//     í: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '¬': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '&': { height: 100, width: 77.7890625, ratio: 0.777890625 },
//     '™': { height: 100, width: 98, ratio: 0.98 },
//     '£': { height: 100, width: 50, ratio: 0.5 },
//     $: { height: 100, width: 50, ratio: 0.5 },
//     '‹': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '›': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '{': { height: 100, width: 48, ratio: 0.48 },
//     '[': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ']': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '}': { height: 100, width: 48, ratio: 0.48 },
//     '≠': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     '~': { height: 100, width: 54.1015625, ratio: 0.541015625 },
//     '¨': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ļ: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ņ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '^': { height: 100, width: 46.9296875, ratio: 0.469296875 },
//     ź: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '†': { height: 100, width: 50, ratio: 0.5 },
//     '¶': { height: 100, width: 45.3125, ratio: 0.453125 },
//     '€': { height: 100, width: 74.4140625, ratio: 0.744140625 },
//     ę: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '@': { height: 100, width: 92.09375, ratio: 0.9209375 },
//     ą: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ß: { height: 100, width: 50, ratio: 0.5 },
//     '∂': { height: 100, width: 49.4140625, ratio: 0.494140625 },
//     ń: { height: 100, width: 50, ratio: 0.5 },
//     '©': { height: 100, width: 75.9765625, ratio: 0.759765625 },
//     ķ: { height: 100, width: 50, ratio: 0.5 },
//     '∆': { height: 100, width: 61.1875, ratio: 0.611875 },
//     Ż: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     '•': { height: 100, width: 35.015625, ratio: 0.35015625 },
//     '…': { height: 100, width: 100, ratio: 1 },
//     '–': { height: 100, width: 50, ratio: 0.5 },
//     ';': { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ķ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '”': { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '„': { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ć: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '»': { height: 100, width: 50, ratio: 0.5 },
//     '«': { height: 100, width: 50, ratio: 0.5 },
//     '|': { height: 100, width: 20.0234375, ratio: 0.200234375 },
//     ŕ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ř: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '#': { height: 100, width: 50, ratio: 0.5 },
//     ř: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ŗ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     ŗ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '°': { height: 100, width: 39.9921875, ratio: 0.399921875 },
//     ī: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ī: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ý: { height: 100, width: 50, ratio: 0.5 },
//     Ý: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     ł: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ź: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ś: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     '®': { height: 100, width: 75.9765625, ratio: 0.759765625 },
//     š: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     Ł: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ļ: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '*': { height: 100, width: 50, ratio: 0.5 },
//     ' ': { height: 0, width: 0, ratio: null },
//     ż: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     Ž: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ū: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '—': { height: 100, width: 100, ratio: 1 },
//     '÷': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     ų: { height: 100, width: 50, ratio: 0.5 },
//     Ų: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '’': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '‚': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '>': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '<': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     Ŕ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '&nbsp;': { height: 100, width: 25, ratio: 0.25 },
//   },
//   'Plaything.ttf': {
//     '0': { height: 100, width: 78.125, ratio: 0.78125 },
//     '1': { height: 100, width: 29.296875, ratio: 0.29296875 },
//     '2': { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     '3': { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     '4': { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     '5': { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     '6': { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     '7': { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     '8': { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     '9': { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     '§': { height: 100, width: 50, ratio: 0.5 },
//     "'": { height: 100, width: 19.53125, ratio: 0.1953125 },
//     '"': { height: 100, width: 34.1796875, ratio: 0.341796875 },
//     '+': { height: 100, width: 48.828125, ratio: 0.48828125 },
//     '!': { height: 100, width: 19.53125, ratio: 0.1953125 },
//     '%': { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     '/': { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     '=': { height: 100, width: 48.828125, ratio: 0.48828125 },
//     '(': { height: 100, width: 43.9453125, ratio: 0.439453125 },
//     ')': { height: 100, width: 43.9453125, ratio: 0.439453125 },
//     Ö: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ü: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ó: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ú: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ő: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     P: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     O: { height: 100, width: 78.125, ratio: 0.78125 },
//     I: { height: 100, width: 19.53125, ratio: 0.1953125 },
//     U: { height: 100, width: 78.125, ratio: 0.78125 },
//     Z: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     T: { height: 100, width: 68.359375, ratio: 0.68359375 },
//     R: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     E: { height: 100, width: 68.359375, ratio: 0.68359375 },
//     W: { height: 100, width: 102.5390625, ratio: 1.025390625 },
//     Q: { height: 100, width: 78.125, ratio: 0.78125 },
//     A: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     S: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     D: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     F: { height: 100, width: 68.359375, ratio: 0.68359375 },
//     G: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     H: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     J: { height: 100, width: 78.125, ratio: 0.78125 },
//     K: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     L: { height: 100, width: 68.359375, ratio: 0.68359375 },
//     É: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Á: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ű: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     _: { height: 100, width: 68.359375, ratio: 0.68359375 },
//     ':': { height: 100, width: 19.53125, ratio: 0.1953125 },
//     '?': { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     M: { height: 100, width: 78.125, ratio: 0.78125 },
//     N: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     B: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     V: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     C: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     X: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     Y: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     Í: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ö: { height: 100, width: 50, ratio: 0.5 },
//     ü: { height: 100, width: 50, ratio: 0.5 },
//     ó: { height: 100, width: 50, ratio: 0.5 },
//     ú: { height: 100, width: 50, ratio: 0.5 },
//     ő: { height: 100, width: 50, ratio: 0.5 },
//     p: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     o: { height: 100, width: 78.125, ratio: 0.78125 },
//     i: { height: 100, width: 19.53125, ratio: 0.1953125 },
//     u: { height: 100, width: 78.125, ratio: 0.78125 },
//     z: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     t: { height: 100, width: 68.359375, ratio: 0.68359375 },
//     r: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     e: { height: 100, width: 68.359375, ratio: 0.68359375 },
//     w: { height: 100, width: 102.5390625, ratio: 1.025390625 },
//     q: { height: 100, width: 78.125, ratio: 0.78125 },
//     a: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     s: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     d: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     f: { height: 100, width: 68.359375, ratio: 0.68359375 },
//     g: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     h: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     j: { height: 100, width: 78.125, ratio: 0.78125 },
//     k: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     l: { height: 100, width: 68.359375, ratio: 0.68359375 },
//     é: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     á: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ű: { height: 100, width: 50, ratio: 0.5 },
//     '-': { height: 100, width: 48.828125, ratio: 0.48828125 },
//     '.': { height: 100, width: 19.53125, ratio: 0.1953125 },
//     ',': { height: 100, width: 19.53125, ratio: 0.1953125 },
//     m: { height: 100, width: 78.125, ratio: 0.78125 },
//     n: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     b: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     v: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     c: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     x: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     y: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     í: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '¬': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '&': { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     '™': { height: 100, width: 98, ratio: 0.98 },
//     '£': { height: 100, width: 50, ratio: 0.5 },
//     $: { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     '‹': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '›': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '{': { height: 100, width: 39.0625, ratio: 0.390625 },
//     '[': { height: 100, width: 34.1796875, ratio: 0.341796875 },
//     ']': { height: 100, width: 34.1796875, ratio: 0.341796875 },
//     '}': { height: 100, width: 39.0625, ratio: 0.390625 },
//     '≠': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     '~': { height: 100, width: 48.828125, ratio: 0.48828125 },
//     '¨': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ļ: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ņ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '^': { height: 100, width: 19.53125, ratio: 0.1953125 },
//     ź: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '†': { height: 100, width: 50, ratio: 0.5 },
//     '¶': { height: 100, width: 45.3125, ratio: 0.453125 },
//     '€': { height: 100, width: 74.4140625, ratio: 0.744140625 },
//     ę: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '@': { height: 100, width: 78.125, ratio: 0.78125 },
//     ą: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ß: { height: 100, width: 50, ratio: 0.5 },
//     '∂': { height: 100, width: 49.4140625, ratio: 0.494140625 },
//     ń: { height: 100, width: 50, ratio: 0.5 },
//     '©': { height: 100, width: 75.9765625, ratio: 0.759765625 },
//     ķ: { height: 100, width: 50, ratio: 0.5 },
//     '∆': { height: 100, width: 61.1875, ratio: 0.611875 },
//     Ż: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     '•': { height: 100, width: 35.015625, ratio: 0.35015625 },
//     '…': { height: 100, width: 100, ratio: 1 },
//     '–': { height: 100, width: 50, ratio: 0.5 },
//     ';': { height: 100, width: 19.53125, ratio: 0.1953125 },
//     Ķ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '”': { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '„': { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ć: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '»': { height: 100, width: 50, ratio: 0.5 },
//     '«': { height: 100, width: 50, ratio: 0.5 },
//     '|': { height: 100, width: 19.53125, ratio: 0.1953125 },
//     ŕ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ř: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '#': { height: 100, width: 73.2421875, ratio: 0.732421875 },
//     ř: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ŗ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     ŗ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '°': { height: 100, width: 39.9921875, ratio: 0.399921875 },
//     ī: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ī: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ý: { height: 100, width: 50, ratio: 0.5 },
//     Ý: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     ł: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ź: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ś: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     '®': { height: 100, width: 75.9765625, ratio: 0.759765625 },
//     š: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     Ł: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ļ: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '*': { height: 100, width: 48.828125, ratio: 0.48828125 },
//     ' ': { height: 0, width: 0, ratio: null },
//     ż: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     Ž: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ū: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '—': { height: 100, width: 100, ratio: 1 },
//     '÷': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     ų: { height: 100, width: 50, ratio: 0.5 },
//     Ų: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '’': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '‚': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '>': { height: 100, width: 43.9453125, ratio: 0.439453125 },
//     '<': { height: 100, width: 43.9453125, ratio: 0.439453125 },
//     Ŕ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '&nbsp;': { height: 100, width: 24.8046875, ratio: 0.248046875 },
//   },
//   'Bestie.ttf': {
//     '0': { height: 100, width: 53.5, ratio: 0.535 },
//     '1': { height: 100, width: 43.8046875, ratio: 0.438046875 },
//     '2': { height: 100, width: 54.6015625, ratio: 0.546015625 },
//     '3': { height: 100, width: 46.40625, ratio: 0.4640625 },
//     '4': { height: 100, width: 57, ratio: 0.57 },
//     '5': { height: 100, width: 47.6015625, ratio: 0.476015625 },
//     '6': { height: 100, width: 50.40625, ratio: 0.5040625 },
//     '7': { height: 100, width: 37.1015625, ratio: 0.371015625 },
//     '8': { height: 100, width: 48.203125, ratio: 0.48203125 },
//     '9': { height: 100, width: 45.5, ratio: 0.455 },
//     '§': { height: 100, width: 50, ratio: 0.5 },
//     "'": { height: 100, width: 20, ratio: 0.2 },
//     '"': { height: 100, width: 31.40625, ratio: 0.3140625 },
//     '+': { height: 100, width: 48.703125, ratio: 0.48703125 },
//     '!': { height: 100, width: 36.703125, ratio: 0.36703125 },
//     '%': { height: 100, width: 64.5, ratio: 0.645 },
//     '/': { height: 100, width: 40.3046875, ratio: 0.403046875 },
//     '=': { height: 100, width: 45.90625, ratio: 0.4590625 },
//     '(': { height: 100, width: 30, ratio: 0.3 },
//     ')': { height: 100, width: 40.203125, ratio: 0.40203125 },
//     Ö: { height: 100, width: 69, ratio: 0.69 },
//     Ü: { height: 100, width: 63.703125, ratio: 0.63703125 },
//     Ó: { height: 100, width: 69, ratio: 0.69 },
//     Ú: { height: 100, width: 63.703125, ratio: 0.63703125 },
//     Ő: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     P: { height: 100, width: 51.8046875, ratio: 0.518046875 },
//     O: { height: 100, width: 69, ratio: 0.69 },
//     I: { height: 100, width: 52.203125, ratio: 0.52203125 },
//     U: { height: 100, width: 63.703125, ratio: 0.63703125 },
//     Z: { height: 100, width: 50.40625, ratio: 0.5040625 },
//     T: { height: 100, width: 37.6015625, ratio: 0.376015625 },
//     R: { height: 100, width: 64.6015625, ratio: 0.646015625 },
//     E: { height: 100, width: 69.40625, ratio: 0.6940625 },
//     W: { height: 100, width: 79.5, ratio: 0.795 },
//     Q: { height: 100, width: 72.40625, ratio: 0.7240625 },
//     A: { height: 100, width: 77.1015625, ratio: 0.771015625 },
//     S: { height: 100, width: 65.3046875, ratio: 0.653046875 },
//     D: { height: 100, width: 65.703125, ratio: 0.65703125 },
//     F: { height: 100, width: 46.90625, ratio: 0.4690625 },
//     G: { height: 100, width: 59.3046875, ratio: 0.593046875 },
//     H: { height: 100, width: 66, ratio: 0.66 },
//     J: { height: 100, width: 49.1015625, ratio: 0.491015625 },
//     K: { height: 100, width: 59.703125, ratio: 0.59703125 },
//     L: { height: 100, width: 63.40625, ratio: 0.6340625 },
//     É: { height: 100, width: 69.40625, ratio: 0.6940625 },
//     Á: { height: 100, width: 77.1015625, ratio: 0.771015625 },
//     Ű: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     _: { height: 100, width: 51.40625, ratio: 0.5140625 },
//     ':': { height: 100, width: 25.3046875, ratio: 0.253046875 },
//     '?': { height: 100, width: 41, ratio: 0.41 },
//     M: { height: 100, width: 69.8046875, ratio: 0.698046875 },
//     N: { height: 100, width: 60.3046875, ratio: 0.603046875 },
//     B: { height: 100, width: 60.1015625, ratio: 0.601015625 },
//     V: { height: 100, width: 50.703125, ratio: 0.50703125 },
//     C: { height: 100, width: 65.1015625, ratio: 0.651015625 },
//     X: { height: 100, width: 60.1015625, ratio: 0.601015625 },
//     Y: { height: 100, width: 66.8046875, ratio: 0.668046875 },
//     Í: { height: 100, width: 52.203125, ratio: 0.52203125 },
//     ö: { height: 100, width: 36.1015625, ratio: 0.361015625 },
//     ü: { height: 100, width: 45.8046875, ratio: 0.458046875 },
//     ó: { height: 100, width: 36.203125, ratio: 0.36203125 },
//     ú: { height: 100, width: 46, ratio: 0.46 },
//     ő: { height: 100, width: 50, ratio: 0.5 },
//     p: { height: 100, width: 39.703125, ratio: 0.39703125 },
//     o: { height: 100, width: 36.203125, ratio: 0.36203125 },
//     i: { height: 100, width: 22, ratio: 0.22 },
//     u: { height: 100, width: 46, ratio: 0.46 },
//     z: { height: 100, width: 42.703125, ratio: 0.42703125 },
//     t: { height: 100, width: 24.6015625, ratio: 0.246015625 },
//     r: { height: 100, width: 39.703125, ratio: 0.39703125 },
//     e: { height: 100, width: 33.703125, ratio: 0.33703125 },
//     w: { height: 100, width: 48.6015625, ratio: 0.486015625 },
//     q: { height: 100, width: 43.703125, ratio: 0.43703125 },
//     a: { height: 100, width: 37.6015625, ratio: 0.376015625 },
//     s: { height: 100, width: 35, ratio: 0.35 },
//     d: { height: 100, width: 41.3046875, ratio: 0.413046875 },
//     f: { height: 100, width: 29.703125, ratio: 0.29703125 },
//     g: { height: 100, width: 39.703125, ratio: 0.39703125 },
//     h: { height: 100, width: 44.40625, ratio: 0.4440625 },
//     j: { height: 100, width: 19.3046875, ratio: 0.193046875 },
//     k: { height: 100, width: 43.3046875, ratio: 0.433046875 },
//     l: { height: 100, width: 30.6015625, ratio: 0.306015625 },
//     é: { height: 100, width: 33.703125, ratio: 0.33703125 },
//     á: { height: 100, width: 37.6015625, ratio: 0.376015625 },
//     ű: { height: 100, width: 50, ratio: 0.5 },
//     '-': { height: 100, width: 42.8046875, ratio: 0.428046875 },
//     '.': { height: 100, width: 18.6015625, ratio: 0.186015625 },
//     ',': { height: 100, width: 17.3046875, ratio: 0.173046875 },
//     m: { height: 100, width: 63.6015625, ratio: 0.636015625 },
//     n: { height: 100, width: 42.703125, ratio: 0.42703125 },
//     b: { height: 100, width: 37.6015625, ratio: 0.376015625 },
//     v: { height: 100, width: 38, ratio: 0.38 },
//     c: { height: 100, width: 36.3046875, ratio: 0.363046875 },
//     x: { height: 100, width: 35.703125, ratio: 0.35703125 },
//     y: { height: 100, width: 42.6015625, ratio: 0.426015625 },
//     í: { height: 100, width: 22, ratio: 0.22 },
//     '¬': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '&': { height: 100, width: 61.5, ratio: 0.615 },
//     '™': { height: 100, width: 98, ratio: 0.98 },
//     '£': { height: 100, width: 67.703125, ratio: 0.67703125 },
//     $: { height: 100, width: 50, ratio: 0.5 },
//     '‹': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '›': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '{': { height: 100, width: 35.203125, ratio: 0.35203125 },
//     '[': { height: 100, width: 45, ratio: 0.45 },
//     ']': { height: 100, width: 47.40625, ratio: 0.4740625 },
//     '}': { height: 100, width: 56.703125, ratio: 0.56703125 },
//     '≠': { height: 100, width: 45.90625, ratio: 0.4590625 },
//     '~': { height: 100, width: 46.3046875, ratio: 0.463046875 },
//     '¨': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ļ: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ņ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '^': { height: 100, width: 41.1015625, ratio: 0.411015625 },
//     ź: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '†': { height: 100, width: 50, ratio: 0.5 },
//     '¶': { height: 100, width: 45.3125, ratio: 0.453125 },
//     '€': { height: 100, width: 63.203125, ratio: 0.63203125 },
//     ę: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '@': { height: 100, width: 79.5, ratio: 0.795 },
//     ą: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ß: { height: 100, width: 53.703125, ratio: 0.53703125 },
//     '∂': { height: 100, width: 49.4140625, ratio: 0.494140625 },
//     ń: { height: 100, width: 50, ratio: 0.5 },
//     '©': { height: 100, width: 74.703125, ratio: 0.74703125 },
//     ķ: { height: 100, width: 50, ratio: 0.5 },
//     '∆': { height: 100, width: 61.1875, ratio: 0.611875 },
//     Ż: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     '•': { height: 100, width: 35.015625, ratio: 0.35015625 },
//     '…': { height: 100, width: 100, ratio: 1 },
//     '–': { height: 100, width: 50, ratio: 0.5 },
//     ';': { height: 100, width: 35.40625, ratio: 0.3540625 },
//     Ķ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '”': { height: 100, width: 31.40625, ratio: 0.3140625 },
//     '„': { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ć: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '»': { height: 100, width: 50, ratio: 0.5 },
//     '«': { height: 100, width: 50, ratio: 0.5 },
//     '|': { height: 100, width: 31.5, ratio: 0.315 },
//     ŕ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ř: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '#': { height: 100, width: 67.1015625, ratio: 0.671015625 },
//     ř: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ŗ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     ŗ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '°': { height: 100, width: 39.9921875, ratio: 0.399921875 },
//     ī: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ī: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ý: { height: 100, width: 42.6015625, ratio: 0.426015625 },
//     Ý: { height: 100, width: 66.8046875, ratio: 0.668046875 },
//     ł: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ź: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ś: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     '®': { height: 100, width: 75.9765625, ratio: 0.759765625 },
//     š: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     Ł: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ļ: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '*': { height: 100, width: 35.703125, ratio: 0.35703125 },
//     ' ': { height: 0, width: 0, ratio: null },
//     ż: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     Ž: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ū: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '—': { height: 100, width: 100, ratio: 1 },
//     '÷': { height: 100, width: 42.8046875, ratio: 0.428046875 },
//     ų: { height: 100, width: 50, ratio: 0.5 },
//     Ų: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '’': { height: 100, width: 20, ratio: 0.2 },
//     '‚': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '>': { height: 100, width: 47.5, ratio: 0.475 },
//     '<': { height: 100, width: 47.5, ratio: 0.475 },
//     Ŕ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '&nbsp;': { height: 100, width: 30.90625, ratio: 0.3090625 },
//   },
//   'BFF.ttf': {
//     '0': { height: 100, width: 62.5, ratio: 0.625 },
//     '1': { height: 100, width: 24.40625, ratio: 0.2440625 },
//     '2': { height: 100, width: 52.90625, ratio: 0.5290625 },
//     '3': { height: 100, width: 53.1015625, ratio: 0.531015625 },
//     '4': { height: 100, width: 57.6015625, ratio: 0.576015625 },
//     '5': { height: 100, width: 55.3046875, ratio: 0.553046875 },
//     '6': { height: 100, width: 53.5, ratio: 0.535 },
//     '7': { height: 100, width: 49.1015625, ratio: 0.491015625 },
//     '8': { height: 100, width: 54.5, ratio: 0.545 },
//     '9': { height: 100, width: 53.5, ratio: 0.535 },
//     '§': { height: 100, width: 66.3046875, ratio: 0.663046875 },
//     "'": { height: 100, width: 19.703125, ratio: 0.19703125 },
//     '"': { height: 100, width: 33.40625, ratio: 0.3340625 },
//     '+': { height: 100, width: 53, ratio: 0.53 },
//     '!': { height: 100, width: 23.5, ratio: 0.235 },
//     '%': { height: 100, width: 69.703125, ratio: 0.69703125 },
//     '/': { height: 100, width: 55.8046875, ratio: 0.558046875 },
//     '=': { height: 100, width: 53, ratio: 0.53 },
//     '(': { height: 100, width: 26.40625, ratio: 0.2640625 },
//     ')': { height: 100, width: 26.40625, ratio: 0.2640625 },
//     Ö: { height: 100, width: 79, ratio: 0.79 },
//     Ü: { height: 100, width: 66.5, ratio: 0.665 },
//     Ó: { height: 100, width: 79, ratio: 0.79 },
//     Ú: { height: 100, width: 66.5, ratio: 0.665 },
//     Ő: { height: 100, width: 79, ratio: 0.79 },
//     P: { height: 100, width: 57.3046875, ratio: 0.573046875 },
//     O: { height: 100, width: 79, ratio: 0.79 },
//     I: { height: 100, width: 24.5, ratio: 0.245 },
//     U: { height: 100, width: 66.5, ratio: 0.665 },
//     Z: { height: 100, width: 56.1015625, ratio: 0.561015625 },
//     T: { height: 100, width: 53, ratio: 0.53 },
//     R: { height: 100, width: 60.90625, ratio: 0.6090625 },
//     E: { height: 100, width: 53, ratio: 0.53 },
//     W: { height: 100, width: 96, ratio: 0.96 },
//     Q: { height: 100, width: 79, ratio: 0.79 },
//     A: { height: 100, width: 63.6015625, ratio: 0.636015625 },
//     S: { height: 100, width: 56.3046875, ratio: 0.563046875 },
//     D: { height: 100, width: 70.203125, ratio: 0.70203125 },
//     F: { height: 100, width: 51, ratio: 0.51 },
//     G: { height: 100, width: 79, ratio: 0.79 },
//     H: { height: 100, width: 67, ratio: 0.67 },
//     J: { height: 100, width: 55.90625, ratio: 0.5590625 },
//     K: { height: 100, width: 57.703125, ratio: 0.57703125 },
//     L: { height: 100, width: 49, ratio: 0.49 },
//     É: { height: 100, width: 53, ratio: 0.53 },
//     Á: { height: 100, width: 63.6015625, ratio: 0.636015625 },
//     Ű: { height: 100, width: 66.5, ratio: 0.665 },
//     _: { height: 100, width: 49, ratio: 0.49 },
//     ':': { height: 100, width: 23.5, ratio: 0.235 },
//     '?': { height: 100, width: 54.40625, ratio: 0.5440625 },
//     M: { height: 100, width: 81.5, ratio: 0.815 },
//     N: { height: 100, width: 69.5, ratio: 0.695 },
//     B: { height: 100, width: 61.203125, ratio: 0.61203125 },
//     V: { height: 100, width: 60.203125, ratio: 0.60203125 },
//     C: { height: 100, width: 69.40625, ratio: 0.6940625 },
//     X: { height: 100, width: 58.6015625, ratio: 0.586015625 },
//     Y: { height: 100, width: 58.6015625, ratio: 0.586015625 },
//     Í: { height: 100, width: 24.5, ratio: 0.245 },
//     ö: { height: 100, width: 57.203125, ratio: 0.57203125 },
//     ü: { height: 100, width: 54.3046875, ratio: 0.543046875 },
//     ó: { height: 100, width: 57.203125, ratio: 0.57203125 },
//     ú: { height: 100, width: 54.3046875, ratio: 0.543046875 },
//     ő: { height: 100, width: 57.203125, ratio: 0.57203125 },
//     p: { height: 100, width: 57.3046875, ratio: 0.573046875 },
//     o: { height: 100, width: 79, ratio: 0.79 },
//     i: { height: 100, width: 24.5, ratio: 0.245 },
//     u: { height: 100, width: 66.5, ratio: 0.665 },
//     z: { height: 100, width: 56.1015625, ratio: 0.561015625 },
//     t: { height: 100, width: 53, ratio: 0.53 },
//     r: { height: 100, width: 60.90625, ratio: 0.6090625 },
//     e: { height: 100, width: 53, ratio: 0.53 },
//     w: { height: 100, width: 96, ratio: 0.96 },
//     q: { height: 100, width: 79, ratio: 0.79 },
//     a: { height: 100, width: 63.6015625, ratio: 0.636015625 },
//     s: { height: 100, width: 56.3046875, ratio: 0.563046875 },
//     d: { height: 100, width: 70.203125, ratio: 0.70203125 },
//     f: { height: 100, width: 51, ratio: 0.51 },
//     g: { height: 100, width: 79, ratio: 0.79 },
//     h: { height: 100, width: 67, ratio: 0.67 },
//     j: { height: 100, width: 55.90625, ratio: 0.5590625 },
//     k: { height: 100, width: 57.703125, ratio: 0.57703125 },
//     l: { height: 100, width: 49, ratio: 0.49 },
//     é: { height: 100, width: 55.703125, ratio: 0.55703125 },
//     á: { height: 100, width: 60.203125, ratio: 0.60203125 },
//     ű: { height: 100, width: 54.3046875, ratio: 0.543046875 },
//     '-': { height: 100, width: 54, ratio: 0.54 },
//     '.': { height: 100, width: 23.5, ratio: 0.235 },
//     ',': { height: 100, width: 23, ratio: 0.23 },
//     m: { height: 100, width: 81.5, ratio: 0.815 },
//     n: { height: 100, width: 69.5, ratio: 0.695 },
//     b: { height: 100, width: 61.203125, ratio: 0.61203125 },
//     v: { height: 100, width: 60.203125, ratio: 0.60203125 },
//     c: { height: 100, width: 69.40625, ratio: 0.6940625 },
//     x: { height: 100, width: 58.6015625, ratio: 0.586015625 },
//     y: { height: 100, width: 58.6015625, ratio: 0.586015625 },
//     í: { height: 100, width: 21.703125, ratio: 0.21703125 },
//     '¬': { height: 100, width: 51.8046875, ratio: 0.518046875 },
//     '&': { height: 100, width: 66.203125, ratio: 0.66203125 },
//     '™': { height: 100, width: 50.40625, ratio: 0.5040625 },
//     '£': { height: 100, width: 57.5, ratio: 0.575 },
//     $: { height: 100, width: 56.3046875, ratio: 0.563046875 },
//     '‹': { height: 100, width: 32.3046875, ratio: 0.323046875 },
//     '›': { height: 100, width: 32.3046875, ratio: 0.323046875 },
//     '{': { height: 100, width: 35, ratio: 0.35 },
//     '[': { height: 100, width: 28, ratio: 0.28 },
//     ']': { height: 100, width: 28, ratio: 0.28 },
//     '}': { height: 100, width: 35, ratio: 0.35 },
//     '≠': { height: 100, width: 53, ratio: 0.53 },
//     '~': { height: 100, width: 59.90625, ratio: 0.5990625 },
//     '¨': { height: 100, width: 38, ratio: 0.38 },
//     Ļ: { height: 100, width: 49, ratio: 0.49 },
//     Ņ: { height: 100, width: 69.5, ratio: 0.695 },
//     '^': { height: 100, width: 49.8046875, ratio: 0.498046875 },
//     ź: { height: 100, width: 49, ratio: 0.49 },
//     '†': { height: 100, width: 48, ratio: 0.48 },
//     '¶': { height: 100, width: 59.8046875, ratio: 0.598046875 },
//     '€': { height: 100, width: 55.90625, ratio: 0.5590625 },
//     ę: { height: 100, width: 55.703125, ratio: 0.55703125 },
//     '@': { height: 100, width: 79, ratio: 0.79 },
//     ą: { height: 100, width: 60.203125, ratio: 0.60203125 },
//     ß: { height: 100, width: 61.3046875, ratio: 0.613046875 },
//     '∂': { height: 100, width: 49.4140625, ratio: 0.494140625 },
//     ń: { height: 100, width: 54.3046875, ratio: 0.543046875 },
//     '©': { height: 100, width: 81.5, ratio: 0.815 },
//     ķ: { height: 100, width: 45.703125, ratio: 0.45703125 },
//     '∆': { height: 100, width: 61.1875, ratio: 0.611875 },
//     Ż: { height: 100, width: 56.1015625, ratio: 0.561015625 },
//     '•': { height: 100, width: 32, ratio: 0.32 },
//     '…': { height: 100, width: 70.5, ratio: 0.705 },
//     '–': { height: 100, width: 67, ratio: 0.67 },
//     ';': { height: 100, width: 23.5, ratio: 0.235 },
//     Ķ: { height: 100, width: 57.703125, ratio: 0.57703125 },
//     '”': { height: 100, width: 35, ratio: 0.35 },
//     '„': { height: 100, width: 35, ratio: 0.35 },
//     ć: { height: 100, width: 49.703125, ratio: 0.49703125 },
//     '»': { height: 100, width: 46.3046875, ratio: 0.463046875 },
//     '«': { height: 100, width: 46.3046875, ratio: 0.463046875 },
//     '|': { height: 100, width: 23.703125, ratio: 0.23703125 },
//     ŕ: { height: 100, width: 31.703125, ratio: 0.31703125 },
//     Ř: { height: 100, width: 60.90625, ratio: 0.6090625 },
//     '#': { height: 100, width: 60.5, ratio: 0.605 },
//     ř: { height: 100, width: 31.703125, ratio: 0.31703125 },
//     Ŗ: { height: 100, width: 60.90625, ratio: 0.6090625 },
//     ŗ: { height: 100, width: 31.703125, ratio: 0.31703125 },
//     '°': { height: 100, width: 40.703125, ratio: 0.40703125 },
//     ī: { height: 100, width: 21.703125, ratio: 0.21703125 },
//     Ī: { height: 100, width: 24.5, ratio: 0.245 },
//     ý: { height: 100, width: 48.8046875, ratio: 0.488046875 },
//     Ý: { height: 100, width: 58.6015625, ratio: 0.586015625 },
//     ł: { height: 100, width: 21.6015625, ratio: 0.216015625 },
//     Ź: { height: 100, width: 56.1015625, ratio: 0.561015625 },
//     ś: { height: 100, width: 43, ratio: 0.43 },
//     '®': { height: 100, width: 81.5, ratio: 0.815 },
//     š: { height: 100, width: 43, ratio: 0.43 },
//     Ł: { height: 100, width: 49, ratio: 0.49 },
//     ļ: { height: 100, width: 21.703125, ratio: 0.21703125 },
//     '*': { height: 100, width: 44.703125, ratio: 0.44703125 },
//     ' ': { height: 0, width: 0, ratio: null },
//     ż: { height: 100, width: 49, ratio: 0.49 },
//     Ž: { height: 100, width: 56.1015625, ratio: 0.561015625 },
//     Ū: { height: 100, width: 66.5, ratio: 0.665 },
//     '—': { height: 100, width: 80, ratio: 0.8 },
//     '÷': { height: 100, width: 58, ratio: 0.58 },
//     ų: { height: 100, width: 54.3046875, ratio: 0.543046875 },
//     Ų: { height: 100, width: 66.5, ratio: 0.665 },
//     '’': { height: 100, width: 23, ratio: 0.23 },
//     '‚': { height: 100, width: 23, ratio: 0.23 },
//     '>': { height: 100, width: 52, ratio: 0.52 },
//     '<': { height: 100, width: 55.8046875, ratio: 0.558046875 },
//     Ŕ: { height: 100, width: 60.90625, ratio: 0.6090625 },
//     '&nbsp;': { height: 100, width: 27, ratio: 0.27 },
//   },
//   'Clickbait.ttf': {
//     '0': { height: 100, width: 50, ratio: 0.5 },
//     '1': { height: 100, width: 50, ratio: 0.5 },
//     '2': { height: 100, width: 50, ratio: 0.5 },
//     '3': { height: 100, width: 50, ratio: 0.5 },
//     '4': { height: 100, width: 50, ratio: 0.5 },
//     '5': { height: 100, width: 50, ratio: 0.5 },
//     '6': { height: 100, width: 50, ratio: 0.5 },
//     '7': { height: 100, width: 50, ratio: 0.5 },
//     '8': { height: 100, width: 50, ratio: 0.5 },
//     '9': { height: 100, width: 50, ratio: 0.5 },
//     '§': { height: 100, width: 50, ratio: 0.5 },
//     "'": { height: 100, width: 18.0234375, ratio: 0.180234375 },
//     '"': { height: 100, width: 40.8203125, ratio: 0.408203125 },
//     '+': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '!': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '%': { height: 100, width: 83.3046875, ratio: 0.833046875 },
//     '/': { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '=': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '(': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ')': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ö: { height: 100, width: 108.3046875, ratio: 1.083046875 },
//     Ü: { height: 100, width: 98.6015625, ratio: 0.986015625 },
//     Ó: { height: 100, width: 108.3046875, ratio: 1.083046875 },
//     Ú: { height: 100, width: 98.6015625, ratio: 0.986015625 },
//     Ő: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     P: { height: 100, width: 98.40625, ratio: 0.9840625 },
//     O: { height: 100, width: 108.3046875, ratio: 1.083046875 },
//     I: { height: 100, width: 83.3046875, ratio: 0.833046875 },
//     U: { height: 100, width: 98.6015625, ratio: 0.986015625 },
//     Z: { height: 100, width: 83.3046875, ratio: 0.833046875 },
//     T: { height: 100, width: 65.6015625, ratio: 0.656015625 },
//     R: { height: 100, width: 105.203125, ratio: 1.05203125 },
//     E: { height: 100, width: 117.203125, ratio: 1.17203125 },
//     W: { height: 100, width: 119.5, ratio: 1.195 },
//     Q: { height: 100, width: 105.6015625, ratio: 1.056015625 },
//     A: { height: 100, width: 131.203125, ratio: 1.31203125 },
//     S: { height: 100, width: 89.1015625, ratio: 0.891015625 },
//     D: { height: 100, width: 135.40625, ratio: 1.3540625 },
//     F: { height: 100, width: 83.3046875, ratio: 0.833046875 },
//     G: { height: 100, width: 114.8046875, ratio: 1.148046875 },
//     H: { height: 100, width: 140.3046875, ratio: 1.403046875 },
//     J: { height: 100, width: 120.8046875, ratio: 1.208046875 },
//     K: { height: 100, width: 111.703125, ratio: 1.11703125 },
//     L: { height: 100, width: 111.1015625, ratio: 1.111015625 },
//     É: { height: 100, width: 117.203125, ratio: 1.17203125 },
//     Á: { height: 100, width: 131.203125, ratio: 1.31203125 },
//     Ű: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     _: { height: 100, width: 50, ratio: 0.5 },
//     ':': { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '?': { height: 100, width: 44.390625, ratio: 0.44390625 },
//     M: { height: 100, width: 157.3046875, ratio: 1.573046875 },
//     N: { height: 100, width: 127.1015625, ratio: 1.271015625 },
//     B: { height: 100, width: 126, ratio: 1.26 },
//     V: { height: 100, width: 89.1015625, ratio: 0.891015625 },
//     C: { height: 100, width: 105.203125, ratio: 1.05203125 },
//     X: { height: 100, width: 83.3046875, ratio: 0.833046875 },
//     Y: { height: 100, width: 104.1015625, ratio: 1.041015625 },
//     Í: { height: 100, width: 83.3046875, ratio: 0.833046875 },
//     ö: { height: 100, width: 61.703125, ratio: 0.61703125 },
//     ü: { height: 100, width: 87.5, ratio: 0.875 },
//     ó: { height: 100, width: 61.703125, ratio: 0.61703125 },
//     ú: { height: 100, width: 87.5, ratio: 0.875 },
//     ő: { height: 100, width: 50, ratio: 0.5 },
//     p: { height: 100, width: 66.40625, ratio: 0.6640625 },
//     o: { height: 100, width: 61.703125, ratio: 0.61703125 },
//     i: { height: 100, width: 54.703125, ratio: 0.54703125 },
//     u: { height: 100, width: 87.5, ratio: 0.875 },
//     z: { height: 100, width: 79.703125, ratio: 0.79703125 },
//     t: { height: 100, width: 24.203125, ratio: 0.24203125 },
//     r: { height: 100, width: 55.6015625, ratio: 0.556015625 },
//     e: { height: 100, width: 54.703125, ratio: 0.54703125 },
//     w: { height: 100, width: 96.703125, ratio: 0.96703125 },
//     q: { height: 100, width: 78.1015625, ratio: 0.781015625 },
//     a: { height: 100, width: 85.6015625, ratio: 0.856015625 },
//     s: { height: 100, width: 54.3046875, ratio: 0.543046875 },
//     d: { height: 100, width: 85.90625, ratio: 0.8590625 },
//     f: { height: 100, width: 53.8046875, ratio: 0.538046875 },
//     g: { height: 100, width: 71.1015625, ratio: 0.711015625 },
//     h: { height: 100, width: 90.5, ratio: 0.905 },
//     j: { height: 100, width: 38.6015625, ratio: 0.386015625 },
//     k: { height: 100, width: 71.1015625, ratio: 0.711015625 },
//     l: { height: 100, width: 44.5, ratio: 0.445 },
//     é: { height: 100, width: 54.703125, ratio: 0.54703125 },
//     á: { height: 100, width: 85.6015625, ratio: 0.856015625 },
//     ű: { height: 100, width: 50, ratio: 0.5 },
//     '-': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '.': { height: 100, width: 25, ratio: 0.25 },
//     ',': { height: 100, width: 25, ratio: 0.25 },
//     m: { height: 100, width: 114.1015625, ratio: 1.141015625 },
//     n: { height: 100, width: 86.703125, ratio: 0.86703125 },
//     b: { height: 100, width: 54.5, ratio: 0.545 },
//     v: { height: 100, width: 73.40625, ratio: 0.7340625 },
//     c: { height: 100, width: 53.90625, ratio: 0.5390625 },
//     x: { height: 100, width: 87.40625, ratio: 0.8740625 },
//     y: { height: 100, width: 69.5, ratio: 0.695 },
//     í: { height: 100, width: 54.703125, ratio: 0.54703125 },
//     '¬': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '&': { height: 100, width: 77.7890625, ratio: 0.777890625 },
//     '™': { height: 100, width: 98, ratio: 0.98 },
//     '£': { height: 100, width: 50, ratio: 0.5 },
//     $: { height: 100, width: 50, ratio: 0.5 },
//     '‹': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '›': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '{': { height: 100, width: 48, ratio: 0.48 },
//     '[': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ']': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '}': { height: 100, width: 48, ratio: 0.48 },
//     '≠': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     '~': { height: 100, width: 54.1015625, ratio: 0.541015625 },
//     '¨': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ļ: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ņ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '^': { height: 100, width: 46.9296875, ratio: 0.469296875 },
//     ź: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '†': { height: 100, width: 50, ratio: 0.5 },
//     '¶': { height: 100, width: 45.3125, ratio: 0.453125 },
//     '€': { height: 100, width: 83.3046875, ratio: 0.833046875 },
//     ę: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '@': { height: 100, width: 83.3046875, ratio: 0.833046875 },
//     ą: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ß: { height: 100, width: 50, ratio: 0.5 },
//     '∂': { height: 100, width: 49.4140625, ratio: 0.494140625 },
//     ń: { height: 100, width: 50, ratio: 0.5 },
//     '©': { height: 100, width: 75.9765625, ratio: 0.759765625 },
//     ķ: { height: 100, width: 50, ratio: 0.5 },
//     '∆': { height: 100, width: 61.1875, ratio: 0.611875 },
//     Ż: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     '•': { height: 100, width: 35.015625, ratio: 0.35015625 },
//     '…': { height: 100, width: 100, ratio: 1 },
//     '–': { height: 100, width: 50, ratio: 0.5 },
//     ';': { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ķ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '”': { height: 100, width: 83.3046875, ratio: 0.833046875 },
//     '„': { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ć: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '»': { height: 100, width: 50, ratio: 0.5 },
//     '«': { height: 100, width: 50, ratio: 0.5 },
//     '|': { height: 100, width: 20.0234375, ratio: 0.200234375 },
//     ŕ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ř: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '#': { height: 100, width: 50, ratio: 0.5 },
//     ř: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ŗ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     ŗ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '°': { height: 100, width: 39.9921875, ratio: 0.399921875 },
//     ī: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ī: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ý: { height: 100, width: 69.5, ratio: 0.695 },
//     Ý: { height: 100, width: 104.1015625, ratio: 1.041015625 },
//     ł: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ź: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ś: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     '®': { height: 100, width: 75.9765625, ratio: 0.759765625 },
//     š: { height: 100, width: 54.3046875, ratio: 0.543046875 },
//     Ł: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ļ: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '*': { height: 100, width: 50, ratio: 0.5 },
//     ' ': { height: 0, width: 0, ratio: null },
//     ż: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     Ž: { height: 100, width: 83.3046875, ratio: 0.833046875 },
//     Ū: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '—': { height: 100, width: 100, ratio: 1 },
//     '÷': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     ų: { height: 100, width: 50, ratio: 0.5 },
//     Ų: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '’': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '‚': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '>': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '<': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     Ŕ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '&nbsp;': { height: 100, width: 50.203125, ratio: 0.50203125 },
//   },
//   'Clout.ttf': {
//     '0': { height: 100, width: 60.3046875, ratio: 0.603046875 },
//     '1': { height: 100, width: 51.3046875, ratio: 0.513046875 },
//     '2': { height: 100, width: 56.703125, ratio: 0.56703125 },
//     '3': { height: 100, width: 54.703125, ratio: 0.54703125 },
//     '4': { height: 100, width: 56.90625, ratio: 0.5690625 },
//     '5': { height: 100, width: 55.6015625, ratio: 0.556015625 },
//     '6': { height: 100, width: 56.5, ratio: 0.565 },
//     '7': { height: 100, width: 59.1015625, ratio: 0.591015625 },
//     '8': { height: 100, width: 59.40625, ratio: 0.5940625 },
//     '9': { height: 100, width: 57.703125, ratio: 0.57703125 },
//     '§': { height: 100, width: 57.40625, ratio: 0.5740625 },
//     "'": { height: 100, width: 15.203125, ratio: 0.15203125 },
//     '"': { height: 100, width: 29.1015625, ratio: 0.291015625 },
//     '+': { height: 100, width: 62.90625, ratio: 0.6290625 },
//     '!': { height: 100, width: 23.40625, ratio: 0.2340625 },
//     '%': { height: 100, width: 90.8046875, ratio: 0.908046875 },
//     '/': { height: 100, width: 40.203125, ratio: 0.40203125 },
//     '=': { height: 100, width: 63.3046875, ratio: 0.633046875 },
//     '(': { height: 100, width: 32.703125, ratio: 0.32703125 },
//     ')': { height: 100, width: 32.703125, ratio: 0.32703125 },
//     Ö: { height: 100, width: 79.90625, ratio: 0.7990625 },
//     Ü: { height: 100, width: 68.6015625, ratio: 0.686015625 },
//     Ó: { height: 100, width: 79.90625, ratio: 0.7990625 },
//     Ú: { height: 100, width: 68.6015625, ratio: 0.686015625 },
//     Ő: { height: 100, width: 79.90625, ratio: 0.7990625 },
//     P: { height: 100, width: 55.5, ratio: 0.555 },
//     O: { height: 100, width: 79.90625, ratio: 0.7990625 },
//     I: { height: 100, width: 52.5, ratio: 0.525 },
//     U: { height: 100, width: 68.6015625, ratio: 0.686015625 },
//     Z: { height: 100, width: 55.5, ratio: 0.555 },
//     T: { height: 100, width: 53.5, ratio: 0.535 },
//     R: { height: 100, width: 60.3046875, ratio: 0.603046875 },
//     E: { height: 100, width: 52.6015625, ratio: 0.526015625 },
//     W: { height: 100, width: 88.90625, ratio: 0.8890625 },
//     Q: { height: 100, width: 79.90625, ratio: 0.7990625 },
//     A: { height: 100, width: 64.90625, ratio: 0.6490625 },
//     S: { height: 100, width: 52.203125, ratio: 0.52203125 },
//     D: { height: 100, width: 68, ratio: 0.68 },
//     F: { height: 100, width: 50.1015625, ratio: 0.501015625 },
//     G: { height: 100, width: 81.40625, ratio: 0.8140625 },
//     H: { height: 100, width: 67.703125, ratio: 0.67703125 },
//     J: { height: 100, width: 56.5, ratio: 0.565 },
//     K: { height: 100, width: 59.6015625, ratio: 0.596015625 },
//     L: { height: 100, width: 49.6015625, ratio: 0.496015625 },
//     É: { height: 100, width: 52.6015625, ratio: 0.526015625 },
//     Á: { height: 100, width: 64.90625, ratio: 0.6490625 },
//     Ű: { height: 100, width: 68.6015625, ratio: 0.686015625 },
//     _: { height: 100, width: 69.703125, ratio: 0.69703125 },
//     ':': { height: 100, width: 23.703125, ratio: 0.23703125 },
//     '?': { height: 100, width: 42, ratio: 0.42 },
//     M: { height: 100, width: 74, ratio: 0.74 },
//     N: { height: 100, width: 67.703125, ratio: 0.67703125 },
//     B: { height: 100, width: 59.40625, ratio: 0.5940625 },
//     V: { height: 100, width: 64.203125, ratio: 0.64203125 },
//     C: { height: 100, width: 70.3046875, ratio: 0.703046875 },
//     X: { height: 100, width: 65.90625, ratio: 0.6590625 },
//     Y: { height: 100, width: 63.6015625, ratio: 0.636015625 },
//     Í: { height: 100, width: 52.5, ratio: 0.525 },
//     ö: { height: 100, width: 60.40625, ratio: 0.6040625 },
//     ü: { height: 100, width: 54.40625, ratio: 0.5440625 },
//     ó: { height: 100, width: 60.40625, ratio: 0.6040625 },
//     ú: { height: 100, width: 54.40625, ratio: 0.5440625 },
//     ő: { height: 100, width: 60.40625, ratio: 0.6040625 },
//     p: { height: 100, width: 59.40625, ratio: 0.5940625 },
//     o: { height: 100, width: 60.40625, ratio: 0.6040625 },
//     i: { height: 100, width: 25.5, ratio: 0.255 },
//     u: { height: 100, width: 54.40625, ratio: 0.5440625 },
//     z: { height: 100, width: 52.5, ratio: 0.525 },
//     t: { height: 100, width: 49.3046875, ratio: 0.493046875 },
//     r: { height: 100, width: 48.703125, ratio: 0.48703125 },
//     e: { height: 100, width: 57.40625, ratio: 0.5740625 },
//     w: { height: 100, width: 71.6015625, ratio: 0.716015625 },
//     q: { height: 100, width: 59.3046875, ratio: 0.593046875 },
//     a: { height: 100, width: 59.3046875, ratio: 0.593046875 },
//     s: { height: 100, width: 42.90625, ratio: 0.4290625 },
//     d: { height: 100, width: 59.8046875, ratio: 0.598046875 },
//     f: { height: 100, width: 42.5, ratio: 0.425 },
//     g: { height: 100, width: 59.6015625, ratio: 0.596015625 },
//     h: { height: 100, width: 54.8046875, ratio: 0.548046875 },
//     j: { height: 100, width: 42.203125, ratio: 0.42203125 },
//     k: { height: 100, width: 51.5, ratio: 0.515 },
//     l: { height: 100, width: 21.6015625, ratio: 0.216015625 },
//     é: { height: 100, width: 57.40625, ratio: 0.5740625 },
//     á: { height: 100, width: 59.3046875, ratio: 0.593046875 },
//     ű: { height: 100, width: 54.40625, ratio: 0.5440625 },
//     '-': { height: 100, width: 40.703125, ratio: 0.40703125 },
//     '.': { height: 100, width: 23.40625, ratio: 0.2340625 },
//     ',': { height: 100, width: 25.203125, ratio: 0.25203125 },
//     m: { height: 100, width: 80.8046875, ratio: 0.808046875 },
//     n: { height: 100, width: 54.40625, ratio: 0.5440625 },
//     b: { height: 100, width: 59.8046875, ratio: 0.598046875 },
//     v: { height: 100, width: 51.3046875, ratio: 0.513046875 },
//     c: { height: 100, width: 53.3046875, ratio: 0.533046875 },
//     x: { height: 100, width: 50.203125, ratio: 0.50203125 },
//     y: { height: 100, width: 56.3046875, ratio: 0.563046875 },
//     í: { height: 100, width: 25.90625, ratio: 0.2590625 },
//     '¬': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '&': { height: 100, width: 72.203125, ratio: 0.72203125 },
//     '™': { height: 100, width: 92.6015625, ratio: 0.926015625 },
//     '£': { height: 100, width: 61.40625, ratio: 0.6140625 },
//     $: { height: 100, width: 52.203125, ratio: 0.52203125 },
//     '‹': { height: 100, width: 32.3046875, ratio: 0.323046875 },
//     '›': { height: 100, width: 32.203125, ratio: 0.32203125 },
//     '{': { height: 100, width: 41.5, ratio: 0.415 },
//     '[': { height: 100, width: 33.703125, ratio: 0.33703125 },
//     ']': { height: 100, width: 33.8046875, ratio: 0.338046875 },
//     '}': { height: 100, width: 41.40625, ratio: 0.4140625 },
//     '≠': { height: 100, width: 63.3046875, ratio: 0.633046875 },
//     '~': { height: 100, width: 50.1015625, ratio: 0.501015625 },
//     '¨': { height: 100, width: 62.40625, ratio: 0.6240625 },
//     Ļ: { height: 100, width: 49.6015625, ratio: 0.496015625 },
//     Ņ: { height: 100, width: 67.703125, ratio: 0.67703125 },
//     '^': { height: 100, width: 55.3046875, ratio: 0.553046875 },
//     ź: { height: 100, width: 52.5, ratio: 0.525 },
//     '†': { height: 100, width: 45.703125, ratio: 0.45703125 },
//     '¶': { height: 100, width: 57.6015625, ratio: 0.576015625 },
//     '€': { height: 100, width: 74.6015625, ratio: 0.746015625 },
//     ę: { height: 100, width: 57.40625, ratio: 0.5740625 },
//     '@': { height: 100, width: 88.5, ratio: 0.885 },
//     ą: { height: 100, width: 59.3046875, ratio: 0.593046875 },
//     ß: { height: 100, width: 58.5, ratio: 0.585 },
//     '∂': { height: 100, width: 49.4140625, ratio: 0.494140625 },
//     ń: { height: 100, width: 54.40625, ratio: 0.5440625 },
//     '©': { height: 100, width: 83.8046875, ratio: 0.838046875 },
//     ķ: { height: 100, width: 51.5, ratio: 0.515 },
//     '∆': { height: 100, width: 61.1875, ratio: 0.611875 },
//     Ż: { height: 100, width: 55.5, ratio: 0.555 },
//     '•': { height: 100, width: 43.5, ratio: 0.435 },
//     '…': { height: 100, width: 67.8046875, ratio: 0.678046875 },
//     '–': { height: 100, width: 50.8046875, ratio: 0.508046875 },
//     ';': { height: 100, width: 25.203125, ratio: 0.25203125 },
//     Ķ: { height: 100, width: 59.6015625, ratio: 0.596015625 },
//     '”': { height: 100, width: 37.90625, ratio: 0.3790625 },
//     '„': { height: 100, width: 41.6015625, ratio: 0.416015625 },
//     ć: { height: 100, width: 53.3046875, ratio: 0.533046875 },
//     '»': { height: 100, width: 49.203125, ratio: 0.49203125 },
//     '«': { height: 100, width: 49.3046875, ratio: 0.493046875 },
//     '|': { height: 100, width: 21.6015625, ratio: 0.216015625 },
//     ŕ: { height: 100, width: 48.703125, ratio: 0.48703125 },
//     Ř: { height: 100, width: 60.3046875, ratio: 0.603046875 },
//     '#': { height: 100, width: 71.6015625, ratio: 0.716015625 },
//     ř: { height: 100, width: 48.703125, ratio: 0.48703125 },
//     Ŗ: { height: 100, width: 60.3046875, ratio: 0.603046875 },
//     ŗ: { height: 100, width: 48.703125, ratio: 0.48703125 },
//     '°': { height: 100, width: 36.203125, ratio: 0.36203125 },
//     ī: { height: 100, width: 25.90625, ratio: 0.2590625 },
//     Ī: { height: 100, width: 52.5, ratio: 0.525 },
//     ý: { height: 100, width: 56.3046875, ratio: 0.563046875 },
//     Ý: { height: 100, width: 63.6015625, ratio: 0.636015625 },
//     ł: { height: 100, width: 38.1015625, ratio: 0.381015625 },
//     Ź: { height: 100, width: 55.5, ratio: 0.555 },
//     ś: { height: 100, width: 42.90625, ratio: 0.4290625 },
//     '®': { height: 100, width: 83.8046875, ratio: 0.838046875 },
//     š: { height: 100, width: 42.90625, ratio: 0.4290625 },
//     Ł: { height: 100, width: 49.6015625, ratio: 0.496015625 },
//     ļ: { height: 100, width: 21.6015625, ratio: 0.216015625 },
//     '*': { height: 100, width: 39.1015625, ratio: 0.391015625 },
//     ' ': { height: 0, width: 0, ratio: null },
//     ż: { height: 100, width: 52.5, ratio: 0.525 },
//     Ž: { height: 100, width: 55.5, ratio: 0.555 },
//     Ū: { height: 100, width: 68.6015625, ratio: 0.686015625 },
//     '—': { height: 100, width: 71, ratio: 0.71 },
//     '÷': { height: 100, width: 62.90625, ratio: 0.6290625 },
//     ų: { height: 100, width: 54.40625, ratio: 0.5440625 },
//     Ų: { height: 100, width: 68.6015625, ratio: 0.686015625 },
//     '’': { height: 100, width: 21.5, ratio: 0.215 },
//     '‚': { height: 100, width: 25.203125, ratio: 0.25203125 },
//     '>': { height: 100, width: 58.40625, ratio: 0.5840625 },
//     '<': { height: 100, width: 58.5, ratio: 0.585 },
//     Ŕ: { height: 100, width: 60.3046875, ratio: 0.603046875 },
//     '&nbsp;': { height: 100, width: 35.703125, ratio: 0.35703125 },
//   },
//   'Comment.ttf': {
//     '0': { height: 100, width: 52.90625, ratio: 0.5290625 },
//     '1': { height: 100, width: 40.3046875, ratio: 0.403046875 },
//     '2': { height: 100, width: 50, ratio: 0.5 },
//     '3': { height: 100, width: 50.40625, ratio: 0.5040625 },
//     '4': { height: 100, width: 51.8046875, ratio: 0.518046875 },
//     '5': { height: 100, width: 54.1015625, ratio: 0.541015625 },
//     '6': { height: 100, width: 52.90625, ratio: 0.5290625 },
//     '7': { height: 100, width: 51.90625, ratio: 0.5190625 },
//     '8': { height: 100, width: 52.90625, ratio: 0.5290625 },
//     '9': { height: 100, width: 54.40625, ratio: 0.5440625 },
//     '§': { height: 100, width: 50, ratio: 0.5 },
//     "'": { height: 100, width: 37.203125, ratio: 0.37203125 },
//     '"': { height: 100, width: 57.703125, ratio: 0.57703125 },
//     '+': { height: 100, width: 54.40625, ratio: 0.5440625 },
//     '!': { height: 100, width: 35.5, ratio: 0.355 },
//     '%': { height: 100, width: 87.703125, ratio: 0.87703125 },
//     '/': { height: 100, width: 54.203125, ratio: 0.54203125 },
//     '=': { height: 100, width: 50.8046875, ratio: 0.508046875 },
//     '(': { height: 100, width: 48, ratio: 0.48 },
//     ')': { height: 100, width: 47.90625, ratio: 0.4790625 },
//     Ö: { height: 100, width: 79.90625, ratio: 0.7990625 },
//     Ü: { height: 100, width: 80.5, ratio: 0.805 },
//     Ó: { height: 100, width: 79.90625, ratio: 0.7990625 },
//     Ú: { height: 100, width: 80.5, ratio: 0.805 },
//     Ő: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     P: { height: 100, width: 75.6015625, ratio: 0.756015625 },
//     O: { height: 100, width: 79.90625, ratio: 0.7990625 },
//     I: { height: 100, width: 55.8046875, ratio: 0.558046875 },
//     U: { height: 100, width: 80.5, ratio: 0.805 },
//     Z: { height: 100, width: 57.8046875, ratio: 0.578046875 },
//     T: { height: 100, width: 61.703125, ratio: 0.61703125 },
//     R: { height: 100, width: 78.703125, ratio: 0.78703125 },
//     E: { height: 100, width: 67.6015625, ratio: 0.676015625 },
//     W: { height: 100, width: 97.3046875, ratio: 0.973046875 },
//     Q: { height: 100, width: 79.5, ratio: 0.795 },
//     A: { height: 100, width: 71.1015625, ratio: 0.711015625 },
//     S: { height: 100, width: 69.5, ratio: 0.695 },
//     D: { height: 100, width: 79.90625, ratio: 0.7990625 },
//     F: { height: 100, width: 66, ratio: 0.66 },
//     G: { height: 100, width: 68, ratio: 0.68 },
//     H: { height: 100, width: 79.5, ratio: 0.795 },
//     J: { height: 100, width: 55.703125, ratio: 0.55703125 },
//     K: { height: 100, width: 78.6015625, ratio: 0.786015625 },
//     L: { height: 100, width: 65.703125, ratio: 0.65703125 },
//     É: { height: 100, width: 67.6015625, ratio: 0.676015625 },
//     Á: { height: 100, width: 71.1015625, ratio: 0.711015625 },
//     Ű: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     _: { height: 100, width: 56.90625, ratio: 0.5690625 },
//     ':': { height: 100, width: 35.5, ratio: 0.355 },
//     '?': { height: 100, width: 37.703125, ratio: 0.37703125 },
//     M: { height: 100, width: 95.703125, ratio: 0.95703125 },
//     N: { height: 100, width: 78.6015625, ratio: 0.786015625 },
//     B: { height: 100, width: 79.90625, ratio: 0.7990625 },
//     V: { height: 100, width: 77, ratio: 0.77 },
//     C: { height: 100, width: 61, ratio: 0.61 },
//     X: { height: 100, width: 79.40625, ratio: 0.7940625 },
//     Y: { height: 100, width: 80.203125, ratio: 0.80203125 },
//     Í: { height: 100, width: 53.6015625, ratio: 0.536015625 },
//     ö: { height: 100, width: 51.6015625, ratio: 0.516015625 },
//     ü: { height: 100, width: 50.90625, ratio: 0.5090625 },
//     ó: { height: 100, width: 51.6015625, ratio: 0.516015625 },
//     ú: { height: 100, width: 50.90625, ratio: 0.5090625 },
//     ő: { height: 100, width: 50, ratio: 0.5 },
//     p: { height: 100, width: 51.6015625, ratio: 0.516015625 },
//     o: { height: 100, width: 51.6015625, ratio: 0.516015625 },
//     i: { height: 100, width: 32.5, ratio: 0.325 },
//     u: { height: 100, width: 51.1015625, ratio: 0.511015625 },
//     z: { height: 100, width: 52.3046875, ratio: 0.523046875 },
//     t: { height: 100, width: 40, ratio: 0.4 },
//     r: { height: 100, width: 40.703125, ratio: 0.40703125 },
//     e: { height: 100, width: 49.3046875, ratio: 0.493046875 },
//     w: { height: 100, width: 63.3046875, ratio: 0.633046875 },
//     q: { height: 100, width: 51.6015625, ratio: 0.516015625 },
//     a: { height: 100, width: 51, ratio: 0.51 },
//     s: { height: 100, width: 44.1015625, ratio: 0.441015625 },
//     d: { height: 100, width: 51.1015625, ratio: 0.511015625 },
//     f: { height: 100, width: 40.703125, ratio: 0.40703125 },
//     g: { height: 100, width: 52.3046875, ratio: 0.523046875 },
//     h: { height: 100, width: 50.203125, ratio: 0.50203125 },
//     j: { height: 100, width: 33.40625, ratio: 0.3340625 },
//     k: { height: 100, width: 49.8046875, ratio: 0.498046875 },
//     l: { height: 100, width: 32.6015625, ratio: 0.326015625 },
//     é: { height: 100, width: 49.3046875, ratio: 0.493046875 },
//     á: { height: 100, width: 51, ratio: 0.51 },
//     ű: { height: 100, width: 50, ratio: 0.5 },
//     '-': { height: 100, width: 50.8046875, ratio: 0.508046875 },
//     '.': { height: 100, width: 35.5, ratio: 0.355 },
//     ',': { height: 100, width: 35.5, ratio: 0.355 },
//     m: { height: 100, width: 62.6015625, ratio: 0.626015625 },
//     n: { height: 100, width: 50.1015625, ratio: 0.501015625 },
//     b: { height: 100, width: 51.703125, ratio: 0.51703125 },
//     v: { height: 100, width: 49.203125, ratio: 0.49203125 },
//     c: { height: 100, width: 42.40625, ratio: 0.4240625 },
//     x: { height: 100, width: 53.703125, ratio: 0.53703125 },
//     y: { height: 100, width: 52.3046875, ratio: 0.523046875 },
//     í: { height: 100, width: 35.203125, ratio: 0.35203125 },
//     '¬': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '&': { height: 100, width: 58.8046875, ratio: 0.588046875 },
//     '™': { height: 100, width: 98, ratio: 0.98 },
//     '£': { height: 100, width: 51.5, ratio: 0.515 },
//     $: { height: 100, width: 53.1015625, ratio: 0.531015625 },
//     '‹': { height: 100, width: 42.703125, ratio: 0.42703125 },
//     '›': { height: 100, width: 42.90625, ratio: 0.4290625 },
//     '{': { height: 100, width: 49.6015625, ratio: 0.496015625 },
//     '[': { height: 100, width: 45.40625, ratio: 0.4540625 },
//     ']': { height: 100, width: 45.40625, ratio: 0.4540625 },
//     '}': { height: 100, width: 49.6015625, ratio: 0.496015625 },
//     '≠': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     '~': { height: 100, width: 55.5, ratio: 0.555 },
//     '¨': { height: 100, width: 34.5, ratio: 0.345 },
//     Ļ: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ņ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '^': { height: 100, width: 55.40625, ratio: 0.5540625 },
//     ź: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '†': { height: 100, width: 46, ratio: 0.46 },
//     '¶': { height: 100, width: 40.8046875, ratio: 0.408046875 },
//     '€': { height: 100, width: 51.3046875, ratio: 0.513046875 },
//     ę: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '@': { height: 100, width: 85, ratio: 0.85 },
//     ą: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ß: { height: 100, width: 53.6015625, ratio: 0.536015625 },
//     '∂': { height: 100, width: 49.4140625, ratio: 0.494140625 },
//     ń: { height: 100, width: 50, ratio: 0.5 },
//     '©': { height: 100, width: 73.203125, ratio: 0.73203125 },
//     ķ: { height: 100, width: 50, ratio: 0.5 },
//     '∆': { height: 100, width: 61.1875, ratio: 0.611875 },
//     Ż: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     '•': { height: 100, width: 55.5, ratio: 0.555 },
//     '…': { height: 100, width: 99.8046875, ratio: 0.998046875 },
//     '–': { height: 100, width: 56.90625, ratio: 0.5690625 },
//     ';': { height: 100, width: 35.5, ratio: 0.355 },
//     Ķ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '”': { height: 100, width: 63.203125, ratio: 0.63203125 },
//     '„': { height: 100, width: 63.203125, ratio: 0.63203125 },
//     ć: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '»': { height: 100, width: 65, ratio: 0.65 },
//     '«': { height: 100, width: 65, ratio: 0.65 },
//     '|': { height: 100, width: 35.8046875, ratio: 0.358046875 },
//     ŕ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ř: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '#': { height: 100, width: 68, ratio: 0.68 },
//     ř: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ŗ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     ŗ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '°': { height: 100, width: 50.3046875, ratio: 0.503046875 },
//     ī: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ī: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ý: { height: 100, width: 52.703125, ratio: 0.52703125 },
//     Ý: { height: 100, width: 80.203125, ratio: 0.80203125 },
//     ł: { height: 100, width: 34.203125, ratio: 0.34203125 },
//     Ź: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ś: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     '®': { height: 100, width: 80.1015625, ratio: 0.801015625 },
//     š: { height: 100, width: 48.90625, ratio: 0.4890625 },
//     Ł: { height: 100, width: 65.703125, ratio: 0.65703125 },
//     ļ: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '*': { height: 100, width: 52.8046875, ratio: 0.528046875 },
//     ' ': { height: 0, width: 0, ratio: null },
//     ż: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     Ž: { height: 100, width: 57.8046875, ratio: 0.578046875 },
//     Ū: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '—': { height: 100, width: 69.203125, ratio: 0.69203125 },
//     '÷': { height: 100, width: 54.40625, ratio: 0.5440625 },
//     ų: { height: 100, width: 50, ratio: 0.5 },
//     Ų: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '’': { height: 100, width: 43.6015625, ratio: 0.436015625 },
//     '‚': { height: 100, width: 35.5, ratio: 0.355 },
//     '>': { height: 100, width: 45.703125, ratio: 0.45703125 },
//     '<': { height: 100, width: 45.8046875, ratio: 0.458046875 },
//     Ŕ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '&nbsp;': { height: 100, width: 22.3046875, ratio: 0.223046875 },
//   },
//   'Gamble.ttf': {
//     '0': { height: 100, width: 28.6015625, ratio: 0.286015625 },
//     '1': { height: 100, width: 17.703125, ratio: 0.17703125 },
//     '2': { height: 100, width: 28.90625, ratio: 0.2890625 },
//     '3': { height: 100, width: 31.6015625, ratio: 0.316015625 },
//     '4': { height: 100, width: 29.40625, ratio: 0.2940625 },
//     '5': { height: 100, width: 29.8046875, ratio: 0.298046875 },
//     '6': { height: 100, width: 27.8046875, ratio: 0.278046875 },
//     '7': { height: 100, width: 23, ratio: 0.23 },
//     '8': { height: 100, width: 27.703125, ratio: 0.27703125 },
//     '9': { height: 100, width: 27.5, ratio: 0.275 },
//     '§': { height: 100, width: 30.6015625, ratio: 0.306015625 },
//     "'": { height: 100, width: 14.1015625, ratio: 0.141015625 },
//     '"': { height: 100, width: 20.3046875, ratio: 0.203046875 },
//     '+': { height: 100, width: 15.8046875, ratio: 0.158046875 },
//     '!': { height: 100, width: 27.5, ratio: 0.275 },
//     '%': { height: 100, width: 26.203125, ratio: 0.26203125 },
//     '/': { height: 100, width: 27.703125, ratio: 0.27703125 },
//     '=': { height: 100, width: 19.6015625, ratio: 0.196015625 },
//     '(': { height: 100, width: 28.703125, ratio: 0.28703125 },
//     ')': { height: 100, width: 28.703125, ratio: 0.28703125 },
//     Ö: { height: 100, width: 44.5, ratio: 0.445 },
//     Ü: { height: 100, width: 40, ratio: 0.4 },
//     Ó: { height: 100, width: 44.5, ratio: 0.445 },
//     Ú: { height: 100, width: 40, ratio: 0.4 },
//     Ő: { height: 100, width: 44.5, ratio: 0.445 },
//     P: { height: 100, width: 49.203125, ratio: 0.49203125 },
//     O: { height: 100, width: 44.5, ratio: 0.445 },
//     I: { height: 100, width: 40.8046875, ratio: 0.408046875 },
//     U: { height: 100, width: 40, ratio: 0.4 },
//     Z: { height: 100, width: 40.203125, ratio: 0.40203125 },
//     T: { height: 100, width: 27.8046875, ratio: 0.278046875 },
//     R: { height: 100, width: 51.90625, ratio: 0.5190625 },
//     E: { height: 100, width: 34.203125, ratio: 0.34203125 },
//     W: { height: 100, width: 49.40625, ratio: 0.4940625 },
//     Q: { height: 100, width: 45.6015625, ratio: 0.456015625 },
//     A: { height: 100, width: 46, ratio: 0.46 },
//     S: { height: 100, width: 34.40625, ratio: 0.3440625 },
//     D: { height: 100, width: 52, ratio: 0.52 },
//     F: { height: 100, width: 30.203125, ratio: 0.30203125 },
//     G: { height: 100, width: 39.6015625, ratio: 0.396015625 },
//     H: { height: 100, width: 44.5, ratio: 0.445 },
//     J: { height: 100, width: 38.6015625, ratio: 0.386015625 },
//     K: { height: 100, width: 44.3046875, ratio: 0.443046875 },
//     L: { height: 100, width: 25.40625, ratio: 0.2540625 },
//     É: { height: 100, width: 34.203125, ratio: 0.34203125 },
//     Á: { height: 100, width: 46, ratio: 0.46 },
//     Ű: { height: 100, width: 40, ratio: 0.4 },
//     _: { height: 100, width: 28.6015625, ratio: 0.286015625 },
//     ':': { height: 100, width: 18.5, ratio: 0.185 },
//     '?': { height: 100, width: 32.90625, ratio: 0.3290625 },
//     M: { height: 100, width: 53.8046875, ratio: 0.538046875 },
//     N: { height: 100, width: 50.3046875, ratio: 0.503046875 },
//     B: { height: 100, width: 52.8046875, ratio: 0.528046875 },
//     V: { height: 100, width: 39, ratio: 0.39 },
//     C: { height: 100, width: 35.5, ratio: 0.355 },
//     X: { height: 100, width: 36.90625, ratio: 0.3690625 },
//     Y: { height: 100, width: 45, ratio: 0.45 },
//     Í: { height: 100, width: 40.8046875, ratio: 0.408046875 },
//     ö: { height: 100, width: 27.40625, ratio: 0.2740625 },
//     ü: { height: 100, width: 31.40625, ratio: 0.3140625 },
//     ó: { height: 100, width: 27.40625, ratio: 0.2740625 },
//     ú: { height: 100, width: 31.40625, ratio: 0.3140625 },
//     ő: { height: 100, width: 27.40625, ratio: 0.2740625 },
//     p: { height: 100, width: 28.40625, ratio: 0.2840625 },
//     o: { height: 100, width: 27.40625, ratio: 0.2740625 },
//     i: { height: 100, width: 16.703125, ratio: 0.16703125 },
//     u: { height: 100, width: 31.40625, ratio: 0.3140625 },
//     z: { height: 100, width: 26.6015625, ratio: 0.266015625 },
//     t: { height: 100, width: 18.6015625, ratio: 0.186015625 },
//     r: { height: 100, width: 25.6015625, ratio: 0.256015625 },
//     e: { height: 100, width: 22.203125, ratio: 0.22203125 },
//     w: { height: 100, width: 36.90625, ratio: 0.3690625 },
//     q: { height: 100, width: 26.203125, ratio: 0.26203125 },
//     a: { height: 100, width: 31.40625, ratio: 0.3140625 },
//     s: { height: 100, width: 19.40625, ratio: 0.1940625 },
//     d: { height: 100, width: 33.6015625, ratio: 0.336015625 },
//     f: { height: 100, width: 19.3046875, ratio: 0.193046875 },
//     g: { height: 100, width: 25.8046875, ratio: 0.258046875 },
//     h: { height: 100, width: 30.1015625, ratio: 0.301015625 },
//     j: { height: 100, width: 12.6015625, ratio: 0.126015625 },
//     k: { height: 100, width: 30.1015625, ratio: 0.301015625 },
//     l: { height: 100, width: 18.90625, ratio: 0.1890625 },
//     é: { height: 100, width: 22.203125, ratio: 0.22203125 },
//     á: { height: 100, width: 31.40625, ratio: 0.3140625 },
//     ű: { height: 100, width: 31.40625, ratio: 0.3140625 },
//     '-': { height: 100, width: 33.40625, ratio: 0.3340625 },
//     '.': { height: 100, width: 15.203125, ratio: 0.15203125 },
//     ',': { height: 100, width: 15.40625, ratio: 0.1540625 },
//     m: { height: 100, width: 42.6015625, ratio: 0.426015625 },
//     n: { height: 100, width: 30.1015625, ratio: 0.301015625 },
//     b: { height: 100, width: 24.203125, ratio: 0.24203125 },
//     v: { height: 100, width: 24.6015625, ratio: 0.246015625 },
//     c: { height: 100, width: 22.203125, ratio: 0.22203125 },
//     x: { height: 100, width: 27.40625, ratio: 0.2740625 },
//     y: { height: 100, width: 26.40625, ratio: 0.2640625 },
//     í: { height: 100, width: 16.703125, ratio: 0.16703125 },
//     '¬': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '&': { height: 100, width: 31.6015625, ratio: 0.316015625 },
//     '™': { height: 100, width: 98, ratio: 0.98 },
//     '£': { height: 100, width: 30, ratio: 0.3 },
//     $: { height: 100, width: 25.8046875, ratio: 0.258046875 },
//     '‹': { height: 100, width: 13.703125, ratio: 0.13703125 },
//     '›': { height: 100, width: 13, ratio: 0.13 },
//     '{': { height: 100, width: 24.1015625, ratio: 0.241015625 },
//     '[': { height: 100, width: 39.203125, ratio: 0.39203125 },
//     ']': { height: 100, width: 39.1015625, ratio: 0.391015625 },
//     '}': { height: 100, width: 24.1015625, ratio: 0.241015625 },
//     '≠': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     '~': { height: 100, width: 20.5, ratio: 0.205 },
//     '¨': { height: 100, width: 18.5, ratio: 0.185 },
//     Ļ: { height: 100, width: 25.40625, ratio: 0.2540625 },
//     Ņ: { height: 100, width: 50.3046875, ratio: 0.503046875 },
//     '^': { height: 100, width: 46.9296875, ratio: 0.469296875 },
//     ź: { height: 100, width: 26.6015625, ratio: 0.266015625 },
//     '†': { height: 100, width: 33.1015625, ratio: 0.331015625 },
//     '¶': { height: 100, width: 42.90625, ratio: 0.4290625 },
//     '€': { height: 100, width: 27.8046875, ratio: 0.278046875 },
//     ę: { height: 100, width: 22.203125, ratio: 0.22203125 },
//     '@': { height: 100, width: 52.6015625, ratio: 0.526015625 },
//     ą: { height: 100, width: 31.40625, ratio: 0.3140625 },
//     ß: { height: 100, width: 26.203125, ratio: 0.26203125 },
//     '∂': { height: 100, width: 49.4140625, ratio: 0.494140625 },
//     ń: { height: 100, width: 30.1015625, ratio: 0.301015625 },
//     '©': { height: 100, width: 16.6015625, ratio: 0.166015625 },
//     ķ: { height: 100, width: 30.1015625, ratio: 0.301015625 },
//     '∆': { height: 100, width: 61.1875, ratio: 0.611875 },
//     Ż: { height: 100, width: 40.203125, ratio: 0.40203125 },
//     '•': { height: 100, width: 17, ratio: 0.17 },
//     '…': { height: 100, width: 31.203125, ratio: 0.31203125 },
//     '–': { height: 100, width: 39.8046875, ratio: 0.398046875 },
//     ';': { height: 100, width: 27.6015625, ratio: 0.276015625 },
//     Ķ: { height: 100, width: 44.3046875, ratio: 0.443046875 },
//     '”': { height: 100, width: 26.8046875, ratio: 0.268046875 },
//     '„': { height: 100, width: 26.8046875, ratio: 0.268046875 },
//     ć: { height: 100, width: 22.203125, ratio: 0.22203125 },
//     '»': { height: 100, width: 21.5, ratio: 0.215 },
//     '«': { height: 100, width: 22.3046875, ratio: 0.223046875 },
//     '|': { height: 100, width: 33.1015625, ratio: 0.331015625 },
//     ŕ: { height: 100, width: 25.6015625, ratio: 0.256015625 },
//     Ř: { height: 100, width: 51.90625, ratio: 0.5190625 },
//     '#': { height: 100, width: 58.40625, ratio: 0.5840625 },
//     ř: { height: 100, width: 25.6015625, ratio: 0.256015625 },
//     Ŗ: { height: 100, width: 51.90625, ratio: 0.5190625 },
//     ŗ: { height: 100, width: 25.6015625, ratio: 0.256015625 },
//     '°': { height: 100, width: 8.203125, ratio: 0.08203125 },
//     ī: { height: 100, width: 16.703125, ratio: 0.16703125 },
//     Ī: { height: 100, width: 40.8046875, ratio: 0.408046875 },
//     ý: { height: 100, width: 26.40625, ratio: 0.2640625 },
//     Ý: { height: 100, width: 45, ratio: 0.45 },
//     ł: { height: 100, width: 18.90625, ratio: 0.1890625 },
//     Ź: { height: 100, width: 40.203125, ratio: 0.40203125 },
//     ś: { height: 100, width: 19.40625, ratio: 0.1940625 },
//     '®': { height: 100, width: 8.8046875, ratio: 0.088046875 },
//     š: { height: 100, width: 19.40625, ratio: 0.1940625 },
//     Ł: { height: 100, width: 25.40625, ratio: 0.2540625 },
//     ļ: { height: 100, width: 18.90625, ratio: 0.1890625 },
//     '*': { height: 100, width: 8.703125, ratio: 0.08703125 },
//     ' ': { height: 0, width: 0, ratio: null },
//     ż: { height: 100, width: 26.6015625, ratio: 0.266015625 },
//     Ž: { height: 100, width: 40.203125, ratio: 0.40203125 },
//     Ū: { height: 100, width: 40, ratio: 0.4 },
//     '—': { height: 100, width: 49.40625, ratio: 0.4940625 },
//     '÷': { height: 100, width: 18.5, ratio: 0.185 },
//     ų: { height: 100, width: 31.40625, ratio: 0.3140625 },
//     Ų: { height: 100, width: 40, ratio: 0.4 },
//     '’': { height: 100, width: 24.203125, ratio: 0.24203125 },
//     '‚': { height: 100, width: 19.703125, ratio: 0.19703125 },
//     '>': { height: 100, width: 17.8046875, ratio: 0.178046875 },
//     '<': { height: 100, width: 17.8046875, ratio: 0.178046875 },
//     Ŕ: { height: 100, width: 51.90625, ratio: 0.5190625 },
//     '&nbsp;': { height: 100, width: 13.90625, ratio: 0.1390625 },
//   },
//   'Glow.ttf': {
//     '0': { height: 100, width: 78.125, ratio: 0.78125 },
//     '1': { height: 100, width: 19.53125, ratio: 0.1953125 },
//     '2': { height: 100, width: 78.125, ratio: 0.78125 },
//     '3': { height: 100, width: 78.125, ratio: 0.78125 },
//     '4': { height: 100, width: 78.125, ratio: 0.78125 },
//     '5': { height: 100, width: 78.125, ratio: 0.78125 },
//     '6': { height: 100, width: 78.125, ratio: 0.78125 },
//     '7': { height: 100, width: 78.125, ratio: 0.78125 },
//     '8': { height: 100, width: 78.125, ratio: 0.78125 },
//     '9': { height: 100, width: 78.125, ratio: 0.78125 },
//     '§': { height: 100, width: 50, ratio: 0.5 },
//     "'": { height: 100, width: 19.53125, ratio: 0.1953125 },
//     '"': { height: 100, width: 34.1796875, ratio: 0.341796875 },
//     '+': { height: 100, width: 48.828125, ratio: 0.48828125 },
//     '!': { height: 100, width: 19.53125, ratio: 0.1953125 },
//     '%': { height: 100, width: 78.125, ratio: 0.78125 },
//     '/': { height: 100, width: 78.125, ratio: 0.78125 },
//     '=': { height: 100, width: 48.828125, ratio: 0.48828125 },
//     '(': { height: 100, width: 53.7109375, ratio: 0.537109375 },
//     ')': { height: 100, width: 53.7109375, ratio: 0.537109375 },
//     Ö: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ü: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ó: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ú: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ő: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     P: { height: 100, width: 78.125, ratio: 0.78125 },
//     O: { height: 100, width: 78.125, ratio: 0.78125 },
//     I: { height: 100, width: 19.53125, ratio: 0.1953125 },
//     U: { height: 100, width: 78.125, ratio: 0.78125 },
//     Z: { height: 100, width: 78.125, ratio: 0.78125 },
//     T: { height: 100, width: 78.125, ratio: 0.78125 },
//     R: { height: 100, width: 78.125, ratio: 0.78125 },
//     E: { height: 100, width: 78.125, ratio: 0.78125 },
//     W: { height: 100, width: 78.125, ratio: 0.78125 },
//     Q: { height: 100, width: 78.125, ratio: 0.78125 },
//     A: { height: 100, width: 78.125, ratio: 0.78125 },
//     S: { height: 100, width: 78.125, ratio: 0.78125 },
//     D: { height: 100, width: 78.125, ratio: 0.78125 },
//     F: { height: 100, width: 78.125, ratio: 0.78125 },
//     G: { height: 100, width: 78.125, ratio: 0.78125 },
//     H: { height: 100, width: 78.125, ratio: 0.78125 },
//     J: { height: 100, width: 78.125, ratio: 0.78125 },
//     K: { height: 100, width: 78.125, ratio: 0.78125 },
//     L: { height: 100, width: 78.125, ratio: 0.78125 },
//     É: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Á: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ű: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     _: { height: 100, width: 78.125, ratio: 0.78125 },
//     ':': { height: 100, width: 19.53125, ratio: 0.1953125 },
//     '?': { height: 100, width: 78.125, ratio: 0.78125 },
//     M: { height: 100, width: 78.125, ratio: 0.78125 },
//     N: { height: 100, width: 78.125, ratio: 0.78125 },
//     B: { height: 100, width: 78.125, ratio: 0.78125 },
//     V: { height: 100, width: 78.125, ratio: 0.78125 },
//     C: { height: 100, width: 78.125, ratio: 0.78125 },
//     X: { height: 100, width: 78.125, ratio: 0.78125 },
//     Y: { height: 100, width: 78.125, ratio: 0.78125 },
//     Í: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ö: { height: 100, width: 50, ratio: 0.5 },
//     ü: { height: 100, width: 50, ratio: 0.5 },
//     ó: { height: 100, width: 50, ratio: 0.5 },
//     ú: { height: 100, width: 50, ratio: 0.5 },
//     ő: { height: 100, width: 50, ratio: 0.5 },
//     p: { height: 100, width: 78.125, ratio: 0.78125 },
//     o: { height: 100, width: 78.125, ratio: 0.78125 },
//     i: { height: 100, width: 19.53125, ratio: 0.1953125 },
//     u: { height: 100, width: 78.125, ratio: 0.78125 },
//     z: { height: 100, width: 78.125, ratio: 0.78125 },
//     t: { height: 100, width: 78.125, ratio: 0.78125 },
//     r: { height: 100, width: 78.125, ratio: 0.78125 },
//     e: { height: 100, width: 78.125, ratio: 0.78125 },
//     w: { height: 100, width: 78.125, ratio: 0.78125 },
//     q: { height: 100, width: 78.125, ratio: 0.78125 },
//     a: { height: 100, width: 78.125, ratio: 0.78125 },
//     s: { height: 100, width: 78.125, ratio: 0.78125 },
//     d: { height: 100, width: 78.125, ratio: 0.78125 },
//     f: { height: 100, width: 78.125, ratio: 0.78125 },
//     g: { height: 100, width: 78.125, ratio: 0.78125 },
//     h: { height: 100, width: 78.125, ratio: 0.78125 },
//     j: { height: 100, width: 78.125, ratio: 0.78125 },
//     k: { height: 100, width: 78.125, ratio: 0.78125 },
//     l: { height: 100, width: 78.125, ratio: 0.78125 },
//     é: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     á: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ű: { height: 100, width: 50, ratio: 0.5 },
//     '-': { height: 100, width: 48.828125, ratio: 0.48828125 },
//     '.': { height: 100, width: 19.53125, ratio: 0.1953125 },
//     ',': { height: 100, width: 19.53125, ratio: 0.1953125 },
//     m: { height: 100, width: 78.125, ratio: 0.78125 },
//     n: { height: 100, width: 78.125, ratio: 0.78125 },
//     b: { height: 100, width: 78.125, ratio: 0.78125 },
//     v: { height: 100, width: 78.125, ratio: 0.78125 },
//     c: { height: 100, width: 78.125, ratio: 0.78125 },
//     x: { height: 100, width: 78.125, ratio: 0.78125 },
//     y: { height: 100, width: 78.125, ratio: 0.78125 },
//     í: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '¬': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '&': { height: 100, width: 78.125, ratio: 0.78125 },
//     '™': { height: 100, width: 98, ratio: 0.98 },
//     '£': { height: 100, width: 50, ratio: 0.5 },
//     $: { height: 100, width: 78.125, ratio: 0.78125 },
//     '‹': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '›': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '{': { height: 100, width: 48.828125, ratio: 0.48828125 },
//     '[': { height: 100, width: 48.828125, ratio: 0.48828125 },
//     ']': { height: 100, width: 48.828125, ratio: 0.48828125 },
//     '}': { height: 100, width: 48.828125, ratio: 0.48828125 },
//     '≠': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     '~': { height: 100, width: 48.828125, ratio: 0.48828125 },
//     '¨': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ļ: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ņ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '^': { height: 100, width: 19.53125, ratio: 0.1953125 },
//     ź: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '†': { height: 100, width: 50, ratio: 0.5 },
//     '¶': { height: 100, width: 45.3125, ratio: 0.453125 },
//     '€': { height: 100, width: 74.4140625, ratio: 0.744140625 },
//     ę: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '@': { height: 100, width: 78.125, ratio: 0.78125 },
//     ą: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ß: { height: 100, width: 50, ratio: 0.5 },
//     '∂': { height: 100, width: 49.4140625, ratio: 0.494140625 },
//     ń: { height: 100, width: 50, ratio: 0.5 },
//     '©': { height: 100, width: 75.9765625, ratio: 0.759765625 },
//     ķ: { height: 100, width: 50, ratio: 0.5 },
//     '∆': { height: 100, width: 61.1875, ratio: 0.611875 },
//     Ż: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     '•': { height: 100, width: 35.015625, ratio: 0.35015625 },
//     '…': { height: 100, width: 100, ratio: 1 },
//     '–': { height: 100, width: 50, ratio: 0.5 },
//     ';': { height: 100, width: 19.53125, ratio: 0.1953125 },
//     Ķ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '”': { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '„': { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ć: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '»': { height: 100, width: 50, ratio: 0.5 },
//     '«': { height: 100, width: 50, ratio: 0.5 },
//     '|': { height: 100, width: 19.53125, ratio: 0.1953125 },
//     ŕ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ř: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '#': { height: 100, width: 78.125, ratio: 0.78125 },
//     ř: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ŗ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     ŗ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '°': { height: 100, width: 39.9921875, ratio: 0.399921875 },
//     ī: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ī: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ý: { height: 100, width: 50, ratio: 0.5 },
//     Ý: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     ł: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ź: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ś: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     '®': { height: 100, width: 75.9765625, ratio: 0.759765625 },
//     š: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     Ł: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ļ: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '*': { height: 100, width: 43.9453125, ratio: 0.439453125 },
//     ' ': { height: 0, width: 0, ratio: null },
//     ż: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     Ž: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ū: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '—': { height: 100, width: 100, ratio: 1 },
//     '÷': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     ų: { height: 100, width: 50, ratio: 0.5 },
//     Ų: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '’': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '‚': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '>': { height: 100, width: 53.7109375, ratio: 0.537109375 },
//     '<': { height: 100, width: 53.7109375, ratio: 0.537109375 },
//     Ŕ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '&nbsp;': { height: 100, width: 24.8046875, ratio: 0.248046875 },
//   },
//   'Instaneon.ttf': {
//     '0': { height: 100, width: 31.6015625, ratio: 0.316015625 },
//     '1': { height: 100, width: 21.8046875, ratio: 0.218046875 },
//     '2': { height: 100, width: 28.5, ratio: 0.285 },
//     '3': { height: 100, width: 31.6015625, ratio: 0.316015625 },
//     '4': { height: 100, width: 32.40625, ratio: 0.3240625 },
//     '5': { height: 100, width: 37.1015625, ratio: 0.371015625 },
//     '6': { height: 100, width: 36.6015625, ratio: 0.366015625 },
//     '7': { height: 100, width: 33.5, ratio: 0.335 },
//     '8': { height: 100, width: 32.40625, ratio: 0.3240625 },
//     '9': { height: 100, width: 29.90625, ratio: 0.2990625 },
//     '§': { height: 100, width: 38.203125, ratio: 0.38203125 },
//     "'": { height: 100, width: 6.1015625, ratio: 0.061015625 },
//     '"': { height: 100, width: 12.1015625, ratio: 0.121015625 },
//     '+': { height: 100, width: 20.90625, ratio: 0.2090625 },
//     '!': { height: 100, width: 25.3046875, ratio: 0.253046875 },
//     '%': { height: 100, width: 31.40625, ratio: 0.3140625 },
//     '/': { height: 100, width: 38.5, ratio: 0.385 },
//     '=': { height: 100, width: 15.8046875, ratio: 0.158046875 },
//     '(': { height: 100, width: 37.703125, ratio: 0.37703125 },
//     ')': { height: 100, width: 37.703125, ratio: 0.37703125 },
//     Ö: { height: 100, width: 62.1015625, ratio: 0.621015625 },
//     Ü: { height: 100, width: 74.1015625, ratio: 0.741015625 },
//     Ó: { height: 100, width: 62.1015625, ratio: 0.621015625 },
//     Ú: { height: 100, width: 74.1015625, ratio: 0.741015625 },
//     Ő: { height: 100, width: 62.1015625, ratio: 0.621015625 },
//     P: { height: 100, width: 71.90625, ratio: 0.7190625 },
//     O: { height: 100, width: 62.1015625, ratio: 0.621015625 },
//     I: { height: 100, width: 49.3046875, ratio: 0.493046875 },
//     U: { height: 100, width: 74.1015625, ratio: 0.741015625 },
//     Z: { height: 100, width: 55.703125, ratio: 0.55703125 },
//     T: { height: 100, width: 51.5, ratio: 0.515 },
//     R: { height: 100, width: 74, ratio: 0.74 },
//     E: { height: 100, width: 45.40625, ratio: 0.4540625 },
//     W: { height: 100, width: 105.6015625, ratio: 1.056015625 },
//     Q: { height: 100, width: 57.40625, ratio: 0.5740625 },
//     A: { height: 100, width: 70.6015625, ratio: 0.706015625 },
//     S: { height: 100, width: 56.3046875, ratio: 0.563046875 },
//     D: { height: 100, width: 73.40625, ratio: 0.7340625 },
//     F: { height: 100, width: 49.40625, ratio: 0.4940625 },
//     G: { height: 100, width: 44.203125, ratio: 0.44203125 },
//     H: { height: 100, width: 74.703125, ratio: 0.74703125 },
//     J: { height: 100, width: 54.40625, ratio: 0.5440625 },
//     K: { height: 100, width: 73.8046875, ratio: 0.738046875 },
//     L: { height: 100, width: 46.203125, ratio: 0.46203125 },
//     É: { height: 100, width: 45.40625, ratio: 0.4540625 },
//     Á: { height: 100, width: 70.6015625, ratio: 0.706015625 },
//     Ű: { height: 100, width: 74.1015625, ratio: 0.741015625 },
//     _: { height: 100, width: 20.90625, ratio: 0.2090625 },
//     ':': { height: 100, width: 13.703125, ratio: 0.13703125 },
//     '?': { height: 100, width: 31.90625, ratio: 0.3190625 },
//     M: { height: 100, width: 93.703125, ratio: 0.93703125 },
//     N: { height: 100, width: 70.90625, ratio: 0.7090625 },
//     B: { height: 100, width: 73.3046875, ratio: 0.733046875 },
//     V: { height: 100, width: 69.203125, ratio: 0.69203125 },
//     C: { height: 100, width: 41, ratio: 0.41 },
//     X: { height: 100, width: 62, ratio: 0.62 },
//     Y: { height: 100, width: 63.203125, ratio: 0.63203125 },
//     Í: { height: 100, width: 49.3046875, ratio: 0.493046875 },
//     ö: { height: 100, width: 29.3046875, ratio: 0.293046875 },
//     ü: { height: 100, width: 28.203125, ratio: 0.28203125 },
//     ó: { height: 100, width: 29.3046875, ratio: 0.293046875 },
//     ú: { height: 100, width: 28.203125, ratio: 0.28203125 },
//     ő: { height: 100, width: 29.3046875, ratio: 0.293046875 },
//     p: { height: 100, width: 24, ratio: 0.24 },
//     o: { height: 100, width: 29.3046875, ratio: 0.293046875 },
//     i: { height: 100, width: 12.3046875, ratio: 0.123046875 },
//     u: { height: 100, width: 28.203125, ratio: 0.28203125 },
//     z: { height: 100, width: 24.3046875, ratio: 0.243046875 },
//     t: { height: 100, width: 12.90625, ratio: 0.1290625 },
//     r: { height: 100, width: 24, ratio: 0.24 },
//     e: { height: 100, width: 22, ratio: 0.22 },
//     w: { height: 100, width: 31.203125, ratio: 0.31203125 },
//     q: { height: 100, width: 23.8046875, ratio: 0.238046875 },
//     a: { height: 100, width: 29.203125, ratio: 0.29203125 },
//     s: { height: 100, width: 19.203125, ratio: 0.19203125 },
//     d: { height: 100, width: 27.703125, ratio: 0.27703125 },
//     f: { height: 100, width: 19.90625, ratio: 0.1990625 },
//     g: { height: 100, width: 28.703125, ratio: 0.28703125 },
//     h: { height: 100, width: 28.3046875, ratio: 0.283046875 },
//     j: { height: 100, width: 10.3046875, ratio: 0.103046875 },
//     k: { height: 100, width: 26.6015625, ratio: 0.266015625 },
//     l: { height: 100, width: 13.3046875, ratio: 0.133046875 },
//     é: { height: 100, width: 22, ratio: 0.22 },
//     á: { height: 100, width: 29.203125, ratio: 0.29203125 },
//     ű: { height: 100, width: 28.203125, ratio: 0.28203125 },
//     '-': { height: 100, width: 20.90625, ratio: 0.2090625 },
//     '.': { height: 100, width: 7.90625, ratio: 0.0790625 },
//     ',': { height: 100, width: 9.703125, ratio: 0.09703125 },
//     m: { height: 100, width: 35.1015625, ratio: 0.351015625 },
//     n: { height: 100, width: 28.1015625, ratio: 0.281015625 },
//     b: { height: 100, width: 23.3046875, ratio: 0.233046875 },
//     v: { height: 100, width: 24.1015625, ratio: 0.241015625 },
//     c: { height: 100, width: 22.5, ratio: 0.225 },
//     x: { height: 100, width: 29.203125, ratio: 0.29203125 },
//     y: { height: 100, width: 26.3046875, ratio: 0.263046875 },
//     í: { height: 100, width: 12.3046875, ratio: 0.123046875 },
//     '¬': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '&': { height: 100, width: 37, ratio: 0.37 },
//     '™': { height: 100, width: 40.3046875, ratio: 0.403046875 },
//     '£': { height: 100, width: 26.6015625, ratio: 0.266015625 },
//     $: { height: 100, width: 26.1015625, ratio: 0.261015625 },
//     '‹': { height: 100, width: 14.90625, ratio: 0.1490625 },
//     '›': { height: 100, width: 12.90625, ratio: 0.1290625 },
//     '{': { height: 100, width: 31.6015625, ratio: 0.316015625 },
//     '[': { height: 100, width: 40.5, ratio: 0.405 },
//     ']': { height: 100, width: 40.40625, ratio: 0.4040625 },
//     '}': { height: 100, width: 31.703125, ratio: 0.31703125 },
//     '≠': { height: 100, width: 15.8046875, ratio: 0.158046875 },
//     '~': { height: 100, width: 16.90625, ratio: 0.1690625 },
//     '¨': { height: 100, width: 12.90625, ratio: 0.1290625 },
//     Ļ: { height: 100, width: 46.203125, ratio: 0.46203125 },
//     Ņ: { height: 100, width: 70.90625, ratio: 0.7090625 },
//     '^': { height: 100, width: 14.6015625, ratio: 0.146015625 },
//     ź: { height: 100, width: 24.3046875, ratio: 0.243046875 },
//     '†': { height: 100, width: 27, ratio: 0.27 },
//     '¶': { height: 100, width: 24.703125, ratio: 0.24703125 },
//     '€': { height: 100, width: 30.5, ratio: 0.305 },
//     ę: { height: 100, width: 22, ratio: 0.22 },
//     '@': { height: 100, width: 51, ratio: 0.51 },
//     ą: { height: 100, width: 29.203125, ratio: 0.29203125 },
//     ß: { height: 100, width: 25.703125, ratio: 0.25703125 },
//     '∂': { height: 100, width: 49.4140625, ratio: 0.494140625 },
//     ń: { height: 100, width: 28.1015625, ratio: 0.281015625 },
//     '©': { height: 100, width: 30.90625, ratio: 0.3090625 },
//     ķ: { height: 100, width: 26.703125, ratio: 0.26703125 },
//     '∆': { height: 100, width: 61.1875, ratio: 0.611875 },
//     Ż: { height: 100, width: 55.703125, ratio: 0.55703125 },
//     '•': { height: 100, width: 18.3046875, ratio: 0.183046875 },
//     '…': { height: 100, width: 23.703125, ratio: 0.23703125 },
//     '–': { height: 100, width: 27.90625, ratio: 0.2790625 },
//     ';': { height: 100, width: 14.5, ratio: 0.145 },
//     Ķ: { height: 100, width: 73.8046875, ratio: 0.738046875 },
//     '”': { height: 100, width: 22.1015625, ratio: 0.221015625 },
//     '„': { height: 100, width: 12.1015625, ratio: 0.121015625 },
//     ć: { height: 100, width: 22.5, ratio: 0.225 },
//     '»': { height: 100, width: 18.90625, ratio: 0.1890625 },
//     '«': { height: 100, width: 20.90625, ratio: 0.2090625 },
//     '|': { height: 100, width: 26.5, ratio: 0.265 },
//     ŕ: { height: 100, width: 24, ratio: 0.24 },
//     Ř: { height: 100, width: 74, ratio: 0.74 },
//     '#': { height: 100, width: 26.3046875, ratio: 0.263046875 },
//     ř: { height: 100, width: 24, ratio: 0.24 },
//     Ŗ: { height: 100, width: 74, ratio: 0.74 },
//     ŗ: { height: 100, width: 24, ratio: 0.24 },
//     '°': { height: 100, width: 17.1015625, ratio: 0.171015625 },
//     ī: { height: 100, width: 12.3046875, ratio: 0.123046875 },
//     Ī: { height: 100, width: 49.3046875, ratio: 0.493046875 },
//     ý: { height: 100, width: 26.3046875, ratio: 0.263046875 },
//     Ý: { height: 100, width: 63.203125, ratio: 0.63203125 },
//     ł: { height: 100, width: 13.3046875, ratio: 0.133046875 },
//     Ź: { height: 100, width: 55.703125, ratio: 0.55703125 },
//     ś: { height: 100, width: 19.203125, ratio: 0.19203125 },
//     '®': { height: 100, width: 30.90625, ratio: 0.3090625 },
//     š: { height: 100, width: 19.203125, ratio: 0.19203125 },
//     Ł: { height: 100, width: 46.203125, ratio: 0.46203125 },
//     ļ: { height: 100, width: 13.3046875, ratio: 0.133046875 },
//     '*': { height: 100, width: 20.90625, ratio: 0.2090625 },
//     ' ': { height: 0, width: 0, ratio: null },
//     ż: { height: 100, width: 24.3046875, ratio: 0.243046875 },
//     Ž: { height: 100, width: 55.703125, ratio: 0.55703125 },
//     Ū: { height: 100, width: 74.1015625, ratio: 0.741015625 },
//     '—': { height: 100, width: 34.90625, ratio: 0.3490625 },
//     '÷': { height: 100, width: 17.703125, ratio: 0.17703125 },
//     ų: { height: 100, width: 28.203125, ratio: 0.28203125 },
//     Ų: { height: 100, width: 74.1015625, ratio: 0.741015625 },
//     '’': { height: 100, width: 17, ratio: 0.17 },
//     '‚': { height: 100, width: 6.6015625, ratio: 0.066015625 },
//     '>': { height: 100, width: 14.90625, ratio: 0.1490625 },
//     '<': { height: 100, width: 14.8046875, ratio: 0.148046875 },
//     Ŕ: { height: 100, width: 74, ratio: 0.74 },
//     '&nbsp;': { height: 100, width: 16, ratio: 0.16 },
//   },
//   'Like.ttf': {
//     '0': { height: 100, width: 54.40625, ratio: 0.5440625 },
//     '1': { height: 100, width: 25.90625, ratio: 0.2590625 },
//     '2': { height: 100, width: 43.703125, ratio: 0.43703125 },
//     '3': { height: 100, width: 41.3046875, ratio: 0.413046875 },
//     '4': { height: 100, width: 37.703125, ratio: 0.37703125 },
//     '5': { height: 100, width: 40.6015625, ratio: 0.406015625 },
//     '6': { height: 100, width: 42.1015625, ratio: 0.421015625 },
//     '7': { height: 100, width: 37.40625, ratio: 0.3740625 },
//     '8': { height: 100, width: 37.5, ratio: 0.375 },
//     '9': { height: 100, width: 39.8046875, ratio: 0.398046875 },
//     '§': { height: 100, width: 50, ratio: 0.5 },
//     "'": { height: 100, width: 19, ratio: 0.19 },
//     '"': { height: 100, width: 26.8046875, ratio: 0.268046875 },
//     '+': { height: 100, width: 40.8046875, ratio: 0.408046875 },
//     '!': { height: 100, width: 33.703125, ratio: 0.33703125 },
//     '%': { height: 100, width: 65.5, ratio: 0.655 },
//     '/': { height: 100, width: 35.3046875, ratio: 0.353046875 },
//     '=': { height: 100, width: 37.3046875, ratio: 0.373046875 },
//     '(': { height: 100, width: 33.6015625, ratio: 0.336015625 },
//     ')': { height: 100, width: 30, ratio: 0.3 },
//     Ö: { height: 100, width: 75.1015625, ratio: 0.751015625 },
//     Ü: { height: 100, width: 75.90625, ratio: 0.7590625 },
//     Ó: { height: 100, width: 75.1015625, ratio: 0.751015625 },
//     Ú: { height: 100, width: 75.90625, ratio: 0.7590625 },
//     Ő: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     P: { height: 100, width: 75.1015625, ratio: 0.751015625 },
//     O: { height: 100, width: 75.1015625, ratio: 0.751015625 },
//     I: { height: 100, width: 66.5, ratio: 0.665 },
//     U: { height: 100, width: 75.90625, ratio: 0.7590625 },
//     Z: { height: 100, width: 105.3046875, ratio: 1.053046875 },
//     T: { height: 100, width: 48.203125, ratio: 0.48203125 },
//     R: { height: 100, width: 72.8046875, ratio: 0.728046875 },
//     E: { height: 100, width: 71.40625, ratio: 0.7140625 },
//     W: { height: 100, width: 123, ratio: 1.23 },
//     Q: { height: 100, width: 86, ratio: 0.86 },
//     A: { height: 100, width: 98.8046875, ratio: 0.988046875 },
//     S: { height: 100, width: 62.203125, ratio: 0.62203125 },
//     D: { height: 100, width: 100.6015625, ratio: 1.006015625 },
//     F: { height: 100, width: 74.90625, ratio: 0.7490625 },
//     G: { height: 100, width: 108.703125, ratio: 1.08703125 },
//     H: { height: 100, width: 99.5, ratio: 0.995 },
//     J: { height: 100, width: 85, ratio: 0.85 },
//     K: { height: 100, width: 70.90625, ratio: 0.7090625 },
//     L: { height: 100, width: 60.1015625, ratio: 0.601015625 },
//     É: { height: 100, width: 71.40625, ratio: 0.7140625 },
//     Á: { height: 100, width: 98.8046875, ratio: 0.988046875 },
//     Ű: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     _: { height: 100, width: 42.203125, ratio: 0.42203125 },
//     ':': { height: 100, width: 28.40625, ratio: 0.2840625 },
//     '?': { height: 100, width: 43, ratio: 0.43 },
//     M: { height: 100, width: 107.40625, ratio: 1.0740625 },
//     N: { height: 100, width: 94.40625, ratio: 0.9440625 },
//     B: { height: 100, width: 74.3046875, ratio: 0.743046875 },
//     V: { height: 100, width: 96.3046875, ratio: 0.963046875 },
//     C: { height: 100, width: 129.3046875, ratio: 1.293046875 },
//     X: { height: 100, width: 100.8046875, ratio: 1.008046875 },
//     Y: { height: 100, width: 70.1015625, ratio: 0.701015625 },
//     Í: { height: 100, width: 66.5, ratio: 0.665 },
//     ö: { height: 100, width: 20.90625, ratio: 0.2090625 },
//     ü: { height: 100, width: 46.703125, ratio: 0.46703125 },
//     ó: { height: 100, width: 20.90625, ratio: 0.2090625 },
//     ú: { height: 100, width: 46.703125, ratio: 0.46703125 },
//     ő: { height: 100, width: 50, ratio: 0.5 },
//     p: { height: 100, width: 50.703125, ratio: 0.50703125 },
//     o: { height: 100, width: 20.90625, ratio: 0.2090625 },
//     i: { height: 100, width: 26.90625, ratio: 0.2690625 },
//     u: { height: 100, width: 46.703125, ratio: 0.46703125 },
//     z: { height: 100, width: 44.1015625, ratio: 0.441015625 },
//     t: { height: 100, width: 14.6015625, ratio: 0.146015625 },
//     r: { height: 100, width: 34.6015625, ratio: 0.346015625 },
//     e: { height: 100, width: 31.8046875, ratio: 0.318046875 },
//     w: { height: 100, width: 63.703125, ratio: 0.63703125 },
//     q: { height: 100, width: 36.6015625, ratio: 0.366015625 },
//     a: { height: 100, width: 41, ratio: 0.41 },
//     s: { height: 100, width: 36.6015625, ratio: 0.366015625 },
//     d: { height: 100, width: 48.703125, ratio: 0.48703125 },
//     f: { height: 100, width: 17.703125, ratio: 0.17703125 },
//     g: { height: 100, width: 38.6015625, ratio: 0.386015625 },
//     h: { height: 100, width: 46.90625, ratio: 0.4690625 },
//     j: { height: 100, width: 26.40625, ratio: 0.2640625 },
//     k: { height: 100, width: 44.1015625, ratio: 0.441015625 },
//     l: { height: 100, width: 38.5, ratio: 0.385 },
//     é: { height: 100, width: 31.8046875, ratio: 0.318046875 },
//     á: { height: 100, width: 41, ratio: 0.41 },
//     ű: { height: 100, width: 50, ratio: 0.5 },
//     '-': { height: 100, width: 34.90625, ratio: 0.3490625 },
//     '.': { height: 100, width: 23.5, ratio: 0.235 },
//     ',': { height: 100, width: 14.6015625, ratio: 0.146015625 },
//     m: { height: 100, width: 64.1015625, ratio: 0.641015625 },
//     n: { height: 100, width: 38.8046875, ratio: 0.388046875 },
//     b: { height: 100, width: 36.8046875, ratio: 0.368046875 },
//     v: { height: 100, width: 41.90625, ratio: 0.4190625 },
//     c: { height: 100, width: 43.5, ratio: 0.435 },
//     x: { height: 100, width: 39.3046875, ratio: 0.393046875 },
//     y: { height: 100, width: 54.1015625, ratio: 0.541015625 },
//     í: { height: 100, width: 26.90625, ratio: 0.2690625 },
//     '¬': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '&': { height: 100, width: 43.8046875, ratio: 0.438046875 },
//     '™': { height: 100, width: 98, ratio: 0.98 },
//     '£': { height: 100, width: 50, ratio: 0.5 },
//     $: { height: 100, width: 51.40625, ratio: 0.5140625 },
//     '‹': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '›': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '{': { height: 100, width: 41.8046875, ratio: 0.418046875 },
//     '[': { height: 100, width: 31.703125, ratio: 0.31703125 },
//     ']': { height: 100, width: 33.703125, ratio: 0.33703125 },
//     '}': { height: 100, width: 32.5, ratio: 0.325 },
//     '≠': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     '~': { height: 100, width: 46.203125, ratio: 0.46203125 },
//     '¨': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ļ: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ņ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '^': { height: 100, width: 28.40625, ratio: 0.2840625 },
//     ź: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '†': { height: 100, width: 50, ratio: 0.5 },
//     '¶': { height: 100, width: 45.3125, ratio: 0.453125 },
//     '€': { height: 100, width: 74.4140625, ratio: 0.744140625 },
//     ę: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '@': { height: 100, width: 91.3046875, ratio: 0.913046875 },
//     ą: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ß: { height: 100, width: 36.6015625, ratio: 0.366015625 },
//     '∂': { height: 100, width: 49.4140625, ratio: 0.494140625 },
//     ń: { height: 100, width: 50, ratio: 0.5 },
//     '©': { height: 100, width: 75.9765625, ratio: 0.759765625 },
//     ķ: { height: 100, width: 50, ratio: 0.5 },
//     '∆': { height: 100, width: 61.1875, ratio: 0.611875 },
//     Ż: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     '•': { height: 100, width: 35.015625, ratio: 0.35015625 },
//     '…': { height: 100, width: 100, ratio: 1 },
//     '–': { height: 100, width: 50, ratio: 0.5 },
//     ';': { height: 100, width: 26.8046875, ratio: 0.268046875 },
//     Ķ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '”': { height: 100, width: 26.8046875, ratio: 0.268046875 },
//     '„': { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ć: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '»': { height: 100, width: 50, ratio: 0.5 },
//     '«': { height: 100, width: 50, ratio: 0.5 },
//     '|': { height: 100, width: 26.3046875, ratio: 0.263046875 },
//     ŕ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ř: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '#': { height: 100, width: 58.5, ratio: 0.585 },
//     ř: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ŗ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     ŗ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '°': { height: 100, width: 39.9921875, ratio: 0.399921875 },
//     ī: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ī: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ý: { height: 100, width: 54.1015625, ratio: 0.541015625 },
//     Ý: { height: 100, width: 70.1015625, ratio: 0.701015625 },
//     ł: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ź: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ś: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     '®': { height: 100, width: 75.9765625, ratio: 0.759765625 },
//     š: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     Ł: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ļ: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '*': { height: 100, width: 26, ratio: 0.26 },
//     ' ': { height: 0, width: 0, ratio: null },
//     ż: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     Ž: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ū: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '—': { height: 100, width: 100, ratio: 1 },
//     '÷': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     ų: { height: 100, width: 50, ratio: 0.5 },
//     Ų: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '’': { height: 100, width: 19, ratio: 0.19 },
//     '‚': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '>': { height: 100, width: 32.5, ratio: 0.325 },
//     '<': { height: 100, width: 39.1015625, ratio: 0.391015625 },
//     Ŕ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '&nbsp;': { height: 100, width: 34.90625, ratio: 0.3490625 },
//   },
//   'Love Island.ttf': {
//     '0': { height: 100, width: 47, ratio: 0.47 },
//     '1': { height: 100, width: 24, ratio: 0.24 },
//     '2': { height: 100, width: 47, ratio: 0.47 },
//     '3': { height: 100, width: 47, ratio: 0.47 },
//     '4': { height: 100, width: 47, ratio: 0.47 },
//     '5': { height: 100, width: 47, ratio: 0.47 },
//     '6': { height: 100, width: 47, ratio: 0.47 },
//     '7': { height: 100, width: 47, ratio: 0.47 },
//     '8': { height: 100, width: 47, ratio: 0.47 },
//     '9': { height: 100, width: 47, ratio: 0.47 },
//     '§': { height: 100, width: 40, ratio: 0.4 },
//     "'": { height: 100, width: 17, ratio: 0.17 },
//     '"': { height: 100, width: 29, ratio: 0.29 },
//     '+': { height: 100, width: 38, ratio: 0.38 },
//     '!': { height: 100, width: 22, ratio: 0.22 },
//     '%': { height: 100, width: 82, ratio: 0.82 },
//     '/': { height: 100, width: 37, ratio: 0.37 },
//     '=': { height: 100, width: 48, ratio: 0.48 },
//     '(': { height: 100, width: 29, ratio: 0.29 },
//     ')': { height: 100, width: 33, ratio: 0.33 },
//     Ö: { height: 100, width: 55, ratio: 0.55 },
//     Ü: { height: 100, width: 48, ratio: 0.48 },
//     Ó: { height: 100, width: 55, ratio: 0.55 },
//     Ú: { height: 100, width: 48, ratio: 0.48 },
//     Ő: { height: 100, width: 55, ratio: 0.55 },
//     P: { height: 100, width: 48, ratio: 0.48 },
//     O: { height: 100, width: 55, ratio: 0.55 },
//     I: { height: 100, width: 24, ratio: 0.24 },
//     U: { height: 100, width: 48, ratio: 0.48 },
//     Z: { height: 100, width: 50, ratio: 0.5 },
//     T: { height: 100, width: 46, ratio: 0.46 },
//     R: { height: 100, width: 56, ratio: 0.56 },
//     E: { height: 100, width: 47, ratio: 0.47 },
//     W: { height: 100, width: 79, ratio: 0.79 },
//     Q: { height: 100, width: 60, ratio: 0.6 },
//     A: { height: 100, width: 50, ratio: 0.5 },
//     S: { height: 100, width: 47, ratio: 0.47 },
//     D: { height: 100, width: 48, ratio: 0.48 },
//     F: { height: 100, width: 47, ratio: 0.47 },
//     G: { height: 100, width: 48, ratio: 0.48 },
//     H: { height: 100, width: 52, ratio: 0.52 },
//     J: { height: 100, width: 48, ratio: 0.48 },
//     K: { height: 100, width: 51, ratio: 0.51 },
//     L: { height: 100, width: 40, ratio: 0.4 },
//     É: { height: 100, width: 47, ratio: 0.47 },
//     Á: { height: 100, width: 50, ratio: 0.5 },
//     Ű: { height: 100, width: 48, ratio: 0.48 },
//     _: { height: 100, width: 47, ratio: 0.47 },
//     ':': { height: 100, width: 23, ratio: 0.23 },
//     '?': { height: 100, width: 35, ratio: 0.35 },
//     M: { height: 100, width: 59, ratio: 0.59 },
//     N: { height: 100, width: 56, ratio: 0.56 },
//     B: { height: 100, width: 48, ratio: 0.48 },
//     V: { height: 100, width: 52, ratio: 0.52 },
//     C: { height: 100, width: 45, ratio: 0.45 },
//     X: { height: 100, width: 53, ratio: 0.53 },
//     Y: { height: 100, width: 48, ratio: 0.48 },
//     Í: { height: 100, width: 24, ratio: 0.24 },
//     ö: { height: 100, width: 43, ratio: 0.43 },
//     ü: { height: 100, width: 56, ratio: 0.56 },
//     ó: { height: 100, width: 43, ratio: 0.43 },
//     ú: { height: 100, width: 56, ratio: 0.56 },
//     ő: { height: 100, width: 43, ratio: 0.43 },
//     p: { height: 100, width: 53, ratio: 0.53 },
//     o: { height: 100, width: 43, ratio: 0.43 },
//     i: { height: 100, width: 29, ratio: 0.29 },
//     u: { height: 100, width: 56, ratio: 0.56 },
//     z: { height: 100, width: 49, ratio: 0.49 },
//     t: { height: 100, width: 40, ratio: 0.4 },
//     r: { height: 100, width: 52, ratio: 0.52 },
//     e: { height: 100, width: 39, ratio: 0.39 },
//     w: { height: 100, width: 76, ratio: 0.76 },
//     q: { height: 100, width: 41, ratio: 0.41 },
//     a: { height: 100, width: 44, ratio: 0.44 },
//     s: { height: 100, width: 55, ratio: 0.55 },
//     d: { height: 100, width: 49, ratio: 0.49 },
//     f: { height: 100, width: 40, ratio: 0.4 },
//     g: { height: 100, width: 37, ratio: 0.37 },
//     h: { height: 100, width: 46, ratio: 0.46 },
//     j: { height: 100, width: 42, ratio: 0.42 },
//     k: { height: 100, width: 47, ratio: 0.47 },
//     l: { height: 100, width: 41, ratio: 0.41 },
//     é: { height: 100, width: 39, ratio: 0.39 },
//     á: { height: 100, width: 44, ratio: 0.44 },
//     ű: { height: 100, width: 56, ratio: 0.56 },
//     '-': { height: 100, width: 32, ratio: 0.32 },
//     '.': { height: 100, width: 23, ratio: 0.23 },
//     ',': { height: 100, width: 23, ratio: 0.23 },
//     m: { height: 100, width: 110, ratio: 1.1 },
//     n: { height: 100, width: 59, ratio: 0.59 },
//     b: { height: 100, width: 41, ratio: 0.41 },
//     v: { height: 100, width: 52, ratio: 0.52 },
//     c: { height: 100, width: 40, ratio: 0.4 },
//     x: { height: 100, width: 50, ratio: 0.5 },
//     y: { height: 100, width: 61, ratio: 0.61 },
//     í: { height: 100, width: 29, ratio: 0.29 },
//     '¬': { height: 100, width: 41, ratio: 0.41 },
//     '&': { height: 100, width: 47, ratio: 0.47 },
//     '™': { height: 100, width: 106, ratio: 1.06 },
//     '£': { height: 100, width: 57, ratio: 0.57 },
//     $: { height: 100, width: 47, ratio: 0.47 },
//     '‹': { height: 100, width: 39, ratio: 0.39 },
//     '›': { height: 100, width: 41, ratio: 0.41 },
//     '{': { height: 100, width: 34, ratio: 0.34 },
//     '[': { height: 100, width: 40, ratio: 0.4 },
//     ']': { height: 100, width: 40, ratio: 0.4 },
//     '}': { height: 100, width: 34, ratio: 0.34 },
//     '≠': { height: 100, width: 48, ratio: 0.48 },
//     '~': { height: 100, width: 40, ratio: 0.4 },
//     '¨': { height: 100, width: 42, ratio: 0.42 },
//     Ļ: { height: 100, width: 40, ratio: 0.4 },
//     Ņ: { height: 100, width: 56, ratio: 0.56 },
//     '^': { height: 100, width: 37, ratio: 0.37 },
//     ź: { height: 100, width: 49, ratio: 0.49 },
//     '†': { height: 100, width: 48, ratio: 0.48 },
//     '¶': { height: 100, width: 43, ratio: 0.43 },
//     '€': { height: 100, width: 60, ratio: 0.6 },
//     ę: { height: 100, width: 39, ratio: 0.39 },
//     '@': { height: 100, width: 61, ratio: 0.61 },
//     ą: { height: 100, width: 50, ratio: 0.5 },
//     ß: { height: 100, width: 46, ratio: 0.46 },
//     '∂': { height: 100, width: 43, ratio: 0.43 },
//     ń: { height: 100, width: 59, ratio: 0.59 },
//     '©': { height: 100, width: 63, ratio: 0.63 },
//     ķ: { height: 100, width: 47, ratio: 0.47 },
//     '∆': { height: 100, width: 50, ratio: 0.5 },
//     Ż: { height: 100, width: 50, ratio: 0.5 },
//     '•': { height: 100, width: 48, ratio: 0.48 },
//     '…': { height: 100, width: 56, ratio: 0.56 },
//     '–': { height: 100, width: 67, ratio: 0.67 },
//     ';': { height: 100, width: 24, ratio: 0.24 },
//     Ķ: { height: 100, width: 51, ratio: 0.51 },
//     '”': { height: 100, width: 39, ratio: 0.39 },
//     '„': { height: 100, width: 37, ratio: 0.37 },
//     ć: { height: 100, width: 40, ratio: 0.4 },
//     '»': { height: 100, width: 68, ratio: 0.68 },
//     '«': { height: 100, width: 64, ratio: 0.64 },
//     '|': { height: 100, width: 17, ratio: 0.17 },
//     ŕ: { height: 100, width: 52, ratio: 0.52 },
//     Ř: { height: 100, width: 56, ratio: 0.56 },
//     '#': { height: 100, width: 48, ratio: 0.48 },
//     ř: { height: 100, width: 52, ratio: 0.52 },
//     Ŗ: { height: 100, width: 56, ratio: 0.56 },
//     ŗ: { height: 100, width: 52, ratio: 0.52 },
//     '°': { height: 100, width: 30, ratio: 0.3 },
//     ī: { height: 100, width: 29, ratio: 0.29 },
//     Ī: { height: 100, width: 24, ratio: 0.24 },
//     ý: { height: 100, width: 61, ratio: 0.61 },
//     Ý: { height: 100, width: 48, ratio: 0.48 },
//     ł: { height: 100, width: 41, ratio: 0.41 },
//     Ź: { height: 100, width: 50, ratio: 0.5 },
//     ś: { height: 100, width: 55, ratio: 0.55 },
//     '®': { height: 100, width: 64, ratio: 0.64 },
//     š: { height: 100, width: 55, ratio: 0.55 },
//     Ł: { height: 100, width: 53, ratio: 0.53 },
//     ļ: { height: 100, width: 41, ratio: 0.41 },
//     '*': { height: 100, width: 47, ratio: 0.47 },
//     ' ': { height: 0, width: 0, ratio: null },
//     ż: { height: 100, width: 49, ratio: 0.49 },
//     Ž: { height: 100, width: 50, ratio: 0.5 },
//     Ū: { height: 100, width: 48, ratio: 0.48 },
//     '—': { height: 100, width: 120, ratio: 1.2 },
//     '÷': { height: 100, width: 47, ratio: 0.47 },
//     ų: { height: 100, width: 56, ratio: 0.56 },
//     Ų: { height: 100, width: 57, ratio: 0.57 },
//     '’': { height: 100, width: 26, ratio: 0.26 },
//     '‚': { height: 100, width: 23, ratio: 0.23 },
//     '>': { height: 100, width: 48, ratio: 0.48 },
//     '<': { height: 100, width: 46, ratio: 0.46 },
//     Ŕ: { height: 100, width: 56, ratio: 0.56 },
//     '&nbsp;': { height: 100, width: 40, ratio: 0.4 },
//   },
//   'Love.ttf': {
//     '0': { height: 100, width: 59.203125, ratio: 0.59203125 },
//     '1': { height: 100, width: 21, ratio: 0.21 },
//     '2': { height: 100, width: 49.90625, ratio: 0.4990625 },
//     '3': { height: 100, width: 45.90625, ratio: 0.4590625 },
//     '4': { height: 100, width: 44.90625, ratio: 0.4490625 },
//     '5': { height: 100, width: 49.40625, ratio: 0.4940625 },
//     '6': { height: 100, width: 52.90625, ratio: 0.5290625 },
//     '7': { height: 100, width: 43.6015625, ratio: 0.436015625 },
//     '8': { height: 100, width: 51.5, ratio: 0.515 },
//     '9': { height: 100, width: 52.703125, ratio: 0.52703125 },
//     '§': { height: 100, width: 50, ratio: 0.5 },
//     "'": { height: 100, width: 20.5, ratio: 0.205 },
//     '"': { height: 100, width: 32.5, ratio: 0.325 },
//     '+': { height: 100, width: 37.703125, ratio: 0.37703125 },
//     '!': { height: 100, width: 24.703125, ratio: 0.24703125 },
//     '%': { height: 100, width: 52.1015625, ratio: 0.521015625 },
//     '/': { height: 100, width: 37.40625, ratio: 0.3740625 },
//     '=': { height: 100, width: 57.40625, ratio: 0.5740625 },
//     '(': { height: 100, width: 43.90625, ratio: 0.4390625 },
//     ')': { height: 100, width: 43.90625, ratio: 0.4390625 },
//     Ö: { height: 100, width: 76.703125, ratio: 0.76703125 },
//     Ü: { height: 100, width: 67.3046875, ratio: 0.673046875 },
//     Ó: { height: 100, width: 76.703125, ratio: 0.76703125 },
//     Ú: { height: 100, width: 67.3046875, ratio: 0.673046875 },
//     Ő: { height: 100, width: 76.703125, ratio: 0.76703125 },
//     P: { height: 100, width: 56.40625, ratio: 0.5640625 },
//     O: { height: 100, width: 81.703125, ratio: 0.81703125 },
//     I: { height: 100, width: 55, ratio: 0.55 },
//     U: { height: 100, width: 71.90625, ratio: 0.7190625 },
//     Z: { height: 100, width: 61.1015625, ratio: 0.611015625 },
//     T: { height: 100, width: 51.90625, ratio: 0.5190625 },
//     R: { height: 100, width: 58.5, ratio: 0.585 },
//     E: { height: 100, width: 55.1015625, ratio: 0.551015625 },
//     W: { height: 100, width: 90.40625, ratio: 0.9040625 },
//     Q: { height: 100, width: 81.8046875, ratio: 0.818046875 },
//     A: { height: 100, width: 60.1015625, ratio: 0.601015625 },
//     S: { height: 100, width: 51.1015625, ratio: 0.511015625 },
//     D: { height: 100, width: 59.90625, ratio: 0.5990625 },
//     F: { height: 100, width: 53.703125, ratio: 0.53703125 },
//     G: { height: 100, width: 62.90625, ratio: 0.6290625 },
//     H: { height: 100, width: 63.5, ratio: 0.635 },
//     J: { height: 100, width: 49.203125, ratio: 0.49203125 },
//     K: { height: 100, width: 59.5, ratio: 0.595 },
//     L: { height: 100, width: 54.5, ratio: 0.545 },
//     É: { height: 100, width: 51.5, ratio: 0.515 },
//     Á: { height: 100, width: 57.1015625, ratio: 0.571015625 },
//     Ű: { height: 100, width: 67.3046875, ratio: 0.673046875 },
//     _: { height: 100, width: 86.6015625, ratio: 0.866015625 },
//     ':': { height: 100, width: 22.90625, ratio: 0.2290625 },
//     '?': { height: 100, width: 37.6015625, ratio: 0.376015625 },
//     M: { height: 100, width: 67.6015625, ratio: 0.676015625 },
//     N: { height: 100, width: 68.6015625, ratio: 0.686015625 },
//     B: { height: 100, width: 60.90625, ratio: 0.6090625 },
//     V: { height: 100, width: 60.203125, ratio: 0.60203125 },
//     C: { height: 100, width: 61.6015625, ratio: 0.616015625 },
//     X: { height: 100, width: 61.703125, ratio: 0.61703125 },
//     Y: { height: 100, width: 60.5, ratio: 0.605 },
//     Í: { height: 100, width: 51.203125, ratio: 0.51203125 },
//     ö: { height: 100, width: 76.703125, ratio: 0.76703125 },
//     ü: { height: 100, width: 67.3046875, ratio: 0.673046875 },
//     ó: { height: 100, width: 76.703125, ratio: 0.76703125 },
//     ú: { height: 100, width: 67.3046875, ratio: 0.673046875 },
//     ő: { height: 100, width: 76.703125, ratio: 0.76703125 },
//     p: { height: 100, width: 56.40625, ratio: 0.5640625 },
//     o: { height: 100, width: 81.703125, ratio: 0.81703125 },
//     i: { height: 100, width: 55, ratio: 0.55 },
//     u: { height: 100, width: 71.90625, ratio: 0.7190625 },
//     z: { height: 100, width: 61.1015625, ratio: 0.611015625 },
//     t: { height: 100, width: 51.90625, ratio: 0.5190625 },
//     r: { height: 100, width: 58.5, ratio: 0.585 },
//     e: { height: 100, width: 55.1015625, ratio: 0.551015625 },
//     w: { height: 100, width: 90.40625, ratio: 0.9040625 },
//     q: { height: 100, width: 81.8046875, ratio: 0.818046875 },
//     a: { height: 100, width: 60.1015625, ratio: 0.601015625 },
//     s: { height: 100, width: 51.1015625, ratio: 0.511015625 },
//     d: { height: 100, width: 59.90625, ratio: 0.5990625 },
//     f: { height: 100, width: 53.703125, ratio: 0.53703125 },
//     g: { height: 100, width: 62.90625, ratio: 0.6290625 },
//     h: { height: 100, width: 63.5, ratio: 0.635 },
//     j: { height: 100, width: 49.203125, ratio: 0.49203125 },
//     k: { height: 100, width: 59.5, ratio: 0.595 },
//     l: { height: 100, width: 54.5, ratio: 0.545 },
//     é: { height: 100, width: 51.5, ratio: 0.515 },
//     á: { height: 100, width: 57.1015625, ratio: 0.571015625 },
//     ű: { height: 100, width: 67.3046875, ratio: 0.673046875 },
//     '-': { height: 100, width: 36.703125, ratio: 0.36703125 },
//     '.': { height: 100, width: 17.203125, ratio: 0.17203125 },
//     ',': { height: 100, width: 22.1015625, ratio: 0.221015625 },
//     m: { height: 100, width: 67.6015625, ratio: 0.676015625 },
//     n: { height: 100, width: 68.6015625, ratio: 0.686015625 },
//     b: { height: 100, width: 60.90625, ratio: 0.6090625 },
//     v: { height: 100, width: 60.203125, ratio: 0.60203125 },
//     c: { height: 100, width: 61.6015625, ratio: 0.616015625 },
//     x: { height: 100, width: 61.703125, ratio: 0.61703125 },
//     y: { height: 100, width: 60.5, ratio: 0.605 },
//     í: { height: 100, width: 51.203125, ratio: 0.51203125 },
//     '¬': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '&': { height: 100, width: 24.8046875, ratio: 0.248046875 },
//     '™': { height: 100, width: 98, ratio: 0.98 },
//     '£': { height: 100, width: 55.3046875, ratio: 0.553046875 },
//     $: { height: 100, width: 49.3046875, ratio: 0.493046875 },
//     '‹': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '›': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '{': { height: 100, width: 118.703125, ratio: 1.18703125 },
//     '[': { height: 100, width: 81.1015625, ratio: 0.811015625 },
//     ']': { height: 100, width: 81.203125, ratio: 0.81203125 },
//     '}': { height: 100, width: 118.703125, ratio: 1.18703125 },
//     '≠': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     '~': { height: 100, width: 53.6015625, ratio: 0.536015625 },
//     '¨': { height: 100, width: 32.3046875, ratio: 0.323046875 },
//     Ļ: { height: 100, width: 52.90625, ratio: 0.5290625 },
//     Ņ: { height: 100, width: 64.203125, ratio: 0.64203125 },
//     '^': { height: 100, width: 57.1015625, ratio: 0.571015625 },
//     ź: { height: 100, width: 58.3046875, ratio: 0.583046875 },
//     '†': { height: 100, width: 50, ratio: 0.5 },
//     '¶': { height: 100, width: 45.3125, ratio: 0.453125 },
//     '€': { height: 100, width: 65.3046875, ratio: 0.653046875 },
//     ę: { height: 100, width: 53.5, ratio: 0.535 },
//     '@': { height: 100, width: 81.703125, ratio: 0.81703125 },
//     ą: { height: 100, width: 59.1015625, ratio: 0.591015625 },
//     ß: { height: 100, width: 46.40625, ratio: 0.4640625 },
//     '∂': { height: 100, width: 49.4140625, ratio: 0.494140625 },
//     ń: { height: 100, width: 60.3046875, ratio: 0.603046875 },
//     '©': { height: 100, width: 81.703125, ratio: 0.81703125 },
//     ķ: { height: 100, width: 54.40625, ratio: 0.5440625 },
//     '∆': { height: 100, width: 61.1875, ratio: 0.611875 },
//     Ż: { height: 100, width: 58.3046875, ratio: 0.583046875 },
//     '•': { height: 100, width: 35.015625, ratio: 0.35015625 },
//     '…': { height: 100, width: 100, ratio: 1 },
//     '–': { height: 100, width: 50, ratio: 0.5 },
//     ';': { height: 100, width: 22, ratio: 0.22 },
//     Ķ: { height: 100, width: 54.40625, ratio: 0.5440625 },
//     '”': { height: 100, width: 38.203125, ratio: 0.38203125 },
//     '„': { height: 100, width: 38.1015625, ratio: 0.381015625 },
//     ć: { height: 100, width: 57.1015625, ratio: 0.571015625 },
//     '»': { height: 100, width: 50, ratio: 0.5 },
//     '«': { height: 100, width: 50, ratio: 0.5 },
//     '|': { height: 100, width: 86.40625, ratio: 0.8640625 },
//     ŕ: { height: 100, width: 52, ratio: 0.52 },
//     Ř: { height: 100, width: 52, ratio: 0.52 },
//     '#': { height: 100, width: 81.703125, ratio: 0.81703125 },
//     ř: { height: 100, width: 52, ratio: 0.52 },
//     Ŗ: { height: 100, width: 55.3046875, ratio: 0.553046875 },
//     ŗ: { height: 100, width: 55.3046875, ratio: 0.553046875 },
//     '°': { height: 100, width: 39.9921875, ratio: 0.399921875 },
//     ī: { height: 100, width: 51.203125, ratio: 0.51203125 },
//     Ī: { height: 100, width: 51.203125, ratio: 0.51203125 },
//     ý: { height: 100, width: 57.90625, ratio: 0.5790625 },
//     Ý: { height: 100, width: 57.90625, ratio: 0.5790625 },
//     ł: { height: 100, width: 51.203125, ratio: 0.51203125 },
//     Ź: { height: 100, width: 58.3046875, ratio: 0.583046875 },
//     ś: { height: 100, width: 45.40625, ratio: 0.4540625 },
//     '®': { height: 100, width: 81.703125, ratio: 0.81703125 },
//     š: { height: 100, width: 45.40625, ratio: 0.4540625 },
//     Ł: { height: 100, width: 51.203125, ratio: 0.51203125 },
//     ļ: { height: 100, width: 52.90625, ratio: 0.5290625 },
//     '*': { height: 100, width: 86.5, ratio: 0.865 },
//     ' ': { height: 0, width: 0, ratio: null },
//     ż: { height: 100, width: 58.3046875, ratio: 0.583046875 },
//     Ž: { height: 100, width: 58.3046875, ratio: 0.583046875 },
//     Ū: { height: 100, width: 67.3046875, ratio: 0.673046875 },
//     '—': { height: 100, width: 100, ratio: 1 },
//     '÷': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     ų: { height: 100, width: 69.5, ratio: 0.695 },
//     Ų: { height: 100, width: 69.5, ratio: 0.695 },
//     '’': { height: 100, width: 22.203125, ratio: 0.22203125 },
//     '‚': { height: 100, width: 22.1015625, ratio: 0.221015625 },
//     '>': { height: 100, width: 43.3046875, ratio: 0.433046875 },
//     '<': { height: 100, width: 43.3046875, ratio: 0.433046875 },
//     Ŕ: { height: 100, width: 52, ratio: 0.52 },
//     '&nbsp;': { height: 100, width: 27.1015625, ratio: 0.271015625 },
//   },
//   'Midnight Champion.ttf': {
//     '0': { height: 100, width: 39.0625, ratio: 0.390625 },
//     '1': { height: 100, width: 24.4140625, ratio: 0.244140625 },
//     '2': { height: 100, width: 39.0625, ratio: 0.390625 },
//     '3': { height: 100, width: 39.0625, ratio: 0.390625 },
//     '4': { height: 100, width: 39.0625, ratio: 0.390625 },
//     '5': { height: 100, width: 39.0625, ratio: 0.390625 },
//     '6': { height: 100, width: 39.0625, ratio: 0.390625 },
//     '7': { height: 100, width: 34.1796875, ratio: 0.341796875 },
//     '8': { height: 100, width: 39.0625, ratio: 0.390625 },
//     '9': { height: 100, width: 39.0625, ratio: 0.390625 },
//     '§': { height: 100, width: 50, ratio: 0.5 },
//     "'": { height: 100, width: 14.6484375, ratio: 0.146484375 },
//     '"': { height: 100, width: 24.4140625, ratio: 0.244140625 },
//     '+': { height: 100, width: 29.296875, ratio: 0.29296875 },
//     '!': { height: 100, width: 14.6484375, ratio: 0.146484375 },
//     '%': { height: 100, width: 39.1171875, ratio: 0.391171875 },
//     '/': { height: 100, width: 39.0625, ratio: 0.390625 },
//     '=': { height: 100, width: 29.296875, ratio: 0.29296875 },
//     '(': { height: 100, width: 24.4140625, ratio: 0.244140625 },
//     ')': { height: 100, width: 24.4140625, ratio: 0.244140625 },
//     Ö: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ü: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ó: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ú: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ő: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     P: { height: 100, width: 39.0625, ratio: 0.390625 },
//     O: { height: 100, width: 78.125, ratio: 0.78125 },
//     I: { height: 100, width: 14.6484375, ratio: 0.146484375 },
//     U: { height: 100, width: 39.0625, ratio: 0.390625 },
//     Z: { height: 100, width: 34.1796875, ratio: 0.341796875 },
//     T: { height: 100, width: 34.1796875, ratio: 0.341796875 },
//     R: { height: 100, width: 39.0625, ratio: 0.390625 },
//     E: { height: 100, width: 34.1796875, ratio: 0.341796875 },
//     W: { height: 100, width: 68.359375, ratio: 0.68359375 },
//     Q: { height: 100, width: 78.125, ratio: 0.78125 },
//     A: { height: 100, width: 39.0625, ratio: 0.390625 },
//     S: { height: 100, width: 39.0625, ratio: 0.390625 },
//     D: { height: 100, width: 48.828125, ratio: 0.48828125 },
//     F: { height: 100, width: 34.1796875, ratio: 0.341796875 },
//     G: { height: 100, width: 48.828125, ratio: 0.48828125 },
//     H: { height: 100, width: 39.0625, ratio: 0.390625 },
//     J: { height: 100, width: 39.0625, ratio: 0.390625 },
//     K: { height: 100, width: 39.0625, ratio: 0.390625 },
//     L: { height: 100, width: 34.1796875, ratio: 0.341796875 },
//     É: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Á: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ű: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     _: { height: 100, width: 34.1796875, ratio: 0.341796875 },
//     ':': { height: 100, width: 14.6484375, ratio: 0.146484375 },
//     '?': { height: 100, width: 39.0625, ratio: 0.390625 },
//     M: { height: 100, width: 63.4765625, ratio: 0.634765625 },
//     N: { height: 100, width: 39.0625, ratio: 0.390625 },
//     B: { height: 100, width: 43.9453125, ratio: 0.439453125 },
//     V: { height: 100, width: 48.828125, ratio: 0.48828125 },
//     C: { height: 100, width: 78.125, ratio: 0.78125 },
//     X: { height: 100, width: 39.0625, ratio: 0.390625 },
//     Y: { height: 100, width: 39.0625, ratio: 0.390625 },
//     Í: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ö: { height: 100, width: 50, ratio: 0.5 },
//     ü: { height: 100, width: 50, ratio: 0.5 },
//     ó: { height: 100, width: 50, ratio: 0.5 },
//     ú: { height: 100, width: 50, ratio: 0.5 },
//     ő: { height: 100, width: 50, ratio: 0.5 },
//     p: { height: 100, width: 39.0625, ratio: 0.390625 },
//     o: { height: 100, width: 39.0625, ratio: 0.390625 },
//     i: { height: 100, width: 14.6484375, ratio: 0.146484375 },
//     u: { height: 100, width: 39.0625, ratio: 0.390625 },
//     z: { height: 100, width: 34.1796875, ratio: 0.341796875 },
//     t: { height: 100, width: 24.4140625, ratio: 0.244140625 },
//     r: { height: 100, width: 39.0625, ratio: 0.390625 },
//     e: { height: 100, width: 39.0625, ratio: 0.390625 },
//     w: { height: 100, width: 43.9453125, ratio: 0.439453125 },
//     q: { height: 100, width: 39.0625, ratio: 0.390625 },
//     a: { height: 100, width: 39.0625, ratio: 0.390625 },
//     s: { height: 100, width: 34.1796875, ratio: 0.341796875 },
//     d: { height: 100, width: 39.0625, ratio: 0.390625 },
//     f: { height: 100, width: 24.4140625, ratio: 0.244140625 },
//     g: { height: 100, width: 39.0625, ratio: 0.390625 },
//     h: { height: 100, width: 39.0625, ratio: 0.390625 },
//     j: { height: 100, width: 14.6484375, ratio: 0.146484375 },
//     k: { height: 100, width: 29.296875, ratio: 0.29296875 },
//     l: { height: 100, width: 14.6484375, ratio: 0.146484375 },
//     é: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     á: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ű: { height: 100, width: 50, ratio: 0.5 },
//     '-': { height: 100, width: 29.296875, ratio: 0.29296875 },
//     '.': { height: 100, width: 14.6484375, ratio: 0.146484375 },
//     ',': { height: 100, width: 14.6484375, ratio: 0.146484375 },
//     m: { height: 100, width: 63.4765625, ratio: 0.634765625 },
//     n: { height: 100, width: 39.0625, ratio: 0.390625 },
//     b: { height: 100, width: 39.0625, ratio: 0.390625 },
//     v: { height: 100, width: 29.296875, ratio: 0.29296875 },
//     c: { height: 100, width: 34.1796875, ratio: 0.341796875 },
//     x: { height: 100, width: 29.296875, ratio: 0.29296875 },
//     y: { height: 100, width: 39.0625, ratio: 0.390625 },
//     í: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '¬': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '&': { height: 100, width: 48.828125, ratio: 0.48828125 },
//     '™': { height: 100, width: 98, ratio: 0.98 },
//     '£': { height: 100, width: 50, ratio: 0.5 },
//     $: { height: 100, width: 39.0625, ratio: 0.390625 },
//     '‹': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '›': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '{': { height: 100, width: 34.1796875, ratio: 0.341796875 },
//     '[': { height: 100, width: 24.4140625, ratio: 0.244140625 },
//     ']': { height: 100, width: 24.4140625, ratio: 0.244140625 },
//     '}': { height: 100, width: 34.1796875, ratio: 0.341796875 },
//     '≠': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     '~': { height: 100, width: 29.296875, ratio: 0.29296875 },
//     '¨': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ļ: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ņ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '^': { height: 100, width: 14.6484375, ratio: 0.146484375 },
//     ź: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '†': { height: 100, width: 50, ratio: 0.5 },
//     '¶': { height: 100, width: 45.3125, ratio: 0.453125 },
//     '€': { height: 100, width: 74.4140625, ratio: 0.744140625 },
//     ę: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '@': { height: 100, width: 78.125, ratio: 0.78125 },
//     ą: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ß: { height: 100, width: 50, ratio: 0.5 },
//     '∂': { height: 100, width: 49.4140625, ratio: 0.494140625 },
//     ń: { height: 100, width: 50, ratio: 0.5 },
//     '©': { height: 100, width: 75.9765625, ratio: 0.759765625 },
//     ķ: { height: 100, width: 50, ratio: 0.5 },
//     '∆': { height: 100, width: 61.1875, ratio: 0.611875 },
//     Ż: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     '•': { height: 100, width: 35.015625, ratio: 0.35015625 },
//     '…': { height: 100, width: 100, ratio: 1 },
//     '–': { height: 100, width: 50, ratio: 0.5 },
//     ';': { height: 100, width: 14.6484375, ratio: 0.146484375 },
//     Ķ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '”': { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '„': { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ć: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '»': { height: 100, width: 50, ratio: 0.5 },
//     '«': { height: 100, width: 50, ratio: 0.5 },
//     '|': { height: 100, width: 14.6484375, ratio: 0.146484375 },
//     ŕ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ř: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '#': { height: 100, width: 39.0625, ratio: 0.390625 },
//     ř: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ŗ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     ŗ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '°': { height: 100, width: 39.9921875, ratio: 0.399921875 },
//     ī: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ī: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ý: { height: 100, width: 50, ratio: 0.5 },
//     Ý: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     ł: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ź: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ś: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     '®': { height: 100, width: 75.9765625, ratio: 0.759765625 },
//     š: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     Ł: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ļ: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '*': { height: 100, width: 29.296875, ratio: 0.29296875 },
//     ' ': { height: 0, width: 0, ratio: null },
//     ż: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     Ž: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ū: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '—': { height: 100, width: 100, ratio: 1 },
//     '÷': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     ų: { height: 100, width: 50, ratio: 0.5 },
//     Ų: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '’': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '‚': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '>': { height: 100, width: 39.0625, ratio: 0.390625 },
//     '<': { height: 100, width: 39.0625, ratio: 0.390625 },
//     Ŕ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '&nbsp;': { height: 100, width: 24.8046875, ratio: 0.248046875 },
//   },
//   'Notification.ttf': {
//     '0': { height: 100, width: 48.9296875, ratio: 0.489296875 },
//     '1': { height: 100, width: 29.0078125, ratio: 0.290078125 },
//     '2': { height: 100, width: 49.609375, ratio: 0.49609375 },
//     '3': { height: 100, width: 55.03125, ratio: 0.5503125 },
//     '4': { height: 100, width: 44.9765625, ratio: 0.449765625 },
//     '5': { height: 100, width: 51.2265625, ratio: 0.512265625 },
//     '6': { height: 100, width: 48.5859375, ratio: 0.485859375 },
//     '7': { height: 100, width: 39.359375, ratio: 0.39359375 },
//     '8': { height: 100, width: 43.0234375, ratio: 0.430234375 },
//     '9': { height: 100, width: 38.96875, ratio: 0.3896875 },
//     '§': { height: 100, width: 53.421875, ratio: 0.53421875 },
//     "'": { height: 100, width: 23.4375, ratio: 0.234375 },
//     '"': { height: 100, width: 31.7421875, ratio: 0.317421875 },
//     '+': { height: 100, width: 46.09375, ratio: 0.4609375 },
//     '!': { height: 100, width: 30.5703125, ratio: 0.305703125 },
//     '%': { height: 100, width: 49.8046875, ratio: 0.498046875 },
//     '/': { height: 100, width: 45.4140625, ratio: 0.454140625 },
//     '=': { height: 100, width: 36.0390625, ratio: 0.360390625 },
//     '(': { height: 100, width: 38.625, ratio: 0.38625 },
//     ')': { height: 100, width: 39.453125, ratio: 0.39453125 },
//     Ö: { height: 100, width: 121.9765625, ratio: 1.219765625 },
//     Ü: { height: 100, width: 69.6328125, ratio: 0.696328125 },
//     Ó: { height: 100, width: 121.9765625, ratio: 1.219765625 },
//     Ú: { height: 100, width: 69.6328125, ratio: 0.696328125 },
//     Ő: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     P: { height: 100, width: 78.2734375, ratio: 0.782734375 },
//     O: { height: 100, width: 121.9765625, ratio: 1.219765625 },
//     I: { height: 100, width: 49.7109375, ratio: 0.497109375 },
//     U: { height: 100, width: 69.6328125, ratio: 0.696328125 },
//     Z: { height: 100, width: 117.140625, ratio: 1.17140625 },
//     T: { height: 100, width: 76.6640625, ratio: 0.766640625 },
//     R: { height: 100, width: 80.375, ratio: 0.80375 },
//     E: { height: 100, width: 119.046875, ratio: 1.19046875 },
//     W: { height: 100, width: 127.0078125, ratio: 1.270078125 },
//     Q: { height: 100, width: 88.3359375, ratio: 0.883359375 },
//     A: { height: 100, width: 84.234375, ratio: 0.84234375 },
//     S: { height: 100, width: 93.359375, ratio: 0.93359375 },
//     D: { height: 100, width: 152.3984375, ratio: 1.523984375 },
//     F: { height: 100, width: 79.3984375, ratio: 0.793984375 },
//     G: { height: 100, width: 71.2890625, ratio: 0.712890625 },
//     H: { height: 100, width: 81.7421875, ratio: 0.817421875 },
//     J: { height: 100, width: 125.8828125, ratio: 1.258828125 },
//     K: { height: 100, width: 87.9453125, ratio: 0.879453125 },
//     L: { height: 100, width: 97.7109375, ratio: 0.977109375 },
//     É: { height: 100, width: 119.046875, ratio: 1.19046875 },
//     Á: { height: 100, width: 84.234375, ratio: 0.84234375 },
//     Ű: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     _: { height: 100, width: 46.875, ratio: 0.46875 },
//     ':': { height: 100, width: 21.1953125, ratio: 0.211953125 },
//     '?': { height: 100, width: 43.9453125, ratio: 0.439453125 },
//     M: { height: 100, width: 142.875, ratio: 1.42875 },
//     N: { height: 100, width: 91.75, ratio: 0.9175 },
//     B: { height: 100, width: 129.7421875, ratio: 1.297421875 },
//     V: { height: 100, width: 65.8203125, ratio: 0.658203125 },
//     C: { height: 100, width: 103.765625, ratio: 1.03765625 },
//     X: { height: 100, width: 97.609375, ratio: 0.97609375 },
//     Y: { height: 100, width: 72.125, ratio: 0.72125 },
//     Í: { height: 100, width: 49.7109375, ratio: 0.497109375 },
//     ö: { height: 100, width: 46.9296875, ratio: 0.469296875 },
//     ü: { height: 100, width: 56.640625, ratio: 0.56640625 },
//     ó: { height: 100, width: 46.9296875, ratio: 0.469296875 },
//     ú: { height: 100, width: 56.640625, ratio: 0.56640625 },
//     ő: { height: 100, width: 50, ratio: 0.5 },
//     p: { height: 100, width: 48.734375, ratio: 0.48734375 },
//     o: { height: 100, width: 46.9296875, ratio: 0.469296875 },
//     i: { height: 100, width: 38.28125, ratio: 0.3828125 },
//     u: { height: 100, width: 56.640625, ratio: 0.56640625 },
//     z: { height: 100, width: 54.6875, ratio: 0.546875 },
//     t: { height: 100, width: 50.1484375, ratio: 0.501484375 },
//     r: { height: 100, width: 51.90625, ratio: 0.5190625 },
//     e: { height: 100, width: 51.953125, ratio: 0.51953125 },
//     w: { height: 100, width: 76.7109375, ratio: 0.767109375 },
//     q: { height: 100, width: 52.734375, ratio: 0.52734375 },
//     a: { height: 100, width: 60.7421875, ratio: 0.607421875 },
//     s: { height: 100, width: 40.53125, ratio: 0.4053125 },
//     d: { height: 100, width: 59.0859375, ratio: 0.590859375 },
//     f: { height: 100, width: 35.40625, ratio: 0.3540625 },
//     g: { height: 100, width: 59.8671875, ratio: 0.598671875 },
//     h: { height: 100, width: 55.8125, ratio: 0.558125 },
//     j: { height: 100, width: 27.25, ratio: 0.2725 },
//     k: { height: 100, width: 46.484375, ratio: 0.46484375 },
//     l: { height: 100, width: 51.90625, ratio: 0.5190625 },
//     é: { height: 100, width: 51.953125, ratio: 0.51953125 },
//     á: { height: 100, width: 60.7421875, ratio: 0.607421875 },
//     ű: { height: 100, width: 50, ratio: 0.5 },
//     '-': { height: 100, width: 38.625, ratio: 0.38625 },
//     '.': { height: 100, width: 21.1953125, ratio: 0.211953125 },
//     ',': { height: 100, width: 22.7578125, ratio: 0.227578125 },
//     m: { height: 100, width: 77.4921875, ratio: 0.774921875 },
//     n: { height: 100, width: 61.578125, ratio: 0.61578125 },
//     b: { height: 100, width: 43.9453125, ratio: 0.439453125 },
//     v: { height: 100, width: 47.4609375, ratio: 0.474609375 },
//     c: { height: 100, width: 49.6640625, ratio: 0.496640625 },
//     x: { height: 100, width: 61.8203125, ratio: 0.618203125 },
//     y: { height: 100, width: 55.1796875, ratio: 0.551796875 },
//     í: { height: 100, width: 38.28125, ratio: 0.3828125 },
//     '¬': { height: 100, width: 49.3671875, ratio: 0.493671875 },
//     '&': { height: 100, width: 97.125, ratio: 0.97125 },
//     '™': { height: 100, width: 52.1015625, ratio: 0.521015625 },
//     '£': { height: 100, width: 85.796875, ratio: 0.85796875 },
//     $: { height: 100, width: 46.78125, ratio: 0.4678125 },
//     '‹': { height: 100, width: 26.90625, ratio: 0.2690625 },
//     '›': { height: 100, width: 26.859375, ratio: 0.26859375 },
//     '{': { height: 100, width: 33.59375, ratio: 0.3359375 },
//     '[': { height: 100, width: 35.9921875, ratio: 0.359921875 },
//     ']': { height: 100, width: 35.15625, ratio: 0.3515625 },
//     '}': { height: 100, width: 32.9140625, ratio: 0.329140625 },
//     '≠': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     '~': { height: 100, width: 44.875, ratio: 0.44875 },
//     '¨': { height: 100, width: 27.296875, ratio: 0.27296875 },
//     Ļ: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ņ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '^': { height: 100, width: 31.25, ratio: 0.3125 },
//     ź: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '†': { height: 100, width: 41.265625, ratio: 0.41265625 },
//     '¶': { height: 100, width: 62.015625, ratio: 0.62015625 },
//     '€': { height: 100, width: 64.2109375, ratio: 0.642109375 },
//     ę: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '@': { height: 100, width: 62.453125, ratio: 0.62453125 },
//     ą: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ß: { height: 100, width: 70.8515625, ratio: 0.708515625 },
//     '∂': { height: 100, width: 61.8671875, ratio: 0.618671875 },
//     ń: { height: 100, width: 50, ratio: 0.5 },
//     '©': { height: 100, width: 40.96875, ratio: 0.4096875 },
//     ķ: { height: 100, width: 50, ratio: 0.5 },
//     '∆': { height: 100, width: 51.90625, ratio: 0.5190625 },
//     Ż: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     '•': { height: 100, width: 27.0078125, ratio: 0.270078125 },
//     '…': { height: 100, width: 42.921875, ratio: 0.42921875 },
//     '–': { height: 100, width: 42.4375, ratio: 0.424375 },
//     ';': { height: 100, width: 22.8515625, ratio: 0.228515625 },
//     Ķ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '”': { height: 100, width: 31.6953125, ratio: 0.316953125 },
//     '„': { height: 100, width: 31.640625, ratio: 0.31640625 },
//     ć: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '»': { height: 100, width: 35.6953125, ratio: 0.356953125 },
//     '«': { height: 100, width: 35.6953125, ratio: 0.356953125 },
//     '|': { height: 100, width: 23.046875, ratio: 0.23046875 },
//     ŕ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ř: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '#': { height: 100, width: 55.2734375, ratio: 0.552734375 },
//     ř: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ŗ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     ŗ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '°': { height: 100, width: 33.2578125, ratio: 0.332578125 },
//     ī: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ī: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ý: { height: 100, width: 55.1796875, ratio: 0.551796875 },
//     Ý: { height: 100, width: 72.125, ratio: 0.72125 },
//     ł: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ź: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ś: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     '®': { height: 100, width: 42.6328125, ratio: 0.426328125 },
//     š: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     Ł: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ļ: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '*': { height: 100, width: 34.328125, ratio: 0.34328125 },
//     ' ': { height: 0, width: 0, ratio: null },
//     ż: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     Ž: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ū: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '—': { height: 100, width: 58.6953125, ratio: 0.586953125 },
//     '÷': { height: 100, width: 36.28125, ratio: 0.3628125 },
//     ų: { height: 100, width: 50, ratio: 0.5 },
//     Ų: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '’': { height: 100, width: 22.7109375, ratio: 0.227109375 },
//     '‚': { height: 100, width: 22.7109375, ratio: 0.227109375 },
//     '>': { height: 100, width: 31.9375, ratio: 0.319375 },
//     '<': { height: 100, width: 31.9375, ratio: 0.319375 },
//     Ŕ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '&nbsp;': { height: 100, width: 33.9375, ratio: 0.339375 },
//   },
//   'Pan Am.ttf': {
//     '0': { height: 100, width: 40.8046875, ratio: 0.408046875 },
//     '1': { height: 100, width: 31.203125, ratio: 0.31203125 },
//     '2': { height: 100, width: 40.203125, ratio: 0.40203125 },
//     '3': { height: 100, width: 45.90625, ratio: 0.4590625 },
//     '4': { height: 100, width: 42.5, ratio: 0.425 },
//     '5': { height: 100, width: 41.90625, ratio: 0.4190625 },
//     '6': { height: 100, width: 41.90625, ratio: 0.4190625 },
//     '7': { height: 100, width: 38.3046875, ratio: 0.383046875 },
//     '8': { height: 100, width: 41.203125, ratio: 0.41203125 },
//     '9': { height: 100, width: 41.203125, ratio: 0.41203125 },
//     '§': { height: 100, width: 50, ratio: 0.5 },
//     "'": { height: 100, width: 18.3046875, ratio: 0.183046875 },
//     '"': { height: 100, width: 32.6015625, ratio: 0.326015625 },
//     '+': { height: 100, width: 42, ratio: 0.42 },
//     '!': { height: 100, width: 20.3046875, ratio: 0.203046875 },
//     '%': { height: 100, width: 93.703125, ratio: 0.93703125 },
//     '/': { height: 100, width: 43.3046875, ratio: 0.433046875 },
//     '=': { height: 100, width: 42.5, ratio: 0.425 },
//     '(': { height: 100, width: 36.90625, ratio: 0.3690625 },
//     ')': { height: 100, width: 37, ratio: 0.37 },
//     Ö: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ü: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ó: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ú: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ő: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     P: { height: 100, width: 41.40625, ratio: 0.4140625 },
//     O: { height: 100, width: 41.1015625, ratio: 0.411015625 },
//     I: { height: 100, width: 20.3046875, ratio: 0.203046875 },
//     U: { height: 100, width: 41, ratio: 0.41 },
//     Z: { height: 100, width: 43.3046875, ratio: 0.433046875 },
//     T: { height: 100, width: 39, ratio: 0.39 },
//     R: { height: 100, width: 42.40625, ratio: 0.4240625 },
//     E: { height: 100, width: 41.90625, ratio: 0.4190625 },
//     W: { height: 100, width: 65.8046875, ratio: 0.658046875 },
//     Q: { height: 100, width: 41.1015625, ratio: 0.411015625 },
//     A: { height: 100, width: 42.8046875, ratio: 0.428046875 },
//     S: { height: 100, width: 43, ratio: 0.43 },
//     D: { height: 100, width: 42, ratio: 0.42 },
//     F: { height: 100, width: 42.203125, ratio: 0.42203125 },
//     G: { height: 100, width: 40.203125, ratio: 0.40203125 },
//     H: { height: 100, width: 44, ratio: 0.44 },
//     J: { height: 100, width: 42.8046875, ratio: 0.428046875 },
//     K: { height: 100, width: 43.703125, ratio: 0.43703125 },
//     L: { height: 100, width: 40, ratio: 0.4 },
//     É: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Á: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ű: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     _: { height: 100, width: 65, ratio: 0.65 },
//     ':': { height: 100, width: 20.3046875, ratio: 0.203046875 },
//     '?': { height: 100, width: 44, ratio: 0.44 },
//     M: { height: 100, width: 64.5, ratio: 0.645 },
//     N: { height: 100, width: 41.8046875, ratio: 0.418046875 },
//     B: { height: 100, width: 42, ratio: 0.42 },
//     V: { height: 100, width: 44, ratio: 0.44 },
//     C: { height: 100, width: 40.40625, ratio: 0.4040625 },
//     X: { height: 100, width: 43.6015625, ratio: 0.436015625 },
//     Y: { height: 100, width: 43.6015625, ratio: 0.436015625 },
//     Í: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ö: { height: 100, width: 50, ratio: 0.5 },
//     ü: { height: 100, width: 50, ratio: 0.5 },
//     ó: { height: 100, width: 50, ratio: 0.5 },
//     ú: { height: 100, width: 50, ratio: 0.5 },
//     ő: { height: 100, width: 50, ratio: 0.5 },
//     p: { height: 100, width: 41.40625, ratio: 0.4140625 },
//     o: { height: 100, width: 41.1015625, ratio: 0.411015625 },
//     i: { height: 100, width: 20.3046875, ratio: 0.203046875 },
//     u: { height: 100, width: 41, ratio: 0.41 },
//     z: { height: 100, width: 43.3046875, ratio: 0.433046875 },
//     t: { height: 100, width: 39, ratio: 0.39 },
//     r: { height: 100, width: 42.40625, ratio: 0.4240625 },
//     e: { height: 100, width: 41.703125, ratio: 0.41703125 },
//     w: { height: 100, width: 65.8046875, ratio: 0.658046875 },
//     q: { height: 100, width: 41.1015625, ratio: 0.411015625 },
//     a: { height: 100, width: 42.8046875, ratio: 0.428046875 },
//     s: { height: 100, width: 43, ratio: 0.43 },
//     d: { height: 100, width: 42, ratio: 0.42 },
//     f: { height: 100, width: 42, ratio: 0.42 },
//     g: { height: 100, width: 40.203125, ratio: 0.40203125 },
//     h: { height: 100, width: 44, ratio: 0.44 },
//     j: { height: 100, width: 42.8046875, ratio: 0.428046875 },
//     k: { height: 100, width: 43.703125, ratio: 0.43703125 },
//     l: { height: 100, width: 40, ratio: 0.4 },
//     é: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     á: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ű: { height: 100, width: 50, ratio: 0.5 },
//     '-': { height: 100, width: 45, ratio: 0.45 },
//     '.': { height: 100, width: 18.8046875, ratio: 0.188046875 },
//     ',': { height: 100, width: 19.8046875, ratio: 0.198046875 },
//     m: { height: 100, width: 64.5, ratio: 0.645 },
//     n: { height: 100, width: 41.8046875, ratio: 0.418046875 },
//     b: { height: 100, width: 42, ratio: 0.42 },
//     v: { height: 100, width: 44, ratio: 0.44 },
//     c: { height: 100, width: 40.40625, ratio: 0.4040625 },
//     x: { height: 100, width: 43.6015625, ratio: 0.436015625 },
//     y: { height: 100, width: 43.6015625, ratio: 0.436015625 },
//     í: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '¬': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '&': { height: 100, width: 46, ratio: 0.46 },
//     '™': { height: 100, width: 98, ratio: 0.98 },
//     '£': { height: 100, width: 50, ratio: 0.5 },
//     $: { height: 100, width: 45.6015625, ratio: 0.456015625 },
//     '‹': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '›': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '{': { height: 100, width: 48, ratio: 0.48 },
//     '[': { height: 100, width: 36.6015625, ratio: 0.366015625 },
//     ']': { height: 100, width: 36.6015625, ratio: 0.366015625 },
//     '}': { height: 100, width: 48, ratio: 0.48 },
//     '≠': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     '~': { height: 100, width: 54.1015625, ratio: 0.541015625 },
//     '¨': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ļ: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ņ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '^': { height: 100, width: 46.9296875, ratio: 0.469296875 },
//     ź: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '†': { height: 100, width: 50, ratio: 0.5 },
//     '¶': { height: 100, width: 45.3125, ratio: 0.453125 },
//     '€': { height: 100, width: 44, ratio: 0.44 },
//     ę: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '@': { height: 100, width: 94.1015625, ratio: 0.941015625 },
//     ą: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ß: { height: 100, width: 50, ratio: 0.5 },
//     '∂': { height: 100, width: 49.4140625, ratio: 0.494140625 },
//     ń: { height: 100, width: 50, ratio: 0.5 },
//     '©': { height: 100, width: 75.9765625, ratio: 0.759765625 },
//     ķ: { height: 100, width: 50, ratio: 0.5 },
//     '∆': { height: 100, width: 61.1875, ratio: 0.611875 },
//     Ż: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     '•': { height: 100, width: 35.015625, ratio: 0.35015625 },
//     '…': { height: 100, width: 100, ratio: 1 },
//     '–': { height: 100, width: 50, ratio: 0.5 },
//     ';': { height: 100, width: 22.3046875, ratio: 0.223046875 },
//     Ķ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '”': { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '„': { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ć: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '»': { height: 100, width: 50, ratio: 0.5 },
//     '«': { height: 100, width: 50, ratio: 0.5 },
//     '|': { height: 100, width: 20.0234375, ratio: 0.200234375 },
//     ŕ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ř: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '#': { height: 100, width: 50, ratio: 0.5 },
//     ř: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ŗ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     ŗ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '°': { height: 100, width: 39.9921875, ratio: 0.399921875 },
//     ī: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ī: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ý: { height: 100, width: 50, ratio: 0.5 },
//     Ý: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     ł: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ź: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ś: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     '®': { height: 100, width: 75.9765625, ratio: 0.759765625 },
//     š: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     Ł: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ļ: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '*': { height: 100, width: 41.6015625, ratio: 0.416015625 },
//     ' ': { height: 0, width: 0, ratio: null },
//     ż: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     Ž: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ū: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '—': { height: 100, width: 100, ratio: 1 },
//     '÷': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     ų: { height: 100, width: 50, ratio: 0.5 },
//     Ų: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '’': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '‚': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '>': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '<': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     Ŕ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '&nbsp;': { height: 100, width: 22.6015625, ratio: 0.226015625 },
//   },
//   'Rather.ttf': {
//     '0': { height: 100, width: 130.6015625, ratio: 1.306015625 },
//     '1': { height: 100, width: 130.6015625, ratio: 1.306015625 },
//     '2': { height: 100, width: 130.6015625, ratio: 1.306015625 },
//     '3': { height: 100, width: 130.6015625, ratio: 1.306015625 },
//     '4': { height: 100, width: 130.6015625, ratio: 1.306015625 },
//     '5': { height: 100, width: 130.6015625, ratio: 1.306015625 },
//     '6': { height: 100, width: 130.6015625, ratio: 1.306015625 },
//     '7': { height: 100, width: 130.6015625, ratio: 1.306015625 },
//     '8': { height: 100, width: 130.6015625, ratio: 1.306015625 },
//     '9': { height: 100, width: 130.6015625, ratio: 1.306015625 },
//     '§': { height: 100, width: 50, ratio: 0.5 },
//     "'": { height: 100, width: 25.40625, ratio: 0.2540625 },
//     '"': { height: 100, width: 29.8046875, ratio: 0.298046875 },
//     '+': { height: 100, width: 71.703125, ratio: 0.71703125 },
//     '!': { height: 100, width: 46.203125, ratio: 0.46203125 },
//     '%': { height: 100, width: 130.6015625, ratio: 1.306015625 },
//     '/': { height: 100, width: 59.8046875, ratio: 0.598046875 },
//     '=': { height: 100, width: 49.1015625, ratio: 0.491015625 },
//     '(': { height: 100, width: 42.203125, ratio: 0.42203125 },
//     ')': { height: 100, width: 47.703125, ratio: 0.47703125 },
//     Ö: { height: 100, width: 59.203125, ratio: 0.59203125 },
//     Ü: { height: 100, width: 56.40625, ratio: 0.5640625 },
//     Ó: { height: 100, width: 59.203125, ratio: 0.59203125 },
//     Ú: { height: 100, width: 56.40625, ratio: 0.5640625 },
//     Ő: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     P: { height: 100, width: 80.3046875, ratio: 0.803046875 },
//     O: { height: 100, width: 59.203125, ratio: 0.59203125 },
//     I: { height: 100, width: 25.5, ratio: 0.255 },
//     U: { height: 100, width: 56.40625, ratio: 0.5640625 },
//     Z: { height: 100, width: 72.90625, ratio: 0.7290625 },
//     T: { height: 100, width: 52.703125, ratio: 0.52703125 },
//     R: { height: 100, width: 79.40625, ratio: 0.7940625 },
//     E: { height: 100, width: 68.40625, ratio: 0.6840625 },
//     W: { height: 100, width: 90.3046875, ratio: 0.903046875 },
//     Q: { height: 100, width: 59.6015625, ratio: 0.596015625 },
//     A: { height: 100, width: 75.6015625, ratio: 0.756015625 },
//     S: { height: 100, width: 61.90625, ratio: 0.6190625 },
//     D: { height: 100, width: 78.8046875, ratio: 0.788046875 },
//     F: { height: 100, width: 59.703125, ratio: 0.59703125 },
//     G: { height: 100, width: 62.1015625, ratio: 0.621015625 },
//     H: { height: 100, width: 68.6015625, ratio: 0.686015625 },
//     J: { height: 100, width: 68.90625, ratio: 0.6890625 },
//     K: { height: 100, width: 65.6015625, ratio: 0.656015625 },
//     L: { height: 100, width: 63.3046875, ratio: 0.633046875 },
//     É: { height: 100, width: 68.40625, ratio: 0.6840625 },
//     Á: { height: 100, width: 75.6015625, ratio: 0.756015625 },
//     Ű: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     _: { height: 100, width: 49.1015625, ratio: 0.491015625 },
//     ':': { height: 100, width: 33, ratio: 0.33 },
//     '?': { height: 100, width: 68, ratio: 0.68 },
//     M: { height: 100, width: 80.6015625, ratio: 0.806015625 },
//     N: { height: 100, width: 73.40625, ratio: 0.7340625 },
//     B: { height: 100, width: 93.3046875, ratio: 0.933046875 },
//     V: { height: 100, width: 58.203125, ratio: 0.58203125 },
//     C: { height: 100, width: 62.1015625, ratio: 0.621015625 },
//     X: { height: 100, width: 81.90625, ratio: 0.8190625 },
//     Y: { height: 100, width: 59.90625, ratio: 0.5990625 },
//     Í: { height: 100, width: 25.5, ratio: 0.255 },
//     ö: { height: 100, width: 41.203125, ratio: 0.41203125 },
//     ü: { height: 100, width: 70, ratio: 0.7 },
//     ó: { height: 100, width: 27.203125, ratio: 0.27203125 },
//     ú: { height: 100, width: 48.90625, ratio: 0.4890625 },
//     ő: { height: 100, width: 50, ratio: 0.5 },
//     p: { height: 100, width: 43.203125, ratio: 0.43203125 },
//     o: { height: 100, width: 26.3046875, ratio: 0.263046875 },
//     i: { height: 100, width: 25.40625, ratio: 0.2540625 },
//     u: { height: 100, width: 48.90625, ratio: 0.4890625 },
//     z: { height: 100, width: 59, ratio: 0.59 },
//     t: { height: 100, width: 19.5, ratio: 0.195 },
//     r: { height: 100, width: 37, ratio: 0.37 },
//     e: { height: 100, width: 32.203125, ratio: 0.32203125 },
//     w: { height: 100, width: 55.90625, ratio: 0.5590625 },
//     q: { height: 100, width: 61.6015625, ratio: 0.616015625 },
//     a: { height: 100, width: 47.3046875, ratio: 0.473046875 },
//     s: { height: 100, width: 42, ratio: 0.42 },
//     d: { height: 100, width: 42.90625, ratio: 0.4290625 },
//     f: { height: 100, width: 37, ratio: 0.37 },
//     g: { height: 100, width: 52.6015625, ratio: 0.526015625 },
//     h: { height: 100, width: 52.5, ratio: 0.525 },
//     j: { height: 100, width: 33.40625, ratio: 0.3340625 },
//     k: { height: 100, width: 47, ratio: 0.47 },
//     l: { height: 100, width: 29.3046875, ratio: 0.293046875 },
//     é: { height: 100, width: 32.203125, ratio: 0.32203125 },
//     á: { height: 100, width: 47.3046875, ratio: 0.473046875 },
//     ű: { height: 100, width: 50, ratio: 0.5 },
//     '-': { height: 100, width: 41.6015625, ratio: 0.416015625 },
//     '.': { height: 100, width: 130.6015625, ratio: 1.306015625 },
//     ',': { height: 100, width: 130.6015625, ratio: 1.306015625 },
//     m: { height: 100, width: 71.5, ratio: 0.715 },
//     n: { height: 100, width: 52.703125, ratio: 0.52703125 },
//     b: { height: 100, width: 34.90625, ratio: 0.3490625 },
//     v: { height: 100, width: 39.703125, ratio: 0.39703125 },
//     c: { height: 100, width: 38.8046875, ratio: 0.388046875 },
//     x: { height: 100, width: 49.90625, ratio: 0.4990625 },
//     y: { height: 100, width: 61.8046875, ratio: 0.618046875 },
//     í: { height: 100, width: 25.40625, ratio: 0.2540625 },
//     '¬': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '&': { height: 100, width: 130.6015625, ratio: 1.306015625 },
//     '™': { height: 100, width: 98, ratio: 0.98 },
//     '£': { height: 100, width: 75.3046875, ratio: 0.753046875 },
//     $: { height: 100, width: 269, ratio: 2.69 },
//     '‹': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '›': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '{': { height: 100, width: 45.6015625, ratio: 0.456015625 },
//     '[': { height: 100, width: 44.703125, ratio: 0.44703125 },
//     ']': { height: 100, width: 59.3046875, ratio: 0.593046875 },
//     '}': { height: 100, width: 34.5, ratio: 0.345 },
//     '≠': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     '~': { height: 100, width: 52.1015625, ratio: 0.521015625 },
//     '¨': { height: 100, width: 29.8046875, ratio: 0.298046875 },
//     Ļ: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ņ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '^': { height: 100, width: 32.90625, ratio: 0.3290625 },
//     ź: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '†': { height: 100, width: 50, ratio: 0.5 },
//     '¶': { height: 100, width: 45.3125, ratio: 0.453125 },
//     '€': { height: 100, width: 63.8046875, ratio: 0.638046875 },
//     ę: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '@': { height: 100, width: 63.90625, ratio: 0.6390625 },
//     ą: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ß: { height: 100, width: 93.3046875, ratio: 0.933046875 },
//     '∂': { height: 100, width: 49.4140625, ratio: 0.494140625 },
//     ń: { height: 100, width: 50, ratio: 0.5 },
//     '©': { height: 100, width: 75.9765625, ratio: 0.759765625 },
//     ķ: { height: 100, width: 50, ratio: 0.5 },
//     '∆': { height: 100, width: 61.1875, ratio: 0.611875 },
//     Ż: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     '•': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '…': { height: 100, width: 71.5, ratio: 0.715 },
//     '–': { height: 100, width: 50, ratio: 0.5 },
//     ';': { height: 100, width: 31, ratio: 0.31 },
//     Ķ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '”': { height: 100, width: 29.8046875, ratio: 0.298046875 },
//     '„': { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ć: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '»': { height: 100, width: 87.5, ratio: 0.875 },
//     '«': { height: 100, width: 87.5, ratio: 0.875 },
//     '|': { height: 100, width: 53.703125, ratio: 0.53703125 },
//     ŕ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ř: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '#': { height: 100, width: 73.40625, ratio: 0.7340625 },
//     ř: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ŗ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     ŗ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '°': { height: 100, width: 29.90625, ratio: 0.2990625 },
//     ī: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ī: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ý: { height: 100, width: 61.8046875, ratio: 0.618046875 },
//     Ý: { height: 100, width: 59.90625, ratio: 0.5990625 },
//     ł: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ź: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ś: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     '®': { height: 100, width: 75.9765625, ratio: 0.759765625 },
//     š: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     Ł: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ļ: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '*': { height: 100, width: 47.703125, ratio: 0.47703125 },
//     ' ': { height: 0, width: 0, ratio: null },
//     ż: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     Ž: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ū: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '—': { height: 100, width: 100, ratio: 1 },
//     '÷': { height: 100, width: 49.1015625, ratio: 0.491015625 },
//     ų: { height: 100, width: 50, ratio: 0.5 },
//     Ų: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '’': { height: 100, width: 25.40625, ratio: 0.2540625 },
//     '‚': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '>': { height: 100, width: 66.5, ratio: 0.665 },
//     '<': { height: 100, width: 57.6015625, ratio: 0.576015625 },
//     Ŕ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '&nbsp;': { height: 100, width: 40, ratio: 0.4 },
//   },
//   'Selfie.ttf': {
//     '0': { height: 100, width: 32, ratio: 0.32 },
//     '1': { height: 100, width: 19.40625, ratio: 0.1940625 },
//     '2': { height: 100, width: 32, ratio: 0.32 },
//     '3': { height: 100, width: 30.3046875, ratio: 0.303046875 },
//     '4': { height: 100, width: 32.40625, ratio: 0.3240625 },
//     '5': { height: 100, width: 31, ratio: 0.31 },
//     '6': { height: 100, width: 31.203125, ratio: 0.31203125 },
//     '7': { height: 100, width: 37.6015625, ratio: 0.376015625 },
//     '8': { height: 100, width: 33.203125, ratio: 0.33203125 },
//     '9': { height: 100, width: 30.8046875, ratio: 0.308046875 },
//     '§': { height: 100, width: 50, ratio: 0.5 },
//     "'": { height: 100, width: 8.1015625, ratio: 0.081015625 },
//     '"': { height: 100, width: 16.203125, ratio: 0.16203125 },
//     '+': { height: 100, width: 38.40625, ratio: 0.3840625 },
//     '!': { height: 100, width: 9.3046875, ratio: 0.093046875 },
//     '%': { height: 100, width: 44.90625, ratio: 0.4490625 },
//     '/': { height: 100, width: 38.40625, ratio: 0.3840625 },
//     '=': { height: 100, width: 31.203125, ratio: 0.31203125 },
//     '(': { height: 100, width: 16.6015625, ratio: 0.166015625 },
//     ')': { height: 100, width: 15.8046875, ratio: 0.158046875 },
//     Ö: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ü: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ó: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ú: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ő: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     P: { height: 100, width: 34, ratio: 0.34 },
//     O: { height: 100, width: 35.6015625, ratio: 0.356015625 },
//     I: { height: 100, width: 10.90625, ratio: 0.1090625 },
//     U: { height: 100, width: 34.8046875, ratio: 0.348046875 },
//     Z: { height: 100, width: 40.90625, ratio: 0.4090625 },
//     T: { height: 100, width: 40.1015625, ratio: 0.401015625 },
//     R: { height: 100, width: 34.8046875, ratio: 0.348046875 },
//     E: { height: 100, width: 30.3046875, ratio: 0.303046875 },
//     W: { height: 100, width: 65.1015625, ratio: 0.651015625 },
//     Q: { height: 100, width: 34.8046875, ratio: 0.348046875 },
//     A: { height: 100, width: 39.203125, ratio: 0.39203125 },
//     S: { height: 100, width: 34.8046875, ratio: 0.348046875 },
//     D: { height: 100, width: 34.8046875, ratio: 0.348046875 },
//     F: { height: 100, width: 30.8046875, ratio: 0.308046875 },
//     G: { height: 100, width: 35.203125, ratio: 0.35203125 },
//     H: { height: 100, width: 34.40625, ratio: 0.3440625 },
//     J: { height: 100, width: 32.40625, ratio: 0.3240625 },
//     K: { height: 100, width: 36, ratio: 0.36 },
//     L: { height: 100, width: 29.5, ratio: 0.295 },
//     É: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Á: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ű: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     _: { height: 100, width: 46.1015625, ratio: 0.461015625 },
//     ':': { height: 100, width: 11.3046875, ratio: 0.113046875 },
//     '?': { height: 100, width: 30.3046875, ratio: 0.303046875 },
//     M: { height: 100, width: 47.3046875, ratio: 0.473046875 },
//     N: { height: 100, width: 36, ratio: 0.36 },
//     B: { height: 100, width: 33.6015625, ratio: 0.336015625 },
//     V: { height: 100, width: 40.1015625, ratio: 0.401015625 },
//     C: { height: 100, width: 34.40625, ratio: 0.3440625 },
//     X: { height: 100, width: 39.203125, ratio: 0.39203125 },
//     Y: { height: 100, width: 41.703125, ratio: 0.41703125 },
//     Í: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ö: { height: 100, width: 50, ratio: 0.5 },
//     ü: { height: 100, width: 50, ratio: 0.5 },
//     ó: { height: 100, width: 50, ratio: 0.5 },
//     ú: { height: 100, width: 50, ratio: 0.5 },
//     ő: { height: 100, width: 50, ratio: 0.5 },
//     p: { height: 100, width: 34, ratio: 0.34 },
//     o: { height: 100, width: 35.6015625, ratio: 0.356015625 },
//     i: { height: 100, width: 10.90625, ratio: 0.1090625 },
//     u: { height: 100, width: 34.8046875, ratio: 0.348046875 },
//     z: { height: 100, width: 40.90625, ratio: 0.4090625 },
//     t: { height: 100, width: 40.1015625, ratio: 0.401015625 },
//     r: { height: 100, width: 34.8046875, ratio: 0.348046875 },
//     e: { height: 100, width: 30.3046875, ratio: 0.303046875 },
//     w: { height: 100, width: 65.1015625, ratio: 0.651015625 },
//     q: { height: 100, width: 34.8046875, ratio: 0.348046875 },
//     a: { height: 100, width: 39.203125, ratio: 0.39203125 },
//     s: { height: 100, width: 34.8046875, ratio: 0.348046875 },
//     d: { height: 100, width: 34.8046875, ratio: 0.348046875 },
//     f: { height: 100, width: 30.8046875, ratio: 0.308046875 },
//     g: { height: 100, width: 35.203125, ratio: 0.35203125 },
//     h: { height: 100, width: 34.40625, ratio: 0.3440625 },
//     j: { height: 100, width: 32.40625, ratio: 0.3240625 },
//     k: { height: 100, width: 36, ratio: 0.36 },
//     l: { height: 100, width: 29.5, ratio: 0.295 },
//     é: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     á: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ű: { height: 100, width: 50, ratio: 0.5 },
//     '-': { height: 100, width: 29.90625, ratio: 0.2990625 },
//     '.': { height: 100, width: 8.1015625, ratio: 0.081015625 },
//     ',': { height: 100, width: 8.5, ratio: 0.085 },
//     m: { height: 100, width: 47.3046875, ratio: 0.473046875 },
//     n: { height: 100, width: 36, ratio: 0.36 },
//     b: { height: 100, width: 33.6015625, ratio: 0.336015625 },
//     v: { height: 100, width: 40.1015625, ratio: 0.401015625 },
//     c: { height: 100, width: 34.40625, ratio: 0.3440625 },
//     x: { height: 100, width: 39.203125, ratio: 0.39203125 },
//     y: { height: 100, width: 41.703125, ratio: 0.41703125 },
//     í: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '¬': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '&': { height: 100, width: 42.90625, ratio: 0.4290625 },
//     '™': { height: 100, width: 87.40625, ratio: 0.8740625 },
//     '£': { height: 100, width: 50, ratio: 0.5 },
//     $: { height: 100, width: 32, ratio: 0.32 },
//     '‹': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '›': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '{': { height: 100, width: 83.3046875, ratio: 0.833046875 },
//     '[': { height: 100, width: 83.3046875, ratio: 0.833046875 },
//     ']': { height: 100, width: 83.3046875, ratio: 0.833046875 },
//     '}': { height: 100, width: 83.3046875, ratio: 0.833046875 },
//     '≠': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     '~': { height: 100, width: 83.3046875, ratio: 0.833046875 },
//     '¨': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ļ: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ņ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '^': { height: 100, width: 83.3046875, ratio: 0.833046875 },
//     ź: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '†': { height: 100, width: 50, ratio: 0.5 },
//     '¶': { height: 100, width: 45.3125, ratio: 0.453125 },
//     '€': { height: 100, width: 74.4140625, ratio: 0.744140625 },
//     ę: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '@': { height: 100, width: 64.703125, ratio: 0.64703125 },
//     ą: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ß: { height: 100, width: 50, ratio: 0.5 },
//     '∂': { height: 100, width: 49.4140625, ratio: 0.494140625 },
//     ń: { height: 100, width: 50, ratio: 0.5 },
//     '©': { height: 100, width: 83.3046875, ratio: 0.833046875 },
//     ķ: { height: 100, width: 50, ratio: 0.5 },
//     '∆': { height: 100, width: 61.1875, ratio: 0.611875 },
//     Ż: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     '•': { height: 100, width: 83.3046875, ratio: 0.833046875 },
//     '…': { height: 100, width: 100, ratio: 1 },
//     '–': { height: 100, width: 29.90625, ratio: 0.2990625 },
//     ';': { height: 100, width: 9.703125, ratio: 0.09703125 },
//     Ķ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '”': { height: 100, width: 15, ratio: 0.15 },
//     '„': { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ć: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '»': { height: 100, width: 50, ratio: 0.5 },
//     '«': { height: 100, width: 50, ratio: 0.5 },
//     '|': { height: 100, width: 8.90625, ratio: 0.0890625 },
//     ŕ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ř: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '#': { height: 100, width: 54.203125, ratio: 0.54203125 },
//     ř: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ŗ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     ŗ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '°': { height: 100, width: 39.9921875, ratio: 0.399921875 },
//     ī: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ī: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ý: { height: 100, width: 50, ratio: 0.5 },
//     Ý: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     ł: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ź: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ś: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     '®': { height: 100, width: 83.3046875, ratio: 0.833046875 },
//     š: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     Ł: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ļ: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '*': { height: 100, width: 29.5, ratio: 0.295 },
//     ' ': { height: 0, width: 0, ratio: null },
//     ż: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     Ž: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ū: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '—': { height: 100, width: 29.90625, ratio: 0.2990625 },
//     '÷': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     ų: { height: 100, width: 50, ratio: 0.5 },
//     Ų: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '’': { height: 100, width: 8.1015625, ratio: 0.081015625 },
//     '‚': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '>': { height: 100, width: 83.3046875, ratio: 0.833046875 },
//     '<': { height: 100, width: 83.3046875, ratio: 0.833046875 },
//     Ŕ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '&nbsp;': { height: 100, width: 21, ratio: 0.21 },
//   },
//   'Share.ttf': {
//     '0': { height: 100, width: 49.8046875, ratio: 0.498046875 },
//     '1': { height: 100, width: 34, ratio: 0.34 },
//     '2': { height: 100, width: 45.5, ratio: 0.455 },
//     '3': { height: 100, width: 44.6015625, ratio: 0.446015625 },
//     '4': { height: 100, width: 46.8046875, ratio: 0.468046875 },
//     '5': { height: 100, width: 46.5, ratio: 0.465 },
//     '6': { height: 100, width: 48, ratio: 0.48 },
//     '7': { height: 100, width: 44.3046875, ratio: 0.443046875 },
//     '8': { height: 100, width: 48.5, ratio: 0.485 },
//     '9': { height: 100, width: 49.1015625, ratio: 0.491015625 },
//     '§': { height: 100, width: 50, ratio: 0.5 },
//     "'": { height: 100, width: 21, ratio: 0.21 },
//     '"': { height: 100, width: 27.8046875, ratio: 0.278046875 },
//     '+': { height: 100, width: 35.3046875, ratio: 0.353046875 },
//     '!': { height: 100, width: 27.90625, ratio: 0.2790625 },
//     '%': { height: 100, width: 41.3046875, ratio: 0.413046875 },
//     '/': { height: 100, width: 20.8046875, ratio: 0.208046875 },
//     '=': { height: 100, width: 40.203125, ratio: 0.40203125 },
//     '(': { height: 100, width: 29.203125, ratio: 0.29203125 },
//     ')': { height: 100, width: 43.203125, ratio: 0.43203125 },
//     Ö: { height: 100, width: 73.5, ratio: 0.735 },
//     Ü: { height: 100, width: 77.6015625, ratio: 0.776015625 },
//     Ó: { height: 100, width: 73.5, ratio: 0.735 },
//     Ú: { height: 100, width: 77.6015625, ratio: 0.776015625 },
//     Ő: { height: 100, width: 73.5, ratio: 0.735 },
//     P: { height: 100, width: 73.1015625, ratio: 0.731015625 },
//     O: { height: 100, width: 73.5, ratio: 0.735 },
//     I: { height: 100, width: 54.40625, ratio: 0.5440625 },
//     U: { height: 100, width: 77.6015625, ratio: 0.776015625 },
//     Z: { height: 100, width: 62.703125, ratio: 0.62703125 },
//     T: { height: 100, width: 61.90625, ratio: 0.6190625 },
//     R: { height: 100, width: 72.5, ratio: 0.725 },
//     E: { height: 100, width: 47.6015625, ratio: 0.476015625 },
//     W: { height: 100, width: 95, ratio: 0.95 },
//     Q: { height: 100, width: 70.703125, ratio: 0.70703125 },
//     A: { height: 100, width: 76.5, ratio: 0.765 },
//     S: { height: 100, width: 55.203125, ratio: 0.55203125 },
//     D: { height: 100, width: 83.3046875, ratio: 0.833046875 },
//     F: { height: 100, width: 63.203125, ratio: 0.63203125 },
//     G: { height: 100, width: 70.3046875, ratio: 0.703046875 },
//     H: { height: 100, width: 81.1015625, ratio: 0.811015625 },
//     J: { height: 100, width: 52.1015625, ratio: 0.521015625 },
//     K: { height: 100, width: 80.6015625, ratio: 0.806015625 },
//     L: { height: 100, width: 50.8046875, ratio: 0.508046875 },
//     É: { height: 100, width: 47.6015625, ratio: 0.476015625 },
//     Á: { height: 100, width: 76.5, ratio: 0.765 },
//     Ű: { height: 100, width: 77.6015625, ratio: 0.776015625 },
//     _: { height: 100, width: 45.5, ratio: 0.455 },
//     ':': { height: 100, width: 25.6015625, ratio: 0.256015625 },
//     '?': { height: 100, width: 47.203125, ratio: 0.47203125 },
//     M: { height: 100, width: 106.203125, ratio: 1.06203125 },
//     N: { height: 100, width: 76.703125, ratio: 0.76703125 },
//     B: { height: 100, width: 79.40625, ratio: 0.7940625 },
//     V: { height: 100, width: 71.40625, ratio: 0.7140625 },
//     C: { height: 100, width: 59.3046875, ratio: 0.593046875 },
//     X: { height: 100, width: 75.1015625, ratio: 0.751015625 },
//     Y: { height: 100, width: 76.5, ratio: 0.765 },
//     Í: { height: 100, width: 54.40625, ratio: 0.5440625 },
//     ö: { height: 100, width: 39.1015625, ratio: 0.391015625 },
//     ü: { height: 100, width: 40.1015625, ratio: 0.401015625 },
//     ó: { height: 100, width: 39.1015625, ratio: 0.391015625 },
//     ú: { height: 100, width: 40.1015625, ratio: 0.401015625 },
//     ő: { height: 100, width: 39.1015625, ratio: 0.391015625 },
//     p: { height: 100, width: 38, ratio: 0.38 },
//     o: { height: 100, width: 39.1015625, ratio: 0.391015625 },
//     i: { height: 100, width: 18.40625, ratio: 0.1840625 },
//     u: { height: 100, width: 40.1015625, ratio: 0.401015625 },
//     z: { height: 100, width: 39.90625, ratio: 0.3990625 },
//     t: { height: 100, width: 20.8046875, ratio: 0.208046875 },
//     r: { height: 100, width: 36.8046875, ratio: 0.368046875 },
//     e: { height: 100, width: 31.703125, ratio: 0.31703125 },
//     w: { height: 100, width: 52.6015625, ratio: 0.526015625 },
//     q: { height: 100, width: 40.40625, ratio: 0.4040625 },
//     a: { height: 100, width: 40.3046875, ratio: 0.403046875 },
//     s: { height: 100, width: 38.5, ratio: 0.385 },
//     d: { height: 100, width: 43, ratio: 0.43 },
//     f: { height: 100, width: 19.203125, ratio: 0.19203125 },
//     g: { height: 100, width: 41.3046875, ratio: 0.413046875 },
//     h: { height: 100, width: 39.90625, ratio: 0.3990625 },
//     j: { height: 100, width: 19.1015625, ratio: 0.191015625 },
//     k: { height: 100, width: 39.5, ratio: 0.395 },
//     l: { height: 100, width: 20.6015625, ratio: 0.206015625 },
//     é: { height: 100, width: 31.703125, ratio: 0.31703125 },
//     á: { height: 100, width: 40.3046875, ratio: 0.403046875 },
//     ű: { height: 100, width: 40.1015625, ratio: 0.401015625 },
//     '-': { height: 100, width: 37, ratio: 0.37 },
//     '.': { height: 100, width: 24.3046875, ratio: 0.243046875 },
//     ',': { height: 100, width: 24.3046875, ratio: 0.243046875 },
//     m: { height: 100, width: 61.703125, ratio: 0.61703125 },
//     n: { height: 100, width: 39.90625, ratio: 0.3990625 },
//     b: { height: 100, width: 38.203125, ratio: 0.38203125 },
//     v: { height: 100, width: 34.5, ratio: 0.345 },
//     c: { height: 100, width: 31.703125, ratio: 0.31703125 },
//     x: { height: 100, width: 45.8046875, ratio: 0.458046875 },
//     y: { height: 100, width: 41.203125, ratio: 0.41203125 },
//     í: { height: 100, width: 18.40625, ratio: 0.1840625 },
//     '¬': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '&': { height: 100, width: 57.8046875, ratio: 0.578046875 },
//     '™': { height: 100, width: 64.3046875, ratio: 0.643046875 },
//     '£': { height: 100, width: 50.8046875, ratio: 0.508046875 },
//     $: { height: 100, width: 45.5, ratio: 0.455 },
//     '‹': { height: 100, width: 34, ratio: 0.34 },
//     '›': { height: 100, width: 26.8046875, ratio: 0.268046875 },
//     '{': { height: 100, width: 36.6015625, ratio: 0.366015625 },
//     '[': { height: 100, width: 39.40625, ratio: 0.3940625 },
//     ']': { height: 100, width: 52.5, ratio: 0.525 },
//     '}': { height: 100, width: 48.1015625, ratio: 0.481015625 },
//     '≠': { height: 100, width: 40.203125, ratio: 0.40203125 },
//     '~': { height: 100, width: 47.203125, ratio: 0.47203125 },
//     '¨': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ļ: { height: 100, width: 50.8046875, ratio: 0.508046875 },
//     Ņ: { height: 100, width: 76.703125, ratio: 0.76703125 },
//     '^': { height: 100, width: 37, ratio: 0.37 },
//     ź: { height: 100, width: 39.90625, ratio: 0.3990625 },
//     '†': { height: 100, width: 35.703125, ratio: 0.35703125 },
//     '¶': { height: 100, width: 46.703125, ratio: 0.46703125 },
//     '€': { height: 100, width: 47.6015625, ratio: 0.476015625 },
//     ę: { height: 100, width: 31.703125, ratio: 0.31703125 },
//     '@': { height: 100, width: 72.703125, ratio: 0.72703125 },
//     ą: { height: 100, width: 40.3046875, ratio: 0.403046875 },
//     ß: { height: 100, width: 35.703125, ratio: 0.35703125 },
//     '∂': { height: 100, width: 49.4140625, ratio: 0.494140625 },
//     ń: { height: 100, width: 39.90625, ratio: 0.3990625 },
//     '©': { height: 100, width: 72.703125, ratio: 0.72703125 },
//     ķ: { height: 100, width: 39.5, ratio: 0.395 },
//     '∆': { height: 100, width: 61.1875, ratio: 0.611875 },
//     Ż: { height: 100, width: 62.703125, ratio: 0.62703125 },
//     '•': { height: 100, width: 30.703125, ratio: 0.30703125 },
//     '…': { height: 100, width: 45.3046875, ratio: 0.453046875 },
//     '–': { height: 100, width: 60, ratio: 0.6 },
//     ';': { height: 100, width: 29.90625, ratio: 0.2990625 },
//     Ķ: { height: 100, width: 80.6015625, ratio: 0.806015625 },
//     '”': { height: 100, width: 27, ratio: 0.27 },
//     '„': { height: 100, width: 22.40625, ratio: 0.2240625 },
//     ć: { height: 100, width: 31.703125, ratio: 0.31703125 },
//     '»': { height: 100, width: 26.8046875, ratio: 0.268046875 },
//     '«': { height: 100, width: 34, ratio: 0.34 },
//     '|': { height: 100, width: 27.703125, ratio: 0.27703125 },
//     ŕ: { height: 100, width: 36.8046875, ratio: 0.368046875 },
//     Ř: { height: 100, width: 72.5, ratio: 0.725 },
//     '#': { height: 100, width: 53.6015625, ratio: 0.536015625 },
//     ř: { height: 100, width: 36.8046875, ratio: 0.368046875 },
//     Ŗ: { height: 100, width: 72.5, ratio: 0.725 },
//     ŗ: { height: 100, width: 36.8046875, ratio: 0.368046875 },
//     '°': { height: 100, width: 35.40625, ratio: 0.3540625 },
//     ī: { height: 100, width: 18.40625, ratio: 0.1840625 },
//     Ī: { height: 100, width: 54.40625, ratio: 0.5440625 },
//     ý: { height: 100, width: 41.203125, ratio: 0.41203125 },
//     Ý: { height: 100, width: 76.5, ratio: 0.765 },
//     ł: { height: 100, width: 20.6015625, ratio: 0.206015625 },
//     Ź: { height: 100, width: 62.703125, ratio: 0.62703125 },
//     ś: { height: 100, width: 38.5, ratio: 0.385 },
//     '®': { height: 100, width: 72.5, ratio: 0.725 },
//     š: { height: 100, width: 38.5, ratio: 0.385 },
//     Ł: { height: 100, width: 50.8046875, ratio: 0.508046875 },
//     ļ: { height: 100, width: 20.6015625, ratio: 0.206015625 },
//     '*': { height: 100, width: 29.203125, ratio: 0.29203125 },
//     ' ': { height: 0, width: 0, ratio: null },
//     ż: { height: 100, width: 39.90625, ratio: 0.3990625 },
//     Ž: { height: 100, width: 62.703125, ratio: 0.62703125 },
//     Ū: { height: 100, width: 77.6015625, ratio: 0.776015625 },
//     '—': { height: 100, width: 60, ratio: 0.6 },
//     '÷': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     ų: { height: 100, width: 40.1015625, ratio: 0.401015625 },
//     Ų: { height: 100, width: 77.6015625, ratio: 0.776015625 },
//     '’': { height: 100, width: 22.203125, ratio: 0.22203125 },
//     '‚': { height: 100, width: 24.3046875, ratio: 0.243046875 },
//     '>': { height: 100, width: 49.5, ratio: 0.495 },
//     '<': { height: 100, width: 48.90625, ratio: 0.4890625 },
//     Ŕ: { height: 100, width: 72.5, ratio: 0.725 },
//     '&nbsp;': { height: 100, width: 30, ratio: 0.3 },
//   },
//   'Sub.ttf': {
//     '0': { height: 100, width: 53.6640625, ratio: 0.536640625 },
//     '1': { height: 100, width: 53.5703125, ratio: 0.535703125 },
//     '2': { height: 100, width: 69.046875, ratio: 0.69046875 },
//     '3': { height: 100, width: 58.5, ratio: 0.585 },
//     '4': { height: 100, width: 50.4921875, ratio: 0.504921875 },
//     '5': { height: 100, width: 51.90625, ratio: 0.5190625 },
//     '6': { height: 100, width: 44.3359375, ratio: 0.443359375 },
//     '7': { height: 100, width: 34.9609375, ratio: 0.349609375 },
//     '8': { height: 100, width: 49.515625, ratio: 0.49515625 },
//     '9': { height: 100, width: 58.7890625, ratio: 0.587890625 },
//     '§': { height: 100, width: 50, ratio: 0.5 },
//     "'": { height: 100, width: 16.8984375, ratio: 0.168984375 },
//     '"': { height: 100, width: 32.8125, ratio: 0.328125 },
//     '+': { height: 100, width: 48.734375, ratio: 0.48734375 },
//     '!': { height: 100, width: 24.3671875, ratio: 0.243671875 },
//     '%': { height: 100, width: 68.8515625, ratio: 0.688515625 },
//     '/': { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '=': { height: 100, width: 44.2890625, ratio: 0.442890625 },
//     '(': { height: 100, width: 38.3828125, ratio: 0.383828125 },
//     ')': { height: 100, width: 38.3828125, ratio: 0.383828125 },
//     Ö: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ü: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ó: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ú: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ő: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     P: { height: 100, width: 67.578125, ratio: 0.67578125 },
//     O: { height: 100, width: 84.28125, ratio: 0.8428125 },
//     I: { height: 100, width: 52.296875, ratio: 0.52296875 },
//     U: { height: 100, width: 76.6171875, ratio: 0.766171875 },
//     Z: { height: 100, width: 75.25, ratio: 0.7525 },
//     T: { height: 100, width: 59.4765625, ratio: 0.594765625 },
//     R: { height: 100, width: 73.4375, ratio: 0.734375 },
//     E: { height: 100, width: 87.9921875, ratio: 0.879921875 },
//     W: { height: 100, width: 99.125, ratio: 0.99125 },
//     Q: { height: 100, width: 84.28125, ratio: 0.8428125 },
//     A: { height: 100, width: 72.4609375, ratio: 0.724609375 },
//     S: { height: 100, width: 65.96875, ratio: 0.6596875 },
//     D: { height: 100, width: 90.875, ratio: 0.90875 },
//     F: { height: 100, width: 62.75, ratio: 0.6275 },
//     G: { height: 100, width: 72.4609375, ratio: 0.724609375 },
//     H: { height: 100, width: 78.2265625, ratio: 0.782265625 },
//     J: { height: 100, width: 79.296875, ratio: 0.79296875 },
//     K: { height: 100, width: 80.2265625, ratio: 0.802265625 },
//     L: { height: 100, width: 93.75, ratio: 0.9375 },
//     É: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Á: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     Ű: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     _: { height: 100, width: 50, ratio: 0.5 },
//     ':': { height: 100, width: 24.7109375, ratio: 0.247109375 },
//     '?': { height: 100, width: 68.1171875, ratio: 0.681171875 },
//     M: { height: 100, width: 112.109375, ratio: 1.12109375 },
//     N: { height: 100, width: 81.109375, ratio: 0.81109375 },
//     B: { height: 100, width: 72.4609375, ratio: 0.724609375 },
//     V: { height: 100, width: 52.296875, ratio: 0.52296875 },
//     C: { height: 100, width: 68.8515625, ratio: 0.688515625 },
//     X: { height: 100, width: 96.4375, ratio: 0.964375 },
//     Y: { height: 100, width: 72.5625, ratio: 0.725625 },
//     Í: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ö: { height: 100, width: 50, ratio: 0.5 },
//     ü: { height: 100, width: 50, ratio: 0.5 },
//     ó: { height: 100, width: 50, ratio: 0.5 },
//     ú: { height: 100, width: 50, ratio: 0.5 },
//     ő: { height: 100, width: 50, ratio: 0.5 },
//     p: { height: 100, width: 40.234375, ratio: 0.40234375 },
//     o: { height: 100, width: 44.53125, ratio: 0.4453125 },
//     i: { height: 100, width: 28.1796875, ratio: 0.281796875 },
//     u: { height: 100, width: 46.9765625, ratio: 0.469765625 },
//     z: { height: 100, width: 56.109375, ratio: 0.56109375 },
//     t: { height: 100, width: 31.546875, ratio: 0.31546875 },
//     r: { height: 100, width: 38.0390625, ratio: 0.380390625 },
//     e: { height: 100, width: 38.578125, ratio: 0.38578125 },
//     w: { height: 100, width: 73.390625, ratio: 0.73390625 },
//     q: { height: 100, width: 46.09375, ratio: 0.4609375 },
//     a: { height: 100, width: 46.390625, ratio: 0.46390625 },
//     s: { height: 100, width: 21.9296875, ratio: 0.219296875 },
//     d: { height: 100, width: 52.9296875, ratio: 0.529296875 },
//     f: { height: 100, width: 30.46875, ratio: 0.3046875 },
//     g: { height: 100, width: 42.7265625, ratio: 0.427265625 },
//     h: { height: 100, width: 50.8359375, ratio: 0.508359375 },
//     j: { height: 100, width: 21.2890625, ratio: 0.212890625 },
//     k: { height: 100, width: 46.2890625, ratio: 0.462890625 },
//     l: { height: 100, width: 30.2734375, ratio: 0.302734375 },
//     é: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     á: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ű: { height: 100, width: 50, ratio: 0.5 },
//     '-': { height: 100, width: 32.71875, ratio: 0.3271875 },
//     '.': { height: 100, width: 27.203125, ratio: 0.27203125 },
//     ',': { height: 100, width: 27.203125, ratio: 0.27203125 },
//     m: { height: 100, width: 69.1953125, ratio: 0.691953125 },
//     n: { height: 100, width: 48.1953125, ratio: 0.481953125 },
//     b: { height: 100, width: 39.453125, ratio: 0.39453125 },
//     v: { height: 100, width: 39.84375, ratio: 0.3984375 },
//     c: { height: 100, width: 34.8671875, ratio: 0.348671875 },
//     x: { height: 100, width: 34.5703125, ratio: 0.345703125 },
//     y: { height: 100, width: 36.7734375, ratio: 0.367734375 },
//     í: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '¬': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '&': { height: 100, width: 68.1171875, ratio: 0.681171875 },
//     '™': { height: 100, width: 98, ratio: 0.98 },
//     '£': { height: 100, width: 50, ratio: 0.5 },
//     $: { height: 100, width: 64.5546875, ratio: 0.645546875 },
//     '‹': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '›': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '{': { height: 100, width: 38.578125, ratio: 0.38578125 },
//     '[': { height: 100, width: 43.0234375, ratio: 0.430234375 },
//     ']': { height: 100, width: 43.359375, ratio: 0.43359375 },
//     '}': { height: 100, width: 37.75, ratio: 0.3775 },
//     '≠': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     '~': { height: 100, width: 54.1015625, ratio: 0.541015625 },
//     '¨': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ļ: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ņ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '^': { height: 100, width: 49.515625, ratio: 0.49515625 },
//     ź: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '†': { height: 100, width: 50, ratio: 0.5 },
//     '¶': { height: 100, width: 45.3125, ratio: 0.453125 },
//     '€': { height: 100, width: 74.4140625, ratio: 0.744140625 },
//     ę: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '@': { height: 100, width: 98.5859375, ratio: 0.985859375 },
//     ą: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ß: { height: 100, width: 50, ratio: 0.5 },
//     '∂': { height: 100, width: 49.4140625, ratio: 0.494140625 },
//     ń: { height: 100, width: 50, ratio: 0.5 },
//     '©': { height: 100, width: 75.9765625, ratio: 0.759765625 },
//     ķ: { height: 100, width: 50, ratio: 0.5 },
//     '∆': { height: 100, width: 61.1875, ratio: 0.611875 },
//     Ż: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     '•': { height: 100, width: 35.015625, ratio: 0.35015625 },
//     '…': { height: 100, width: 100, ratio: 1 },
//     '–': { height: 100, width: 50, ratio: 0.5 },
//     ';': { height: 100, width: 24.125, ratio: 0.24125 },
//     Ķ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '”': { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '„': { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ć: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '»': { height: 100, width: 50, ratio: 0.5 },
//     '«': { height: 100, width: 50, ratio: 0.5 },
//     '|': { height: 100, width: 38.578125, ratio: 0.38578125 },
//     ŕ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ř: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '#': { height: 100, width: 85.109375, ratio: 0.85109375 },
//     ř: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ŗ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     ŗ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '°': { height: 100, width: 39.9921875, ratio: 0.399921875 },
//     ī: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ī: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ý: { height: 100, width: 50, ratio: 0.5 },
//     Ý: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     ł: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ź: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ś: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     '®': { height: 100, width: 75.9765625, ratio: 0.759765625 },
//     š: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     Ł: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ļ: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '*': { height: 100, width: 50, ratio: 0.5 },
//     ' ': { height: 0, width: 0, ratio: null },
//     ż: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     Ž: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ū: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '—': { height: 100, width: 100, ratio: 1 },
//     '÷': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     ų: { height: 100, width: 50, ratio: 0.5 },
//     Ų: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '’': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '‚': { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '>': { height: 100, width: 60.546875, ratio: 0.60546875 },
//     '<': { height: 100, width: 47.7109375, ratio: 0.477109375 },
//     Ŕ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '&nbsp;': { height: 100, width: 24.8046875, ratio: 0.248046875 },
//   },
//   'Tag.ttf': {
//     '0': { height: 100, width: 76.859375, ratio: 0.76859375 },
//     '1': { height: 100, width: 32.9609375, ratio: 0.329609375 },
//     '2': { height: 100, width: 79.203125, ratio: 0.79203125 },
//     '3': { height: 100, width: 59.8671875, ratio: 0.598671875 },
//     '4': { height: 100, width: 80.078125, ratio: 0.80078125 },
//     '5': { height: 100, width: 64.75, ratio: 0.6475 },
//     '6': { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '7': { height: 100, width: 64.6015625, ratio: 0.646015625 },
//     '8': { height: 100, width: 65.7265625, ratio: 0.657265625 },
//     '9': { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '§': { height: 100, width: 77.6875, ratio: 0.776875 },
//     "'": { height: 100, width: 12.2109375, ratio: 0.122109375 },
//     '"': { height: 100, width: 19.7265625, ratio: 0.197265625 },
//     '+': { height: 100, width: 36.625, ratio: 0.36625 },
//     '!': { height: 100, width: 26.125, ratio: 0.26125 },
//     '%': { height: 100, width: 58.0078125, ratio: 0.580078125 },
//     '/': { height: 100, width: 48.828125, ratio: 0.48828125 },
//     '=': { height: 100, width: 36.625, ratio: 0.36625 },
//     '(': { height: 100, width: 34.375, ratio: 0.34375 },
//     ')': { height: 100, width: 34.375, ratio: 0.34375 },
//     Ö: { height: 100, width: 77.34375, ratio: 0.7734375 },
//     Ü: { height: 100, width: 99.3203125, ratio: 0.993203125 },
//     Ó: { height: 100, width: 77.34375, ratio: 0.7734375 },
//     Ú: { height: 100, width: 99.3203125, ratio: 0.993203125 },
//     Ő: { height: 100, width: 77.34375, ratio: 0.7734375 },
//     P: { height: 100, width: 93.4140625, ratio: 0.934140625 },
//     O: { height: 100, width: 77.34375, ratio: 0.7734375 },
//     I: { height: 100, width: 63.4765625, ratio: 0.634765625 },
//     U: { height: 100, width: 99.3203125, ratio: 0.993203125 },
//     Z: { height: 100, width: 91.0703125, ratio: 0.910703125 },
//     T: { height: 100, width: 87.75, ratio: 0.8775 },
//     R: { height: 100, width: 101.2265625, ratio: 1.012265625 },
//     E: { height: 100, width: 82.9140625, ratio: 0.829140625 },
//     W: { height: 100, width: 139.2109375, ratio: 1.392109375 },
//     Q: { height: 100, width: 85.40625, ratio: 0.8540625 },
//     A: { height: 100, width: 105.71875, ratio: 1.0571875 },
//     S: { height: 100, width: 82.0859375, ratio: 0.820859375 },
//     D: { height: 100, width: 102.25, ratio: 1.0225 },
//     F: { height: 100, width: 108.203125, ratio: 1.08203125 },
//     G: { height: 100, width: 86.671875, ratio: 0.86671875 },
//     H: { height: 100, width: 118.4140625, ratio: 1.184140625 },
//     J: { height: 100, width: 56.5, ratio: 0.565 },
//     K: { height: 100, width: 115.3828125, ratio: 1.153828125 },
//     L: { height: 100, width: 90.140625, ratio: 0.90140625 },
//     É: { height: 100, width: 82.9140625, ratio: 0.829140625 },
//     Á: { height: 100, width: 105.71875, ratio: 1.0571875 },
//     Ű: { height: 100, width: 99.3203125, ratio: 0.993203125 },
//     _: { height: 100, width: 30.2734375, ratio: 0.302734375 },
//     ':': { height: 100, width: 22.8515625, ratio: 0.228515625 },
//     '?': { height: 100, width: 77.5390625, ratio: 0.775390625 },
//     M: { height: 100, width: 132.9140625, ratio: 1.329140625 },
//     N: { height: 100, width: 112.796875, ratio: 1.12796875 },
//     B: { height: 100, width: 115.1875, ratio: 1.151875 },
//     V: { height: 100, width: 103.46875, ratio: 1.0346875 },
//     C: { height: 100, width: 84.9140625, ratio: 0.849140625 },
//     X: { height: 100, width: 98.1953125, ratio: 0.981953125 },
//     Y: { height: 100, width: 101.3671875, ratio: 1.013671875 },
//     Í: { height: 100, width: 63.4765625, ratio: 0.634765625 },
//     ö: { height: 100, width: 31.59375, ratio: 0.3159375 },
//     ü: { height: 100, width: 35.015625, ratio: 0.35015625 },
//     ó: { height: 100, width: 31.59375, ratio: 0.3159375 },
//     ú: { height: 100, width: 35.015625, ratio: 0.35015625 },
//     ő: { height: 100, width: 31.59375, ratio: 0.3159375 },
//     p: { height: 100, width: 35.3046875, ratio: 0.353046875 },
//     o: { height: 100, width: 31.59375, ratio: 0.3159375 },
//     i: { height: 100, width: 21, ratio: 0.21 },
//     u: { height: 100, width: 35.015625, ratio: 0.35015625 },
//     z: { height: 100, width: 35.890625, ratio: 0.35890625 },
//     t: { height: 100, width: 23.34375, ratio: 0.2334375 },
//     r: { height: 100, width: 30.328125, ratio: 0.30328125 },
//     e: { height: 100, width: 25.5390625, ratio: 0.255390625 },
//     w: { height: 100, width: 46.34375, ratio: 0.4634375 },
//     q: { height: 100, width: 30.421875, ratio: 0.30421875 },
//     a: { height: 100, width: 34.375, ratio: 0.34375 },
//     s: { height: 100, width: 25.390625, ratio: 0.25390625 },
//     d: { height: 100, width: 36.5234375, ratio: 0.365234375 },
//     f: { height: 100, width: 22.21875, ratio: 0.2221875 },
//     g: { height: 100, width: 30.421875, ratio: 0.30421875 },
//     h: { height: 100, width: 37.5546875, ratio: 0.375546875 },
//     j: { height: 100, width: 16.6015625, ratio: 0.166015625 },
//     k: { height: 100, width: 34.9140625, ratio: 0.349140625 },
//     l: { height: 100, width: 24.46875, ratio: 0.2446875 },
//     é: { height: 100, width: 25.5390625, ratio: 0.255390625 },
//     á: { height: 100, width: 34.375, ratio: 0.34375 },
//     ű: { height: 100, width: 35.015625, ratio: 0.35015625 },
//     '-': { height: 100, width: 36.625, ratio: 0.36625 },
//     '.': { height: 100, width: 17.96875, ratio: 0.1796875 },
//     ',': { height: 100, width: 17.96875, ratio: 0.1796875 },
//     m: { height: 100, width: 63.921875, ratio: 0.63921875 },
//     n: { height: 100, width: 44.484375, ratio: 0.44484375 },
//     b: { height: 100, width: 37.84375, ratio: 0.3784375 },
//     v: { height: 100, width: 33.109375, ratio: 0.33109375 },
//     c: { height: 100, width: 28.6171875, ratio: 0.286171875 },
//     x: { height: 100, width: 36.7734375, ratio: 0.367734375 },
//     y: { height: 100, width: 30.71875, ratio: 0.3071875 },
//     í: { height: 100, width: 21, ratio: 0.21 },
//     '¬': { height: 100, width: 36.625, ratio: 0.36625 },
//     '&': { height: 100, width: 54.296875, ratio: 0.54296875 },
//     '™': { height: 100, width: 52.5390625, ratio: 0.525390625 },
//     '£': { height: 100, width: 47.4140625, ratio: 0.474140625 },
//     $: { height: 100, width: 49.7109375, ratio: 0.497109375 },
//     '‹': { height: 100, width: 29.203125, ratio: 0.29203125 },
//     '›': { height: 100, width: 29.203125, ratio: 0.29203125 },
//     '{': { height: 100, width: 40.7734375, ratio: 0.407734375 },
//     '[': { height: 100, width: 34.4296875, ratio: 0.344296875 },
//     ']': { height: 100, width: 34.4296875, ratio: 0.344296875 },
//     '}': { height: 100, width: 40.7734375, ratio: 0.407734375 },
//     '≠': { height: 100, width: 36.625, ratio: 0.36625 },
//     '~': { height: 100, width: 36.625, ratio: 0.36625 },
//     '¨': { height: 100, width: 24.4140625, ratio: 0.244140625 },
//     Ļ: { height: 100, width: 90.140625, ratio: 0.90140625 },
//     Ņ: { height: 100, width: 112.796875, ratio: 1.12796875 },
//     '^': { height: 100, width: 30.5703125, ratio: 0.305703125 },
//     ź: { height: 100, width: 35.890625, ratio: 0.35890625 },
//     '†': { height: 100, width: 36.625, ratio: 0.36625 },
//     '¶': { height: 100, width: 72.265625, ratio: 0.72265625 },
//     '€': { height: 100, width: 53.46875, ratio: 0.5346875 },
//     ę: { height: 100, width: 25.5390625, ratio: 0.255390625 },
//     '@': { height: 100, width: 67.875, ratio: 0.67875 },
//     ą: { height: 100, width: 34.375, ratio: 0.34375 },
//     ß: { height: 100, width: 33.109375, ratio: 0.33109375 },
//     '∂': { height: 100, width: 39.5078125, ratio: 0.395078125 },
//     ń: { height: 100, width: 44.484375, ratio: 0.44484375 },
//     '©': { height: 100, width: 77.984375, ratio: 0.77984375 },
//     ķ: { height: 100, width: 34.9140625, ratio: 0.349140625 },
//     '∆': { height: 100, width: 61.1875, ratio: 0.611875 },
//     Ż: { height: 100, width: 91.0703125, ratio: 0.910703125 },
//     '•': { height: 100, width: 24.4140625, ratio: 0.244140625 },
//     '…': { height: 100, width: 53.90625, ratio: 0.5390625 },
//     '–': { height: 100, width: 50, ratio: 0.5 },
//     ';': { height: 100, width: 22.8515625, ratio: 0.228515625 },
//     Ķ: { height: 100, width: 115.3828125, ratio: 1.153828125 },
//     '”': { height: 100, width: 24.2734375, ratio: 0.242734375 },
//     '„': { height: 100, width: 24.2734375, ratio: 0.242734375 },
//     ć: { height: 100, width: 28.6171875, ratio: 0.286171875 },
//     '»': { height: 100, width: 43.8515625, ratio: 0.438515625 },
//     '«': { height: 100, width: 43.8515625, ratio: 0.438515625 },
//     '|': { height: 100, width: 24.4140625, ratio: 0.244140625 },
//     ŕ: { height: 100, width: 30.328125, ratio: 0.30328125 },
//     Ř: { height: 100, width: 101.2265625, ratio: 1.012265625 },
//     '#': { height: 100, width: 33.890625, ratio: 0.33890625 },
//     ř: { height: 100, width: 30.328125, ratio: 0.30328125 },
//     Ŗ: { height: 100, width: 101.2265625, ratio: 1.012265625 },
//     ŗ: { height: 100, width: 30.328125, ratio: 0.30328125 },
//     '°': { height: 100, width: 16.9921875, ratio: 0.169921875 },
//     ī: { height: 100, width: 21, ratio: 0.21 },
//     Ī: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ý: { height: 100, width: 30.71875, ratio: 0.3071875 },
//     Ý: { height: 100, width: 101.3671875, ratio: 1.013671875 },
//     ł: { height: 100, width: 24.46875, ratio: 0.2446875 },
//     Ź: { height: 100, width: 91.0703125, ratio: 0.910703125 },
//     ś: { height: 100, width: 25.390625, ratio: 0.25390625 },
//     '®': { height: 100, width: 49.125, ratio: 0.49125 },
//     š: { height: 100, width: 25.390625, ratio: 0.25390625 },
//     Ł: { height: 100, width: 90.140625, ratio: 0.90140625 },
//     ļ: { height: 100, width: 24.46875, ratio: 0.2446875 },
//     '*': { height: 100, width: 28.03125, ratio: 0.2803125 },
//     ' ': { height: 0, width: 0, ratio: null },
//     ż: { height: 100, width: 35.890625, ratio: 0.35890625 },
//     Ž: { height: 100, width: 91.0703125, ratio: 0.910703125 },
//     Ū: { height: 100, width: 99.3203125, ratio: 0.993203125 },
//     '—': { height: 100, width: 100, ratio: 1 },
//     '÷': { height: 100, width: 36.625, ratio: 0.36625 },
//     ų: { height: 100, width: 35.015625, ratio: 0.35015625 },
//     Ų: { height: 100, width: 99.3203125, ratio: 0.993203125 },
//     '’': { height: 100, width: 15.96875, ratio: 0.1596875 },
//     '‚': { height: 100, width: 15.875, ratio: 0.15875 },
//     '>': { height: 100, width: 36.625, ratio: 0.36625 },
//     '<': { height: 100, width: 36.625, ratio: 0.36625 },
//     Ŕ: { height: 100, width: 101.2265625, ratio: 1.012265625 },
//     '&nbsp;': { height: 100, width: 21.9765625, ratio: 0.219765625 },
//   },
//   'Tweet.ttf': {
//     '0': { height: 100, width: 35.90625, ratio: 0.3590625 },
//     '1': { height: 100, width: 27.3046875, ratio: 0.273046875 },
//     '2': { height: 100, width: 41, ratio: 0.41 },
//     '3': { height: 100, width: 37.90625, ratio: 0.3790625 },
//     '4': { height: 100, width: 35.90625, ratio: 0.3590625 },
//     '5': { height: 100, width: 37.90625, ratio: 0.3790625 },
//     '6': { height: 100, width: 34.40625, ratio: 0.3440625 },
//     '7': { height: 100, width: 32.5, ratio: 0.325 },
//     '8': { height: 100, width: 34, ratio: 0.34 },
//     '9': { height: 100, width: 32.40625, ratio: 0.3240625 },
//     '§': { height: 100, width: 50, ratio: 0.5 },
//     "'": { height: 100, width: 15.203125, ratio: 0.15203125 },
//     '"': { height: 100, width: 17.40625, ratio: 0.1740625 },
//     '+': { height: 100, width: 30.1015625, ratio: 0.301015625 },
//     '!': { height: 100, width: 13.3046875, ratio: 0.133046875 },
//     '%': { height: 100, width: 38.1015625, ratio: 0.381015625 },
//     '/': { height: 100, width: 21.1015625, ratio: 0.211015625 },
//     '=': { height: 100, width: 40.203125, ratio: 0.40203125 },
//     '(': { height: 100, width: 18.703125, ratio: 0.18703125 },
//     ')': { height: 100, width: 16.90625, ratio: 0.1690625 },
//     Ö: { height: 100, width: 65.5, ratio: 0.655 },
//     Ü: { height: 100, width: 60.90625, ratio: 0.6090625 },
//     Ó: { height: 100, width: 65.5, ratio: 0.655 },
//     Ú: { height: 100, width: 60.90625, ratio: 0.6090625 },
//     Ő: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     P: { height: 100, width: 67.6015625, ratio: 0.676015625 },
//     O: { height: 100, width: 65.5, ratio: 0.655 },
//     I: { height: 100, width: 56.6015625, ratio: 0.566015625 },
//     U: { height: 100, width: 60.90625, ratio: 0.6090625 },
//     Z: { height: 100, width: 51.203125, ratio: 0.51203125 },
//     T: { height: 100, width: 36.703125, ratio: 0.36703125 },
//     R: { height: 100, width: 75.40625, ratio: 0.7540625 },
//     E: { height: 100, width: 57.90625, ratio: 0.5790625 },
//     W: { height: 100, width: 72.8046875, ratio: 0.728046875 },
//     Q: { height: 100, width: 65.6015625, ratio: 0.656015625 },
//     A: { height: 100, width: 79, ratio: 0.79 },
//     S: { height: 100, width: 54.703125, ratio: 0.54703125 },
//     D: { height: 100, width: 58.40625, ratio: 0.5840625 },
//     F: { height: 100, width: 40.6015625, ratio: 0.406015625 },
//     G: { height: 100, width: 63.3046875, ratio: 0.633046875 },
//     H: { height: 100, width: 62.90625, ratio: 0.6290625 },
//     J: { height: 100, width: 50.40625, ratio: 0.5040625 },
//     K: { height: 100, width: 44.5, ratio: 0.445 },
//     L: { height: 100, width: 31.8046875, ratio: 0.318046875 },
//     É: { height: 100, width: 57.90625, ratio: 0.5790625 },
//     Á: { height: 100, width: 79, ratio: 0.79 },
//     Ű: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     _: { height: 100, width: 57.5, ratio: 0.575 },
//     ':': { height: 100, width: 21.40625, ratio: 0.2140625 },
//     '?': { height: 100, width: 27, ratio: 0.27 },
//     M: { height: 100, width: 79.703125, ratio: 0.79703125 },
//     N: { height: 100, width: 69.5, ratio: 0.695 },
//     B: { height: 100, width: 62.8046875, ratio: 0.628046875 },
//     V: { height: 100, width: 49.6015625, ratio: 0.496015625 },
//     C: { height: 100, width: 55.5, ratio: 0.555 },
//     X: { height: 100, width: 57.1015625, ratio: 0.571015625 },
//     Y: { height: 100, width: 53.203125, ratio: 0.53203125 },
//     Í: { height: 100, width: 56.6015625, ratio: 0.566015625 },
//     ö: { height: 100, width: 22.203125, ratio: 0.22203125 },
//     ü: { height: 100, width: 33.6015625, ratio: 0.336015625 },
//     ó: { height: 100, width: 22.203125, ratio: 0.22203125 },
//     ú: { height: 100, width: 33.6015625, ratio: 0.336015625 },
//     ő: { height: 100, width: 50, ratio: 0.5 },
//     p: { height: 100, width: 32.40625, ratio: 0.3240625 },
//     o: { height: 100, width: 22.203125, ratio: 0.22203125 },
//     i: { height: 100, width: 22.203125, ratio: 0.22203125 },
//     u: { height: 100, width: 33.6015625, ratio: 0.336015625 },
//     z: { height: 100, width: 33.6015625, ratio: 0.336015625 },
//     t: { height: 100, width: 27.703125, ratio: 0.27703125 },
//     r: { height: 100, width: 19.5, ratio: 0.195 },
//     e: { height: 100, width: 22.5, ratio: 0.225 },
//     w: { height: 100, width: 40.203125, ratio: 0.40203125 },
//     q: { height: 100, width: 18.703125, ratio: 0.18703125 },
//     a: { height: 100, width: 29.3046875, ratio: 0.293046875 },
//     s: { height: 100, width: 23.8046875, ratio: 0.238046875 },
//     d: { height: 100, width: 30.90625, ratio: 0.3090625 },
//     f: { height: 100, width: 22.703125, ratio: 0.22703125 },
//     g: { height: 100, width: 21.8046875, ratio: 0.218046875 },
//     h: { height: 100, width: 30.5, ratio: 0.305 },
//     j: { height: 100, width: 10.1015625, ratio: 0.101015625 },
//     k: { height: 100, width: 31.703125, ratio: 0.31703125 },
//     l: { height: 100, width: 19.5, ratio: 0.195 },
//     é: { height: 100, width: 22.5, ratio: 0.225 },
//     á: { height: 100, width: 29.3046875, ratio: 0.293046875 },
//     ű: { height: 100, width: 50, ratio: 0.5 },
//     '-': { height: 100, width: 28.90625, ratio: 0.2890625 },
//     '.': { height: 100, width: 16.40625, ratio: 0.1640625 },
//     ',': { height: 100, width: 7.8046875, ratio: 0.078046875 },
//     m: { height: 100, width: 38.3046875, ratio: 0.383046875 },
//     n: { height: 100, width: 28.90625, ratio: 0.2890625 },
//     b: { height: 100, width: 26.6015625, ratio: 0.266015625 },
//     v: { height: 100, width: 26.6015625, ratio: 0.266015625 },
//     c: { height: 100, width: 18.703125, ratio: 0.18703125 },
//     x: { height: 100, width: 32.8046875, ratio: 0.328046875 },
//     y: { height: 100, width: 23.1015625, ratio: 0.231015625 },
//     í: { height: 100, width: 22.203125, ratio: 0.22203125 },
//     '¬': { height: 100, width: 56.3984375, ratio: 0.563984375 },
//     '&': { height: 100, width: 48.5, ratio: 0.485 },
//     '™': { height: 100, width: 98, ratio: 0.98 },
//     '£': { height: 100, width: 43.6015625, ratio: 0.436015625 },
//     $: { height: 100, width: 39.5, ratio: 0.395 },
//     '‹': { height: 100, width: 25.40625, ratio: 0.2540625 },
//     '›': { height: 100, width: 27.40625, ratio: 0.2740625 },
//     '{': { height: 100, width: 161.6015625, ratio: 1.616015625 },
//     '[': { height: 100, width: 218.40625, ratio: 2.1840625 },
//     ']': { height: 100, width: 124, ratio: 1.24 },
//     '}': { height: 100, width: 98.8046875, ratio: 0.988046875 },
//     '≠': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     '~': { height: 100, width: 21.703125, ratio: 0.21703125 },
//     '¨': { height: 100, width: 18.90625, ratio: 0.1890625 },
//     Ļ: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ņ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '^': { height: 100, width: 20.203125, ratio: 0.20203125 },
//     ź: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '†': { height: 100, width: 50, ratio: 0.5 },
//     '¶': { height: 100, width: 45.3125, ratio: 0.453125 },
//     '€': { height: 100, width: 35.5, ratio: 0.355 },
//     ę: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '@': { height: 100, width: 44.6015625, ratio: 0.446015625 },
//     ą: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ß: { height: 100, width: 21.90625, ratio: 0.2190625 },
//     '∂': { height: 100, width: 49.4140625, ratio: 0.494140625 },
//     ń: { height: 100, width: 50, ratio: 0.5 },
//     '©': { height: 100, width: 32.5, ratio: 0.325 },
//     ķ: { height: 100, width: 50, ratio: 0.5 },
//     '∆': { height: 100, width: 61.1875, ratio: 0.611875 },
//     Ż: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     '•': { height: 100, width: 16.40625, ratio: 0.1640625 },
//     '…': { height: 100, width: 100, ratio: 1 },
//     '–': { height: 100, width: 28.90625, ratio: 0.2890625 },
//     ';': { height: 100, width: 21.40625, ratio: 0.2140625 },
//     Ķ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '”': { height: 100, width: 17.40625, ratio: 0.1740625 },
//     '„': { height: 100, width: 26.1015625, ratio: 0.261015625 },
//     ć: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '»': { height: 100, width: 50, ratio: 0.5 },
//     '«': { height: 100, width: 50, ratio: 0.5 },
//     '|': { height: 100, width: 19.8046875, ratio: 0.198046875 },
//     ŕ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ř: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '#': { height: 100, width: 32.40625, ratio: 0.3240625 },
//     ř: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ŗ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     ŗ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '°': { height: 100, width: 17.6015625, ratio: 0.176015625 },
//     ī: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ī: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ý: { height: 100, width: 19.90625, ratio: 0.1990625 },
//     Ý: { height: 100, width: 53.203125, ratio: 0.53203125 },
//     ł: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ź: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ś: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     '®': { height: 100, width: 75.9765625, ratio: 0.759765625 },
//     š: { height: 100, width: 25, ratio: 0.25 },
//     Ł: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ļ: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '*': { height: 100, width: 21.203125, ratio: 0.21203125 },
//     ' ': { height: 0, width: 0, ratio: null },
//     ż: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     Ž: { height: 100, width: 51.203125, ratio: 0.51203125 },
//     Ū: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '—': { height: 100, width: 57.5, ratio: 0.575 },
//     '÷': { height: 100, width: 38.1015625, ratio: 0.381015625 },
//     ų: { height: 100, width: 50, ratio: 0.5 },
//     Ų: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '’': { height: 100, width: 15.203125, ratio: 0.15203125 },
//     '‚': { height: 100, width: 15.203125, ratio: 0.15203125 },
//     '>': { height: 100, width: 27.40625, ratio: 0.2740625 },
//     '<': { height: 100, width: 25.40625, ratio: 0.2540625 },
//     Ŕ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '&nbsp;': { height: 100, width: 27, ratio: 0.27 },
//   },
//   'Viral.ttf': {
//     '0': { height: 100, width: 91.40625, ratio: 0.9140625 },
//     '1': { height: 100, width: 32.8046875, ratio: 0.328046875 },
//     '2': { height: 100, width: 88.203125, ratio: 0.88203125 },
//     '3': { height: 100, width: 88.8046875, ratio: 0.888046875 },
//     '4': { height: 100, width: 88.40625, ratio: 0.8840625 },
//     '5': { height: 100, width: 88.8046875, ratio: 0.888046875 },
//     '6': { height: 100, width: 91.5, ratio: 0.915 },
//     '7': { height: 100, width: 88.203125, ratio: 0.88203125 },
//     '8': { height: 100, width: 88.203125, ratio: 0.88203125 },
//     '9': { height: 100, width: 88.203125, ratio: 0.88203125 },
//     '§': { height: 100, width: 50, ratio: 0.5 },
//     "'": { height: 100, width: 19.6015625, ratio: 0.196015625 },
//     '"': { height: 100, width: 34, ratio: 0.34 },
//     '+': { height: 100, width: 88.40625, ratio: 0.8840625 },
//     '!': { height: 100, width: 19.6015625, ratio: 0.196015625 },
//     '%': { height: 100, width: 142.8046875, ratio: 1.428046875 },
//     '/': { height: 100, width: 39.6015625, ratio: 0.396015625 },
//     '=': { height: 100, width: 88.3046875, ratio: 0.883046875 },
//     '(': { height: 100, width: 34.5, ratio: 0.345 },
//     ')': { height: 100, width: 34.5, ratio: 0.345 },
//     Ö: { height: 100, width: 91.40625, ratio: 0.9140625 },
//     Ü: { height: 100, width: 91.40625, ratio: 0.9140625 },
//     Ó: { height: 100, width: 91.40625, ratio: 0.9140625 },
//     Ú: { height: 100, width: 91.40625, ratio: 0.9140625 },
//     Ő: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     P: { height: 100, width: 88.203125, ratio: 0.88203125 },
//     O: { height: 100, width: 91.40625, ratio: 0.9140625 },
//     I: { height: 100, width: 19.6015625, ratio: 0.196015625 },
//     U: { height: 100, width: 91.40625, ratio: 0.9140625 },
//     Z: { height: 100, width: 90.5, ratio: 0.905 },
//     T: { height: 100, width: 88.40625, ratio: 0.8840625 },
//     R: { height: 100, width: 88.203125, ratio: 0.88203125 },
//     E: { height: 100, width: 90.5, ratio: 0.905 },
//     W: { height: 100, width: 101.203125, ratio: 1.01203125 },
//     Q: { height: 100, width: 91.40625, ratio: 0.9140625 },
//     A: { height: 100, width: 81.6015625, ratio: 0.816015625 },
//     S: { height: 100, width: 91.8046875, ratio: 0.918046875 },
//     D: { height: 100, width: 91.5, ratio: 0.915 },
//     F: { height: 100, width: 90.5, ratio: 0.905 },
//     G: { height: 100, width: 91.5, ratio: 0.915 },
//     H: { height: 100, width: 88.3046875, ratio: 0.883046875 },
//     J: { height: 100, width: 90.8046875, ratio: 0.908046875 },
//     K: { height: 100, width: 88.203125, ratio: 0.88203125 },
//     L: { height: 100, width: 88.203125, ratio: 0.88203125 },
//     É: { height: 100, width: 90.5, ratio: 0.905 },
//     Á: { height: 100, width: 81.6015625, ratio: 0.816015625 },
//     Ű: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     _: { height: 100, width: 0, ratio: 0 },
//     ':': { height: 100, width: 22.40625, ratio: 0.2240625 },
//     '?': { height: 100, width: 82.203125, ratio: 0.82203125 },
//     M: { height: 100, width: 94.40625, ratio: 0.9440625 },
//     N: { height: 100, width: 87.703125, ratio: 0.87703125 },
//     B: { height: 100, width: 88.203125, ratio: 0.88203125 },
//     V: { height: 100, width: 81.6015625, ratio: 0.816015625 },
//     C: { height: 100, width: 91.5, ratio: 0.915 },
//     X: { height: 100, width: 90.40625, ratio: 0.9040625 },
//     Y: { height: 100, width: 90.40625, ratio: 0.9040625 },
//     Í: { height: 100, width: 19.6015625, ratio: 0.196015625 },
//     ö: { height: 100, width: 91.40625, ratio: 0.9140625 },
//     ü: { height: 100, width: 91.40625, ratio: 0.9140625 },
//     ó: { height: 100, width: 91.40625, ratio: 0.9140625 },
//     ú: { height: 100, width: 91.40625, ratio: 0.9140625 },
//     ő: { height: 100, width: 50, ratio: 0.5 },
//     p: { height: 100, width: 88.203125, ratio: 0.88203125 },
//     o: { height: 100, width: 91.40625, ratio: 0.9140625 },
//     i: { height: 100, width: 19.6015625, ratio: 0.196015625 },
//     u: { height: 100, width: 91.40625, ratio: 0.9140625 },
//     z: { height: 100, width: 90.5, ratio: 0.905 },
//     t: { height: 100, width: 88.40625, ratio: 0.8840625 },
//     r: { height: 100, width: 88.203125, ratio: 0.88203125 },
//     e: { height: 100, width: 90.5, ratio: 0.905 },
//     w: { height: 100, width: 101.203125, ratio: 1.01203125 },
//     q: { height: 100, width: 91.40625, ratio: 0.9140625 },
//     a: { height: 100, width: 81.6015625, ratio: 0.816015625 },
//     s: { height: 100, width: 91.8046875, ratio: 0.918046875 },
//     d: { height: 100, width: 91.5, ratio: 0.915 },
//     f: { height: 100, width: 90.5, ratio: 0.905 },
//     g: { height: 100, width: 91.5, ratio: 0.915 },
//     h: { height: 100, width: 88.3046875, ratio: 0.883046875 },
//     j: { height: 100, width: 90.8046875, ratio: 0.908046875 },
//     k: { height: 100, width: 88.203125, ratio: 0.88203125 },
//     l: { height: 100, width: 88.203125, ratio: 0.88203125 },
//     é: { height: 100, width: 90.5, ratio: 0.905 },
//     á: { height: 100, width: 81.6015625, ratio: 0.816015625 },
//     ű: { height: 100, width: 50, ratio: 0.5 },
//     '-': { height: 100, width: 49.203125, ratio: 0.49203125 },
//     '.': { height: 100, width: 22.40625, ratio: 0.2240625 },
//     ',': { height: 100, width: 19.6015625, ratio: 0.196015625 },
//     m: { height: 100, width: 94.40625, ratio: 0.9440625 },
//     n: { height: 100, width: 87.703125, ratio: 0.87703125 },
//     b: { height: 100, width: 88.203125, ratio: 0.88203125 },
//     v: { height: 100, width: 81.6015625, ratio: 0.816015625 },
//     c: { height: 100, width: 91.5, ratio: 0.915 },
//     x: { height: 100, width: 90.40625, ratio: 0.9040625 },
//     y: { height: 100, width: 90.40625, ratio: 0.9040625 },
//     í: { height: 100, width: 19.6015625, ratio: 0.196015625 },
//     '¬': { height: 100, width: 55.703125, ratio: 0.55703125 },
//     '&': { height: 100, width: 85.5, ratio: 0.855 },
//     '™': { height: 100, width: 74.6015625, ratio: 0.746015625 },
//     '£': { height: 100, width: 88.40625, ratio: 0.8840625 },
//     $: { height: 100, width: 91.8046875, ratio: 0.918046875 },
//     '‹': { height: 100, width: 26.40625, ratio: 0.2640625 },
//     '›': { height: 100, width: 26.40625, ratio: 0.2640625 },
//     '{': { height: 100, width: 422.1015625, ratio: 4.221015625 },
//     '[': { height: 100, width: 81.6015625, ratio: 0.816015625 },
//     ']': { height: 100, width: 81.6015625, ratio: 0.816015625 },
//     '}': { height: 100, width: 419.6015625, ratio: 4.196015625 },
//     '≠': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     '~': { height: 100, width: 0, ratio: 0 },
//     '¨': { height: 100, width: 44, ratio: 0.44 },
//     Ļ: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ņ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '^': { height: 100, width: 50.3046875, ratio: 0.503046875 },
//     ź: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '†': { height: 100, width: 50, ratio: 0.5 },
//     '¶': { height: 100, width: 34, ratio: 0.34 },
//     '€': { height: 100, width: 90.5, ratio: 0.905 },
//     ę: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '@': { height: 100, width: 100.5, ratio: 1.005 },
//     ą: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     ß: { height: 100, width: 176.1015625, ratio: 1.761015625 },
//     '∂': { height: 100, width: 49.4140625, ratio: 0.494140625 },
//     ń: { height: 100, width: 50, ratio: 0.5 },
//     '©': { height: 100, width: 91.40625, ratio: 0.9140625 },
//     ķ: { height: 100, width: 50, ratio: 0.5 },
//     '∆': { height: 100, width: 61.1875, ratio: 0.611875 },
//     Ż: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     '•': { height: 100, width: 29.203125, ratio: 0.29203125 },
//     '…': { height: 100, width: 77.203125, ratio: 0.77203125 },
//     '–': { height: 100, width: 88.3046875, ratio: 0.883046875 },
//     ';': { height: 100, width: 22.40625, ratio: 0.2240625 },
//     Ķ: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '”': { height: 100, width: 35.3046875, ratio: 0.353046875 },
//     '„': { height: 100, width: 35.3046875, ratio: 0.353046875 },
//     ć: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     '»': { height: 100, width: 49.203125, ratio: 0.49203125 },
//     '«': { height: 100, width: 49.203125, ratio: 0.49203125 },
//     '|': { height: 100, width: 91.5, ratio: 0.915 },
//     ŕ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ř: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '#': { height: 100, width: 88.40625, ratio: 0.8840625 },
//     ř: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     Ŗ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     ŗ: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     '°': { height: 100, width: 39.9921875, ratio: 0.399921875 },
//     ī: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ī: { height: 100, width: 33.3046875, ratio: 0.333046875 },
//     ý: { height: 100, width: 90.40625, ratio: 0.9040625 },
//     Ý: { height: 100, width: 90.40625, ratio: 0.9040625 },
//     ł: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     Ź: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ś: { height: 100, width: 38.921875, ratio: 0.38921875 },
//     '®': { height: 100, width: 91.40625, ratio: 0.9140625 },
//     š: { height: 100, width: 91.8046875, ratio: 0.918046875 },
//     Ł: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     ļ: { height: 100, width: 27.7890625, ratio: 0.277890625 },
//     '*': { height: 100, width: 54, ratio: 0.54 },
//     ' ': { height: 0, width: 0, ratio: null },
//     ż: { height: 100, width: 44.390625, ratio: 0.44390625 },
//     Ž: { height: 100, width: 61.0859375, ratio: 0.610859375 },
//     Ū: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '—': { height: 100, width: 108.3046875, ratio: 1.083046875 },
//     '÷': { height: 100, width: 54.8828125, ratio: 0.548828125 },
//     ų: { height: 100, width: 50, ratio: 0.5 },
//     Ų: { height: 100, width: 72.21875, ratio: 0.7221875 },
//     '’': { height: 100, width: 19.6015625, ratio: 0.196015625 },
//     '‚': { height: 100, width: 19.6015625, ratio: 0.196015625 },
//     '>': { height: 100, width: 53.6015625, ratio: 0.536015625 },
//     '<': { height: 100, width: 53.6015625, ratio: 0.536015625 },
//     Ŕ: { height: 100, width: 66.703125, ratio: 0.66703125 },
//     '&nbsp;': { height: 100, width: 45, ratio: 0.45 },
//   },
// };

// [
//   {
//     type: 'paragraph',
//     children: [
//       {
//         text: 'Your text',
//         family: 'Plaything.ttf',
//       },
//     ],
//   },
//   {
//     type: 'paragraph',
//     children: [
//       {
//         text: 'asdf',
//         family: 'Plaything.ttf',
//       },
//     ],
//   },
// ];
export const getDimensions = (letterWidth: number, lineHeight: number, value: any) => {
  const widths = value
    .filter(({ children }: any) => children?.[0]?.text?.length > 0)
    .map(({ children }: any) => {
      const width = children
        .map(({ text, family }: any) => {
          // const dimensions = (fontDimensions as any)[family || 'MoonTime.ttf'];
          return text.trim().length * letterWidth;
          // return (
          //   text
          //     .split('')
          //     // .map((font: string) => dimensions[font.replace(' ', '&nbsp;')].ratio)
          //     .reduce((sum: number, w: number) => sum + letterWidth, 0)
          // );
        })
        .reduce((sum: number, w: number) => sum + w, 0);
      return width;
    });

  // const heights = value
  //   .filter(({ children }: any) => children?.[0]?.text?.length > 0)
  //   .map(({ children }: any) => {
  //     const height = Math.max(
  //       ...children.map(({ text, family }: any) => {
  //         const dimensions = (fontDimensions as any)[family || 'MoonTime.ttf'];
  //         return Math.max(
  //           ...text
  //             .split('')
  //             .map((font: string) => (dimensions[font.replace(' ', '&nbsp;')].height * letterHeight) / 100),
  //         );
  //       }),
  //     );

  //     return height;
  //   });

  // const height =
  //   Math.floor(heights.reduce((sum: number, h: number) => sum + h, 0)) + lineHeight * Math.max(0, heights.length - 1);
  // const height =
  //   letterHeight * value.filter(({ children }: any) => children?.[0]?.text?.length > 0).length + lineHeight;
  return { width: Math.max(...widths), height: 0 };
};
